<template>
  <div class="sketchpad" :class="teacher_full_status ? 'sketchpad-full' : ''">
    <!-- 畫板頭部 -->
    <transition name="el-fade-in">
      <div
        class="sketchpad-head"
        v-show="
          !teacher_full_status || (teacher_full_status && fullRightTopShow)
        "
        @mouseover="fullRightTopMouseover"
        @mouseleave="fullRightTopMouseleave"
        @touchstart.stop="fullRightTopTouchShow"
      >
        <div class="sketchpad-head-left" v-show="!teacher_full_status">
          <!--<p>Practical English</p>-->
          <span v-if="MaterialFileName">{{ MaterialName }}</span>
          <img
            v-if="MaterialFileName"
            src="@/assets/image/icon-right.png"
            alt=""
          />
          <span v-if="MaterialUnit">{{ MaterialUnit }}</span>
          <img v-if="MaterialUnit" src="@/assets/image/icon-right.png" alt="" />
          <span v-if="MaterialUnitPage">{{ MaterialUnitPage }}</span>
          <img
            v-if="MaterialUnitPage"
            src="@/assets/image/icon-right.png"
            alt=""
          />
          <span v-if="MaterialName">{{ MaterialFileName }}</span>
        </div>
        <div class="sketchpad-head-right">
          <div @click="shieldChange()">
            <img
              v-if="student_drawing_permissions"
              src="@/assets/image/icon-shield-open.png"
              style="filter: hue-rotate(85deg)"
              alt=""
            />
            <img
              v-if="!student_drawing_permissions"
              src="@/assets/image/icon-shield-clost.png"
              alt=""
            />
          </div>
          <div @click="addClick()" :style="{ 'pointer-events': isAddingPage ? 'none' : 'auto', opacity: isAddingPage ? '0.5' : '1' }">
            <img src="@/assets/image/icon-add.png" alt="" />
          </div>
        </div>
      </div>
    </transition>
    <!-- 畫板內容 -->
    <div class="sketchpad-box">
      <transition name="el-zoom-in-center">
        <div
          class="sketchpad-box-left"
          v-show="!teacher_full_status || (teacher_full_status && fullLeftShow)"
          @mouseover="fullLeftMouseover"
          @mouseleave="fullLeftMouseleave"
          @touchstart.stop="fullLeftTouchShow"
        >
          <!-- 游標 -->
          <div
            class="left-box"
            :class="toolCursorStatus ? 'tool-btns' : 'tool-btn'"
            @click="
              toolStatusChange('toolCursorStatus');
              whiteboardSwitch($event);
            "
            tool="mouse"
            ref="toolCursorDiv"
          >
            <img
              v-if="!toolCursorStatus"
              src="@/assets/image/icon-tool1-close.png"
              alt=""
            />
            <img
              v-if="toolCursorStatus"
              src="@/assets/image/icon-tool1-open.png"
              alt=""
            />
          </div>
          <!-- 文字 -->
          <div
            class="left-box"
            :class="toolTextStatus ? 'tool-btns' : 'tool-btn'"
            @click="
              toolStatusChange('toolTextStatus');
              whiteboardSwitch($event);
            "
            tool="text"
          >
            <img
              v-if="!toolTextStatus"
              src="@/assets/image/icon-tool2-close.png"
              alt=""
            />
            <img
              v-if="toolTextStatus"
              src="@/assets/image/icon-tool2-open.png"
              alt=""
            />
          </div>
          <!-- 隨意畫 -->
          <div class="left-box">
            <el-popover
              placement="right"
              trigger="hover"
              popper-class="sketchpad-popover"
            >
              <div
                class="box-div"
                @mouseover="fullLeftMouseover"
                @mouseleave="fullLeftMouseleave"
              >
                <div
                  :class="toolRandomCheck == 1 ? 'tool-btns' : 'tool-btn'"
                  @click="
                    toolCheckChange('toolRandomCheck', 1, $event);
                    whiteboardSwitch($event);
                    toolStatusChange('toolRandomStatus', $event);
                  "
                  tool="pen"
                  id="draw-pen"
                >
                  <img
                    v-if="toolRandomCheck == 1"
                    src="@/assets/image/icon-tool3-open.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="@/assets/image/icon-tool3-close.png"
                    alt=""
                  />
                </div>
                <div
                  :class="toolRandomCheck == 2 ? 'tool-btns' : 'tool-btn'"
                  @click="
                    toolCheckChange('toolRandomCheck', 2, $event);
                    whiteboardSwitch($event);
                    toolStatusChange('toolRandomStatus', $event);
                  "
                  tool="line"
                  id="draw-line"
                >
                  <img
                    v-if="toolRandomCheck == 2"
                    src="@/assets/image/icon-tool4-open.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="@/assets/image/icon-tool4-close.png"
                    alt=""
                  />
                </div>
                <div
                  :class="toolRandomCheck == 3 ? 'tool-btns' : 'tool-btn'"
                  @click="
                    toolCheckChange('toolRandomCheck', 3, $event);
                    whiteboardSwitch($event);
                    toolStatusChange('toolRandomStatus', $event);
                  "
                  tool="arrow"
                  id="draw-arrow"
                >
                  <img
                    v-if="toolRandomCheck == 3"
                    src="@/assets/image/icon-tool5-open.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="@/assets/image/icon-tool5-close.png"
                    alt=""
                  />
                </div>
              </div>
              <div
                slot="reference"
                :class="toolRandomStatus ? 'tool-btns' : 'tool-btn'"
                @click="toolStatusChange('toolRandomStatus', $event)"
              >
                <img
                  v-if="!toolRandomStatus && toolRandomCheck == 1"
                  src="@/assets/image/icon-tool3-close.png"
                  alt=""
                />
                <img
                  v-if="!toolRandomStatus && toolRandomCheck == 2"
                  src="@/assets/image/icon-tool4-close.png"
                  alt=""
                />
                <img
                  v-if="!toolRandomStatus && toolRandomCheck == 3"
                  src="@/assets/image/icon-tool5-close.png"
                  alt=""
                />
                <img
                  v-if="toolRandomStatus && toolRandomCheck == 1"
                  src="@/assets/image/icon-tool3-open.png"
                  alt=""
                />
                <img
                  v-if="toolRandomStatus && toolRandomCheck == 2"
                  src="@/assets/image/icon-tool4-open.png"
                  alt=""
                />
                <img
                  v-if="toolRandomStatus && toolRandomCheck == 3"
                  src="@/assets/image/icon-tool5-open.png"
                  alt=""
                />
              </div>
            </el-popover>
          </div>
          <!-- 字體粗細 -->
          <div class="left-box">
            <el-popover
              placement="right"
              trigger="hover"
              popper-class="sketchpad-popover"
            >
              <div
                class="box-div"
                @mouseover="fullLeftMouseover"
                @mouseleave="fullLeftMouseleave"
              >
                <div>
                  <div id="thicknessSlide">
                    <input
                      title="Thickness"
                      id="whiteboardThicknessSlider"
                      style="
                        position: absolute;
                        left: 9px;
                        width: 130px;
                        height: 20px;
                      "
                      type="range"
                      min="1"
                      max="50"
                      value="3"
                      @input="whiteboardThicknessSlider($event)"
                    />
                  </div>
                  <div @click="thicknessSlide()">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 354"
                    >
                      <g id="圖層_2" data-name="圖層 2">
                        <g id="Capa_1" data-name="Capa 1">
                          <rect x="1" y="117" width="511" height="60" />
                          <rect width="512" height="40" />
                          <rect x="1" y="254" width="511" height="100" />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div
                slot="reference"
                :class="toolFontWeightStatus ? 'tool-btns' : 'tool-btn'"
                @click="toolStatusChange('toolFontWeightStatus')"
              >
                <img
                  v-if="!toolFontWeightStatus"
                  src="@/assets/image/icon-tool6-close.png"
                  alt=""
                />
                <img
                  v-if="toolFontWeightStatus"
                  src="@/assets/image/icon-tool6-open.png"
                  alt=""
                />
              </div>
            </el-popover>
          </div>
          <!-- 形狀 -->
          <div class="left-box">
            <el-popover
              placement="right"
              trigger="hover"
              popper-class="sketchpad-popover"
            >
              <div
                class="box-div"
                @mouseover="fullLeftMouseover"
                @mouseleave="fullLeftMouseleave"
              >
                <div
                  :class="toolshapeCheck == 1 ? 'tool-btns' : 'tool-btn'"
                  @click="
                    toolCheckChange('toolshapeCheck', 1, $event);
                    whiteboardSwitch($event);
                    toolStatusChange('toolshapeStatus', $event);
                  "
                  tool="rect"
                  id="shape-rect"
                >
                  <img
                    v-if="toolshapeCheck == 1"
                    src="@/assets/image/icon-tool7-open.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="@/assets/image/icon-tool7-close.png"
                    alt=""
                  />
                </div>
                <div
                  :class="toolshapeCheck == 2 ? 'tool-btns' : 'tool-btn'"
                  @click="
                    toolCheckChange('toolshapeCheck', 2, $event);
                    whiteboardSwitch($event);
                    toolStatusChange('toolshapeStatus', $event);
                  "
                  tool="circle"
                  id="shape-circle"
                >
                  <img
                    v-if="toolshapeCheck == 2"
                    src="@/assets/image/icon-tool8-open.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="@/assets/image/icon-tool8-close.png"
                    alt=""
                  />
                </div>
                <!-- <div
                  :class="toolshapeCheck == 4 ? 'tool-btns' : 'tool-btn'"
                  @click="
                    toolCheckChange('toolshapeCheck', 4, $event);
                    whiteboardSwitch($event);
                    toolStatusChange('toolshapeStatus', $event);
                  "
                  tool="ellipse"
                  id="shape-ellipse"
                >
                  <img
                    v-if="toolshapeCheck == 4"
                    src="@/assets/image/icon-tool10-open.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="@/assets/image/icon-tool10-close.png"
                    alt=""
                  />
                </div> -->
                <div
                  :class="toolshapeCheck == 3 ? 'tool-btns' : 'tool-btn'"
                  @click="
                    toolCheckChange('toolshapeCheck', 3, $event);
                    whiteboardSwitch($event);
                    toolStatusChange('toolshapeStatus', $event);
                  "
                  tool="triangle"
                  id="shape-triangle"
                >
                  <img
                    v-if="toolshapeCheck == 3"
                    src="@/assets/image/icon-tool9-open.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="@/assets/image/icon-tool9-close.png"
                    alt=""
                  />
                </div>
              </div>
              <div
                slot="reference"
                :class="toolshapeStatus ? 'tool-btns' : 'tool-btn'"
                @click="toolStatusChange('toolshapeStatus', $event)"
              >
                <img
                  v-if="!toolshapeStatus && toolshapeCheck == 1"
                  src="@/assets/image/icon-tool7-close.png"
                  alt=""
                />
                <img
                  v-if="!toolshapeStatus && toolshapeCheck == 2"
                  src="@/assets/image/icon-tool8-close.png"
                  alt=""
                />
                <img
                  v-if="!toolshapeStatus && toolshapeCheck == 3"
                  src="@/assets/image/icon-tool9-close.png"
                  alt=""
                />
                <img
                  v-if="!toolshapeStatus && toolshapeCheck == 4"
                  src="@/assets/image/icon-tool10-close.png"
                  alt=""
                />
                <img
                  v-if="toolshapeStatus && toolshapeCheck == 1"
                  src="@/assets/image/icon-tool7-open.png"
                  alt=""
                />
                <img
                  v-if="toolshapeStatus && toolshapeCheck == 2"
                  src="@/assets/image/icon-tool8-open.png"
                  alt=""
                />
                <img
                  v-if="toolshapeStatus && toolshapeCheck == 3"
                  src="@/assets/image/icon-tool9-open.png"
                  alt=""
                />
                <img
                  v-if="toolshapeStatus && toolshapeCheck == 4"
                  src="@/assets/image/icon-tool10-open.png"
                  alt=""
                />
              </div>
            </el-popover>
          </div>
          <!-- 放大 -->
          <div
            class="left-box"
            :class="toolzoomStatus ? 'tool-btns' : 'tool-btn'"
            @click="
              toolStatusChange('toolzoomStatus');
              setZoom(0.05);
            "
          >
            <img
              v-if="!toolzoomStatus"
              src="@/assets/image/icon-tool11-close.png"
              alt=""
            />
            <img
              v-if="toolzoomStatus"
              src="@/assets/image/icon-tool11-open.png"
              alt=""
            />
          </div>
          <!-- 縮小 -->
          <div
            class="left-box"
            :class="toolshrinkStatus ? 'tool-btns' : 'tool-btn'"
            @click="
              toolStatusChange('toolshrinkStatus');
              setZoom(-0.05);
            "
          >
            <img
              v-if="!toolshrinkStatus"
              src="@/assets/image/icon-tool12-close.png"
              alt=""
            />
            <img
              v-if="toolshrinkStatus"
              src="@/assets/image/icon-tool12-open.png"
              alt=""
            />
          </div>
          <!-- 調色板 -->
          <div
            class="left-box"
            :class="toolPaletteStatus ? 'tool-btns' : 'tool-btn'"
            @click="toolStatusChange('toolPaletteStatus')"
          >
            <div id="whiteboardColorpicker" style="position: absolute"></div>
          </div>
          <!-- 物件選取 -->
          <!--<div
            class="left-box"
            :class="toolSelectStatus ? 'tool-btns' : 'tool-btn'"
            @click="
              toolStatusChange('toolSelectStatus');
              whiteboardSwitch($event);
            "
            tool="move"
          >
            <img
              v-if="!toolSelectStatus"
              src="@/assets/image/icon-tool13-close.png"
              alt=""
            />
            <img
              v-if="toolSelectStatus"
              src="@/assets/image/icon-tool13-open.png"
              alt=""
            />
          </div>-->
          <!-- 橡皮擦 -->
          <div
            class="left-box"
            :class="toolEraserStatus ? 'tool-btns' : 'tool-btn'"
            @click="
              toolStatusChange('toolEraserStatus');
              whiteboardSwitch($event);
            "
            tool="eraser"
          >
            <img
              v-if="!toolEraserStatus"
              src="@/assets/image/icon-tool14-close.png"
              alt=""
            />
            <img
              v-if="toolEraserStatus"
              src="@/assets/image/icon-tool14-open.png"
              alt=""
            />
          </div>
          <!-- 蓋章 -->
          <div class="left-box">
            <el-popover
              placement="right"
              trigger="hover"
              popper-class="sketchpad-popover"
            >
              <div
                class="box-imgList"
                @mouseover="fullLeftMouseover"
                @mouseleave="fullLeftMouseleave"
              >
                <div
                  v-for="(item, index) in stampList"
                  :key="index"
                  :class="
                    toolStampCheck == item
                      ? 'box-imgList-divs'
                      : 'box-imgList-div'
                  "
                  @click="
                    toolCheckChange('toolStampCheck', item.file);
                    handleStamps(item.name);
                  "
                >
                  <img :src="item.file" alt="" />
                </div>
              </div>
              <div
                slot="reference"
                :class="toolStampStatus ? 'tool-btns' : 'tool-btn'"
                @click="toolStatusChange('toolStampStatus')"
              >
                <img
                  v-if="!toolStampStatus"
                  src="@/assets/image/icon-tool15-close.png"
                  alt=""
                />
                <img
                  v-if="toolStampStatus"
                  src="@/assets/image/icon-tool15-open.png"
                  alt=""
                />
              </div>
            </el-popover>
          </div>
        </div>
      </transition>
      <div class="sketchpad-box-right">
        <div class="sketchpad-box-right-head">
          <div
            class="sketchpad-box-right-head"
            ref="whiteboardContainer"
            id="whiteboardContainer"
            style="
              position: relative;
              overflow: auto;
              height: 100%;
              width: 100%;
            "
          >
            <Loading
              v-show="loadingMedia"
              id="loadingMedia"
              style="display: none; width: 100%; height: 100%"
            ></Loading>
          </div>
          <div
            class="custom-scrollbar-horizontal"
            ref="customScrollbarHorizontal"
            :style="{
              width: scrollbarWidth + 'px',
              top: teacher_full_status ? '0px' : 'auto',
            }"
            @mousedown.prevent
          >
            <div
              class="scrollbar-thumb-horizontal"
              ref="scrollbarThumbHorizontal"
              :style="{ left: thumbLeft + 'px', width: thumbWidth + 'px' }"
              @mousedown.prevent="startHorizontalDrag"
            ></div>
          </div>
          <div
            class="custom-scrollbar"
            ref="customScrollbar"
            :style="{ height: scrollbarHeight + 'px' }"
            @mousedown.prevent
          >
            <div
              class="scrollbar-thumb"
              ref="scrollbarThumb"
              :style="{ top: thumbTop + 'px', height: thumbHeight + 'px' }"
              @mousedown.prevent="startDrag"
            ></div>
          </div>
        </div>
        <div class="sketchpad-box-right-foo" v-show="!teacher_full_status">
          <div class="foo-left">
            <div
              id="frontPage"
              class="foo-left-box"
              @click="pageChange('frontPage')"
            >
              <img
                v-if="!frontPageStatus"
                src="@/assets/image/icon-retreat-open.png"
                alt=""
              />
              <img
                v-if="frontPageStatus"
                src="@/assets/image/icon-retreat-dis.png"
                alt=""
              />
            </div>
            <div
              id="previousPage"
              class="foo-left-box"
              @click="pageChange('previousPage')"
            >
              <img
                v-if="!previousPageStatus"
                src="@/assets/image/icon-upon-open.png"
                alt=""
              />
              <img
                v-if="previousPageStatus"
                src="@/assets/image/icon-upon-dis.png"
                alt=""
              />
            </div>
            <div class="foo-left-div">
              {{ mediaProgressNum }} / {{ mediaLengthNum }}
            </div>
            <div
              id="nextPage"
              class="foo-left-box"
              @click="pageChange('nextPage')"
            >
              <img
                v-if="!nextPageStatus"
                src="@/assets/image/icon-down-open.png"
                alt=""
              />
              <img
                v-if="nextPageStatus"
                src="@/assets/image/icon-down-dis.png"
                alt=""
              />
            </div>
            <div
              id="lastPage"
              class="foo-left-box"
              @click="pageChange('lastPage')"
            >
              <img
                v-if="!lastPageStatus"
                src="@/assets/image/icon-onward-open.png"
                alt=""
              />
              <img
                v-if="lastPageStatus"
                src="@/assets/image/icon-onward-dis.png"
                alt=""
              />
            </div>
            <div class="foo-left-music">
              <img src="@/assets/image/icon-music-open.png" alt="" />
            </div>
            <div class="foo-left-select">
              <!-- <el-select v-model="fileSelectCheck" value-key="id" @change="fileSelectChange($event)"
                placeholder="Select audios or videos.">
                <el-option-group v-for="group in fileSelectList" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.list" :key="item.id" :label="item.label" :value="item"
                    no-data-text="無數據" loading-text="載入中" @change="fileSelectType(item)">
                  </el-option>
                </el-option-group>
              </el-select> -->
              <el-select
                class="materialObject"
                v-model="fileSelectCheck"
                value-key="FileUrl"
                @change="fileSelectChange"
                placeholder="Select audios or videos."
                ref="selectComponent"
                :disabled="mediaPlayStatus || isShowVideoModal"
              >
                <el-option-group
                  v-for="group in fileSelectList"
                  :key="group.label"
                >
                  <template #label>
                    <img
                      src="@/assets/image/stampList/icon_001_b_r.png"
                      alt="Group Image"
                      style="width: 100px; height: auto"
                    />
                  </template>
                  <el-option
                    v-for="(materialData, index) in group.list"
                    :key="index"
                    :value="materialData"
                    :label="materialData.FileName"
                    no-data-text="無數據"
                    loading-text="載入中"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
              <div class="foo-left-select-div">
                <img src="@/assets/image/icon-select.png" alt="" />
              </div>
            </div>
          </div>
          <div class="foo-right">
            <div class="foo-media" v-show="mediaShow">
              <div class="media-wrapper">
                <audio
                  ref="audio"
                  id="main_audio"
                  preload="none"
                  playsinline
                  style="width: 100%"
                  :src="mediaSelected"
                >
                  <source :src="mediaSelected" type="audio/mp3" />
                </audio>
              </div>
              <!-- <div
                class="foo-media-btn"
                v-if="fileSelectCheck.FileType != 'audio/mp3'"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#hi_popup_video"
                id="button_hi_popup_video"
                @click="showVideoDialogSocket()"
                ref="popupButton"
              ></div> -->
              <div
                class="foo-media-btn"
                v-if="fileSelectCheck.FileType != 'audio/mp3'"
                type="button"
                id="button_hi_popup_video"
                @click="showVideoDialogSocket()"
                ref="popupButton"
              >
                <img src="@/assets/image/icon-play-open.png" alt="" />
              </div>
              <div
                v-if="fileSelectCheck.FileType === 'audio/mp3'"
                class="foo-media-btn"
                @click="playChange(mediaPlayStatus ? 'pause' : 'play')"
              >
                <img
                  v-if="!mediaPlayStatus"
                  src="@/assets/image/icon-play-open.png"
                  alt=""
                />
                <img
                  v-if="mediaPlayStatus"
                  src="@/assets/image/icon-pause-open.png"
                  alt=""
                />
              </div>
              <div
                id="media-stop-btn"
                class="foo-media-btn disabled"
                @click="playChange('stop')"
              >
                <img
                  v-if="mediaStopStatus"
                  src="@/assets/image/icon-stop-open.png"
                  alt=""
                />
                <img
                  v-if="!mediaStopStatus"
                  src="@/assets/image/icon-stop-dis.png"
                  alt=""
                />
              </div>
              <div class="foo-media-time">
                {{ formatTime(mediaCurrentDuration) }}
              </div>
              <div class="foo-media-slider">
                <el-slider
                  v-model="mediaSlider"
                  :show-tooltip="false"
                  @change="inputTimeUpdate"
                  @mousedown.native="handleSliderTouchStart"
                  @touchstart.native="handleSliderTouchStart"
                  @mouseup.native="handleSliderTouchEnd"
                  @touchend.native="handleSliderTouchEnd"
                  @mouseup="handleSliderMouseUp"
                ></el-slider>
              </div>
              <div class="foo-media-time">
                {{ formatTime(mediaTotalDuration) }}
              </div>
            </div>
            <div class="foo-volume" v-show="volumeShow">
              <!-- 大屏幕橫向展示 -->
              <div class="volume-btn" @click="volumeClick">
                <img
                  v-if="!volumeStatus"
                  src="@/assets/image/icon-volume-open.png"
                  alt=""
                />
                <img
                  v-if="volumeStatus"
                  src="@/assets/image/icon-volume-close.png"
                  alt=""
                />
              </div>
              <div class="volume-slider">
                <el-slider
                  v-model="volumeSlider"
                  :show-tooltip="false"
                  @change="volumeChange"
                ></el-slider>
              </div>
              <!-- 小屏幕豎向展示 -->
              <div class="volume-btn volume-btn-show" @click="volumeClick">
                <el-popover
                  placement="top"
                  trigger="hover"
                  popper-class="sketchpad-popovers"
                >
                  <el-slider
                    height="80px"
                    vertical
                    v-model="volumeSlider"
                    @change="volumeChange"
                  ></el-slider>
                  <img
                    v-if="!volumeStatus"
                    slot="reference"
                    src="@/assets/image/icon-volume-open.png"
                    alt=""
                  />
                  <img
                    v-if="volumeStatus"
                    slot="reference"
                    src="@/assets/image/icon-volume-close.png"
                    alt=""
                  />
                </el-popover>
              </div>
            </div>
            <div class="foo-full" @click="fullChange">
              <img src="@/assets/image/icon-full-open.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 全屏模式的音頻操作 -->
    <transition name="el-zoom-in-bottom">
      <div
        class="sketchpad-box-right-bottom"
        v-show="teacher_full_status && fullBottomShow"
        @mouseover="fullBottomMouseover"
        @mouseleave="fullBottomMouseleave"
        @touchstart.stop="fullBottomTouchShow"
      >
        <div class="bottom-slider">
          <el-slider
            v-model="mediaSlider"
            v-if="mediaShow"
            :show-tooltip="false"
            @change="mediaChange"
          ></el-slider>
        </div>
        <div class="bottom-box">
          <div class="bottom-box-left">
            <!-- <div class="media-wrapper">
                <audio
                  ref="audio"
                  id="main_audio"
                  preload="none"
                  style="width: 100%"
                  :src="mediaSelected"
                  @play="onAudioPlay"
                  @pause="onAudioPause"
                  @volumechange="handleVolumeChange"
                >
                  <source :src="mediaSelected" type="audio/mp3" />
                </audio>
              </div> -->
            <div
              class="bottom-media-btn"
              v-if="mediaShow"
              @click="playChange(mediaPlayStatus ? 'pause' : 'play')"
            >
              <img
                v-if="!mediaPlayStatus"
                src="@/assets/image/icon-play-open.png"
                alt=""
              />
              <img
                v-if="mediaPlayStatus"
                src="@/assets/image/icon-pause-open.png"
                alt=""
              />
            </div>
            <div
              class="bottom-media-btn"
              v-if="mediaShow"
              @click="playChange('stop')"
            >
              <img
                v-if="!mediaStopStatus"
                src="@/assets/image/icon-stop-open.png"
                alt=""
              />
              <img
                v-if="mediaStopStatus"
                src="@/assets/image/icon-stop-dis.png"
                alt=""
              />
            </div>
            <div class="bottom-media-time" v-if="mediaShow">
              {{ formatTime(mediaCurrentDuration) }} /
              {{ formatTime(mediaTotalDuration) }}
            </div>
            <div
              class="bottom-media-btn pageChange"
              @click="pageChange('previousPage')"
            >
              <img
                v-if="!previousPageStatus"
                class="img1"
                src="@/assets/image/icon-upon-open.png"
                alt=""
              />
              <img
                v-if="previousPageStatus"
                class="img1"
                src="@/assets/image/icon-upon-dis.png"
                alt=""
              />
            </div>
            <div
              class="bottom-media-btn pageChange"
              @click="pageChange('nextPage')"
            >
              <img
                v-if="!nextPageStatus"
                class="img1"
                src="@/assets/image/icon-down-open.png"
                alt=""
              />
              <img
                v-if="nextPageStatus"
                class="img1"
                src="@/assets/image/icon-down-dis.png"
                alt=""
              />
            </div>
            <div class="bottom-media-music">
              <img src="@/assets/image/icon-music-open.png" alt="" />
            </div>
            <div class="bottom-media-select">
              <el-select
                v-model="fileSelectCheck"
                value-key="FileUrl"
                @change="fileSelectChange"
                placeholder="Select audios or videos."
                ref="selectComponent"
                :popper-append-to-body="false"
              >
                <el-option-group
                  v-for="group in fileSelectList"
                  :key="group.label"
                >
                  <template #label>
                    <img
                      src="@/assets/image/stampList/icon_001_b_r.png"
                      alt="Group Image"
                      style="width: 100px; height: auto"
                    />
                  </template>
                  <el-option
                    v-for="(materialData, index) in group.list"
                    :key="index"
                    :value="materialData"
                    :label="materialData.FileName"
                    no-data-text="無數據"
                    loading-text="載入中"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
              <div class="bottom-media-select-div">
                <img src="@/assets/image/icon-select.png" alt="" />
              </div>
            </div>
          </div>
          <div class="bottom-box-right">
            <div
              class="bottom-media-volume"
              v-if="volumeShow"
              @click="volumeClick"
            >
              <img
                v-if="!volumeStatus"
                src="@/assets/image/icon-volume-open.png"
                alt=""
              />
              <img
                v-if="volumeStatus"
                src="@/assets/image/icon-volume-close.png"
                alt=""
              />
            </div>
            <div class="bottom-media-slider" v-if="volumeShow">
              <el-slider
                v-model="volumeSlider"
                :show-tooltip="false"
                @change="volumeChange"
              ></el-slider>
            </div>
            <div class="bottom-media-btn" @click="fullChange">
              <img src="@/assets/image/icon-full-close.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 全屏模式下 鼠標滑上觸發展示塊 -->
    <div
      class="sketchpad-full-left"
      @mouseover="fullLeftMouseover"
      @mouseleave="fullLeftMouseleave"
      @touchstart.stop="fullLeftTouchShow"
    ></div>
    <div
      class="sketchpad-full-rightTop"
      @mouseover="fullRightTopMouseover"
      @mouseleave="fullRightTopMouseleave"
      @touchstart.stop="fullRightTopTouchShow"
    ></div>
    <div class="sketchpad-full-bottom" @mouseover="fullBottomMouseover" @touchstart.stop="fullBottomTouchShow"></div>

    <!-- Modal-Video -->
    <transition
      name="el-zoom-in-bottom"
      appear
      appear-active-class="el-zoom-in-bottom-appear-active"
      appear-from-class="el-zoom-in-bottom-appear-from"
      appear-to-class="el-zoom-in-bottom-appear-to"
    >
      <div
        class="video-container blur"
        id="hi_popup_video"
        @mouseover="videoMouseOver"
        @mouseleave="videoMouseleave"
        v-show="isShowVideoModal"
      >
        <div class="content">
          <div class="video-content" id="video-content">
            <div class="video-header" v-show="videoBottomShow">
              <h5 class="video-title">
                {{ mediaVideoNameSelected }}
              </h5>
              <button
                type="button"
                class="btn-close"
                aria-label="Close"
                @click="closeVideoDialogSocket"
              ></button>
            </div>
            <video
              width="100%"
              height="100%"
              :key="mediaVedioSelected"
              ref="video"
              @loadedmetadata="setDuration"
              @ended="closeVideoDialogSocket"
              preload="metadata"
              playsinline
            >
              <source :src="mediaVedioSelected" type="video/mp4" />
              <!-- <source
                  src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
                  type="video/mp4"
                /> -->
              Your browser does not support the video tag.
            </video>
            <div
              class="video-footer"
              id="video-footer"
              v-show="videoBottomShow"
            >
              <div class="bottom-slider">
                <el-slider
                  v-model="currentTimeVideo"
                  :show-tooltip="false"
                  :max="duration"
                  @change="changeCurrentTime"
                ></el-slider>
              </div>
              <div class="bottom-box">
                <div class="bottom-box-left">
                  <div
                    class="bottom-media-btn video-control"
                    @click="playVideo"
                  >
                    <img
                      v-if="isPlay"
                      src="@/assets/image/icon-play-dis.png"
                      alt=""
                    />
                    <img
                      v-if="!isPlay"
                      src="@/assets/image/icon-play-open.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="bottom-media-btn video-control"
                    @click="pauseVideo"
                  >
                    <img
                      v-if="!isPlay"
                      src="@/assets/image/icon-stop-dis.png"
                      alt=""
                    />
                    <img
                      v-if="isPlay"
                      src="@/assets/image/icon-stop-open.png"
                      alt=""
                    />
                  </div>
                  <div class="bottom-media-time">
                    {{ formatTime(currentTimeVideo) }} /
                    {{ formatTime(duration) }}
                  </div>
                </div>
                <div class="bottom-box-right">
                  <div class="bottom-media-volume" @click="toggleMute">
                    <img
                      v-if="!isMuted"
                      src="@/assets/image/icon-volume-open.png"
                      alt=""
                    />
                    <img
                      v-if="isMuted"
                      src="@/assets/image/icon-volume-close.png"
                      alt=""
                    />
                  </div>
                  <div class="bottom-media-slider">
                    <el-slider
                      v-model="volume"
                      :show-tooltip="false"
                      @change="changeVolume"
                      :min="0"
                      :max="1"
                      :step="0.01"
                    ></el-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { uuid } from "vue-uuid";
import axios from "axios";
import moment from "moment";
import { io } from "socket.io-client";
import whiteboard from "../../../jswb/whiteboard";
import keybinds from "../../../jswb/keybinds";
import Picker from "vanilla-picker";
// import { dom } from "@fortawesome/fontawesome-svg-core";
import shortcutFunctions from "../../../jswb/shortcutFunctions";
import ReadOnlyService from "../../../jswb/services/ReadOnlyService";
import InfoService from "../../../jswb/services/InfoService";
import { getSubDir } from "../../../jswb/utils";
import ConfigService from "../../../jswb/services/ConfigService";
import { v4 as uuidv4 } from "uuid";
import { throttle, debounce } from "lodash";
import Loading from "../components/Loading.vue";
import Notification from "../../../static/components/Notification.vue";
import NotificationUpload from "../../../static/components/NotificationUpload.vue";
import NotificationMaterialUpload from "../../../static/components/NotificationMaterialObject.vue";
import { isNumber } from "lodash";
const urlParams = new URLSearchParams(window.location.search);
let whiteboardId = urlParams.get("whiteboardid");
const randomid = urlParams.get("randomid");
let colorPickerOnOpen = function (current_color) {
  this._domPalette = $(".picker_palette", this.domElement);
  const palette = JSON.parse(localStorage.getItem("savedColors"));
  if ($(".picker_splotch", this._domPalette).length === 0) {
    for (let i = 0; i < palette.length; i++) {
      let palette_Color_obj = new this.color.constructor(palette[i]);
      let splotch_div = $(
        '<div style="position:relative;"><span position="' +
          i +
          '" class="removeColor" style="position:absolute; cursor:pointer; right:-1px; top:-4px;">x</span></div>'
      )
        .addClass("picker_splotch")
        .attr({
          id: "s" + i,
        })
        .css("background-color", palette_Color_obj.hslaString)
        .on("click", { that: this, obj: palette_Color_obj }, function (e) {
          e.data.that._setColor(e.data.obj.hslaString);
        });
      splotch_div.find(".removeColor").on("click", function (e) {
        e.preventDefault();
        $(this).parent("div").remove();
        palette.splice(i, 1);
        localStorage.setItem("savedColors", JSON.stringify(palette));
      });
      this._domPalette.append(splotch_div);
    }
  }
};
const colorPickerTemplate = `
        <div class="picker_wrapper" tabindex="-1">
          <div class="picker_arrow"></div>
          <div class="picker_hue picker_slider">
            <div class="picker_selector"></div>
          </div>
          <div class="picker_sl">
            <div class="picker_selector"></div>
          </div>
          <div class="picker_alpha picker_slider">
            <div class="picker_selector"></div>
          </div>
          <div class="picker_palette"></div>
          <div class="picker_editor">
            <input aria-label="Type a color name or hex value"/>
          </div>
          <div class="picker_sample"></div>
          <div class="picker_done">
            <button>Ok</button>
          </div>
          <div class="picker_cancel">
            <button>Cancel</button>
          </div>
        </div>
      `;
let signaling_socket;

export default {
  name: "teacher-sketchpad",
  components: {
    Loading,
  },
  props: {
    speakerDeviceId: { type: String, default: '' },
  },
  data() {
    return {
      // 音視頻下拉選
      fileSelectCheck: {},
      // 音視頻列表
      fileSelectList: [
        {
          label: "音檔",
          imgUrl: "images/icon-music-open.png",
          list: [
            // { type: 1, id: 'A1', label: 'A0001.mp3' },
            // { type: 1, id: 'A2', label: 'A0002.mp3' },
            // { type: 1, id: 'A3', label: 'A0003.mp3' },
          ],
        },
        {
          label: "影片",
          imgUrl: "images/icon-film.png",
          list: [
            // { type: 2, id: 'B1', label: 'B0001.mp4' },
            // { type: 2, id: 'B2', label: 'B0002.mp4' },
            // { type: 2, id: 'B3', label: 'B0003.mp4' },
            // { type: 2, id: 'B4', label: 'B0004.mp4' },
            // { type: 2, id: 'B5', label: 'B0005.mp4' },
          ],
        },
      ],
      // 蓋章列表
      stampList: [
        {
          file: require("@/assets/image/stampList/icon_001_b_r.png"),
          name: "icon_001_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_002_b_r.png"),
          name: "icon_002_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_003_b_r.png"),
          name: "icon_003_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_004_b_r.png"),
          name: "icon_004_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_005_b_r.png"),
          name: "icon_005_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_006_b_r.png"),
          name: "icon_006_b_r",
        },
        {
          file: require("@/assets/image/stampList/Amazing.png"),
          name: "Amazing",
        },
        {
          file: require("@/assets/image/stampList/English_Star.png"),
          name: "English_Star",
        },
        {
          file: require("@/assets/image/stampList/Excellent.png"),
          name: "Excellent",
        },
        {
          file: require("@/assets/image/stampList/Great_Work.png"),
          name: "Great_Work",
        },
        {
          file: require("@/assets/image/stampList/HomeWork.png"),
          name: "HomeWork",
        },
        {
          file: require("@/assets/image/stampList/Improving.png"),
          name: "Improving",
        },
        {
          file: require("@/assets/image/stampList/Keep_Up.png"),
          name: "Keep_Up",
        },
        {
          file: require("@/assets/image/stampList/Outstanding.png"),
          name: "Outstanding",
        },
        {
          file: require("@/assets/image/stampList/Progressed.png"),
          name: "Progressed",
        },
        {
          file: require("@/assets/image/stampList/Remember.png"),
          name: "Remember",
        },
        {
          file: require("@/assets/image/stampList/Terrific.png"),
          name: "Terrific",
        },
        {
          file: require("@/assets/image/stampList/Very_Good.png"),
          name: "Very_Good",
        },
        {
          file: require("@/assets/image/stampList/Well_Done.png"),
          name: "Well_Done",
        },
      ],
      // 工具欄選中狀態-游標
      toolCursorStatus: false,
      // 工具欄選中狀態-文字
      toolTextStatus: false,
      // 工具欄選中狀態-隨意畫
      toolRandomStatus: false,
      toolRandomCheck: 1,
      // 工具欄選中狀態-字體粗細
      toolFontWeightStatus: false,
      // 工具欄選中狀態-形狀
      toolshapeStatus: false,
      toolshapeCheck: 1,
      // 工具欄選中狀態-放大
      toolzoomStatus: false,
      // 工具欄選中狀態-縮小
      toolshrinkStatus: false,
      // 工具欄選中狀態-調色板
      toolPaletteStatus: false,
      paletteBackground: "#0000",
      // 工具欄選中狀態-物件選取
      toolSelectStatus: false,
      // 工具欄選中狀態-橡皮擦
      toolEraserStatus: false,
      // 工具欄選中狀態-蓋章
      toolStampStatus: false,
      toolStampCheck: "",

      // 媒體-當前進度
      mediaProgressNum: 1,
      // 媒體-總長度
      mediaLengthNum: 10,
      // 媒體切換-最前頁
      frontPageStatus: false,
      // 媒體切換-上一頁
      previousPageStatus: false,
      // 媒體切換-下一頁
      nextPageStatus: false,
      // 媒體切換-最后頁
      lastPageStatus: false,
      pageFull: false,

      // 媒體操作-顯示狀態
      mediaShow: true,
      // 媒體播放-暫停
      mediaPlayStatus: false,
      // 媒體播放-停止
      mediaStopStatus: false,
      // 媒體播放-當前時長
      mediaCurrentDuration: 0,
      // 媒體播放-總時長
      mediaTotalDuration: 0,
      // 媒體時長滑塊
      mediaSlider: 0,

      // 媒體音量-顯示狀態
      volumeShow: true,
      // 媒體音量狀態
      volumeStatus: false,
      // 媒體音量滑塊
      volumeSlider: 80,

      // 全屏模式-左側工具欄顯示
      fullLeftShow: false,
      // 全屏模式-底部進度條顯示
      fullBottomShow: false,
      // 全屏模式-右上權限顯示
      fullRightTopShow: false,
      videoBottomShow: false,

      volume: 1, // initial volume
      savedVolume: null, //saved volume
      isMuted: false, // initial mute state
      isPlay: false,

      // 視頻 Web Audio API 路由（iOS 音量控制，複用 audioCtx）
      videoGainNode: null,
      videoMediaSource: null,
      currentTimeVideo: 0, // initial current time
      duration: 0, // initial duration

      LessonRecordUrl: "",
      TBUrl: "",
      taskIdRecording: "",

      visibleImage: -1,
      fabricWidth: 0,
      fabricHeight: 0,

      backgroundState: 0,
      searchKey: "",
      currentPage: 0,
      itemsPerPage: 10,
      resultCount: 0,
      theLastLastPage: 0, //for pagination (previous)
      paginationLayers: [],
      currentLayer: 0,

      initialShape: true,
      initialDraw: true,
      currentDraw: null,
      currentShape: null,

      currentTool: "mouse",

      // zoomFactor: 0,

      svgUrl: "",
      objectSelected: false,
      previousCurrentTool: "",
      currentSelectedImage: "",

      prevIndexGlobal: 0,
      currentIndexGlobal: 0,
      nextIndexGlobal: 0,
      // msg:'',
      // text: "",
      // empty: true,
      // send:true,
      colorClicked: false,
      versions: 0,
      showAudioSlider: false,
      showLineWidthSlider: false,
      showStamp: false,

      //trtc
      localStream: null,
      roomId: "",
      userId: "",
      userName: "",
      userType: "",
      remoteStream: [],
      sdkAppId: 20001292,
      // sdkAppId: 1400748574,
      client: null,
      is_teacher: false,
      remoteStreamIds: [],
      remoteStreamTIds: [],

      cameras: null,
      microphones: null,
      speakers: null,
      s_camera: "",
      s_mic: "",
      s_speaker: "",

      mediaSelected: "",
      mediaVedioSelected: "",
      mediaVideoNameSelected: "",

      isLoading: false,
      streamTeacher: null,

      streamStudents: [],

      streamStudent: null,

      isWebCamActive: false,
      isAudioActive: false,
      isSpeakerActive: false,

      isWebCamActiveRemote: [],
      isAudioActiveRemote: [],

      // volume: 100,

      timeData: 30,

      input: {
        year: 0,
        month: 0,
        day: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },

      interval: 1,

      liveChatItems: [],
      isCheckAll: false,

      stateTime: true,
      currentTime: Date.now(),
      intervalTime: null,

      initialHour: 0,
      initialMin: 0,
      initialSec: 0,
      initialMilliSec: 0,

      message: "Let the countdown begin!!",
      totalTime: this.$store.state.classTime * 60,
      timerRunning: false,
      interval: null,

      MaterialMediaObjectData: [],
      MaterialVedioObjectData: [],
      MaterialObjectData: [],
      MaterialObjectDataProxy: [],

      //CanvasLib part
      canvas: null,
      colorPalette: [
        "#f38181",
        "#c9d6df",
        "#07689f",
        "#95e1d3",
        "#fce38a",
        "#ff2e63",
        "#2b2e4a",
        "#aedefc",
      ],
      drawingData: {
        color: "black",
        x: "",
        y: "",
        lineWidth: 1,
      },
      ctx: null,
      isPainting: false,

      currentTool: "",
      done: false,
      fabricObj: [],
      initIdx: 0,

      mouseFrom: {},
      mouseTo: {},
      moveCount: 1,
      doDrawing: false,
      fabricHistoryJson: [],
      mods: 0,
      drawingObject: null, //Draw Object
      drawColor: "#E34F51",
      drawWidth: 2,
      imageBase64: "",
      zoom: window.zoom ? window.zoom : 1,
      zoomIn: 1,
      zoomOut: 1,
      top: 0,
      left: 0,
      contentSizeHeight: 0,
      contentSizeWidth: 0,
      setColor: [
        "#FF0000",
        "#F2C94C",
        "#EBFF00",
        "#9B51E0",
        "#6FCF97",
        "#F2F2F2",
        "#00FFF0",
        "#33FF00",
        "#00A3FF",
        "#FF00C7",
        "#FF7A00",
        "#0075FF",
      ],

      colorInput: "#E34F51",
      distance: 100,
      // zoomValue: "100%",
      userIdz: "",
      teachername: "",
      uploadJsonData: {},
      retryJsonList: [],
      autoSaveDirty: false,
      lastSavedDrawBufferLength: 0,
      MaterialFileType: "",
      MaterialFileName: "",
      MaterialName: "",
      MaterialFileUrl: "",
      MaterialUnitPageId: "",
      MaterialUnit: "",
      MaterialUnitPage: "",
      MaterialCode: "",
      EnglishFileName: "",
      ChineseFileName: "",
      currentBackgroundImage: "",
      loadingMedia: false,

      prevMaterialFileType: "",
      prevMaterialFileName: "",
      prevMaterialName: "",
      prevMaterialFileUrl: "",
      prevMaterialUnitPageId: "",
      prevMaterialUnit: "",
      prevMaterialUnitPage: "",
      prevMaterialCode: "",

      formComments: [],
      onlineUsers: [],
      onlineUsersId: [],
      onlineUsersName: [],

      chatTextSent2: "",
      chatTextSent: "",
      fileUploads: "",
      uuid: uuid.v4(),
      fileUploadsBase64: "",

      // originZoomValue: 0,
      viewportTransform: null,
      borderRange: 1,
      volumeRange: 0.5,
      lastChatItem: 0,

      isJoin: false,
      isSS: false,

      SELECTIMGWIDTH: "",
      SELECTIMGHEIGHT: "",

      clickSaveTeacherComment: true,

      checkingTimer: null,
      nowDateTime: null,
      countdownTimerDisable: true,
      enableTimerEvery10s: true,
      showAlertCheckIn: 0,

      checkTimerData: 0,
      beginTimeStamp: 0,

      socket: {},
      socketLoaded: false,

      isShowVideoModal: false,
      isClickedByMe: false,

      imgTempId: "",
      jsonFileUrl: "",
      fileUrl: "",
      valueToChange: "",
      fileURLName: "",

      canvasWidth: 0,
      canvasHeight: 0,
      imgContainerWidth: 0,
      imgContainerHeight: 0,
      currentIndexMaterial: -1,
      content: [],
      drawFirstState: true,
      loadNewPage: false,
      CleanPage: false,
      newMaterial: [],
      newMaterialState: false,
      sequenceRestoredFromDB: false,
      isAddingPage: false,

      // 緩衝區尚未就緒時記錄待播放狀態，等 loadAudioBuffer 完成後自動播放
      pendingAudioPlay: false,
      pendingAudioOffset: 0,

      firstLoadState: true,
      originalWidth: null,
      originalHeight: null,
      student_drawing_permissions: false,
      thumbHeight: 100,
      thumbTop: 0,
      isDragging: false,
      dragStartY: 0,
      thumbStartTop: 0,
      startY: null,
      startScrollTop: 0,
      startThumbTop: 0,
      scrollbarHeight: 0,
      thumbLeft: 0,
      thumbWidth: 50,
      scrollbarWidth: 0,
      isDraggingHorizontal: false,
      startX: 0,
      startScrollLeft: 0,
      startThumbLeft: 0,

      audioCtx: null,
      audioBuffer: null,
      sourceNode: null,
      startTime: 0,
      pauseTime: 0,
      elapsedTime: 0,
      audioUrl: null,
      isPlaying: false,
      isPaused: false,
      timeUpdateRAF: null,
      isDraggingSlider: false,
      gainNode: null,
    };
  },
  computed: {
    urlForSocket() {
      return `${process.env.VUE_APP_SOCKET_URL}`;
    },
    errorLogs() {
      return this.$store.getters.errorLogs;
    },
    totalPages: function () {
      return Math.ceil(this.resultCount / this.itemsPerPage);
    },
    paginate: function () {
      if (
        !this.MaterialObjectData ||
        this.MaterialObjectData.length != this.MaterialObjectData.length
      ) {
        return;
      }
      this.resultCount = this.MaterialObjectData.length;
      if (this.currentPage >= this.totalPages) {
        this.currentPage = this.totalPages;
      }
      var index = this.currentPage * this.itemsPerPage - this.itemsPerPage;
      return this.MaterialObjectData.slice(index, index + this.itemsPerPage);
    },
    time: function () {
      return this.hours + " : " + this.minutes + " : " + this.seconds;
    },
    milliseconds: function () {
      return this.currentTime;
    },
    hours: function () {
      var milli = this.milliseconds;
      var hrs = Math.floor((this.totalTime / 3600000) % 24);
      return hrs >= 10 ? hrs : "0" + hrs;
      // let h = Math.trunc((this.endDate - this.nowz) / 1000 / 3600);
      // return h>9?h:'0'+h;
    },
    minutes: function () {
      var min = Math.floor(this.totalTime / 60);
      return min >= 10 ? min : "0" + min;
      // let m = Math.trunc((this.endDate - this.nowz) / 1000 / 60) % 60;
      // return m>9?m:'0'+m;
    },
    seconds: function () {
      var sec = this.totalTime - this.minutes * 60;
      return sec >= 10 ? sec : "0" + sec;
      // let s = Math.trunc((this.endDate - this.nowz)/1000) % 60
      // return s>9?s:'0'+s;
    },
    ...mapGetters([
      "teacher_full_status",
      // "student_drawing_permissions",
      "classRoomId",
      "UserName",
      "UserType",
    ]),
  },
  watch: {
    speakerDeviceId(newId) {
      if (this.audioCtx && newId && typeof this.audioCtx.setSinkId === "function") {
        this.audioCtx.setSinkId(newId).catch(() => {});
      }
    },
    MaterialMediaObjectData: {
      deep: true,
      handler() {
        this.MaterialMediaObjectDataKey++; // Increment the key to force the combo box to update
      },
    },
    MaterialVedioObjectData: {
      deep: true,
      handler() {
        this.MaterialVedioObjectDataKey++; // Increment the key to force the combo box to update
      },
    },
    // :key="mediaVedioSelected" 觸發 <video> 元素重建時清空 Web Audio 節點引用
    // 確保新影片可正確建立 MediaElementAudioSourceNode
    mediaVedioSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.videoMediaSource = null;
        this.videoGainNode = null;
      }
    },
    duration: {
      handler() {},
      deep: true,
    },
    errorLogs: {
      handler() {
        console.error("errorLogs", this.errorLogs);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    // 组件销毁前立即保存未保存的绘图数据
    if (this.debouncedAutoSave && this.debouncedAutoSave.cancel) {
      this.debouncedAutoSave.cancel();
    }
    this.autoSaveToDb();

    if (this.socket) {
      this.socket.disconnect();
    }

    if (this._unlockAudio) {
      document.removeEventListener("touchstart", this._unlockAudio);
      document.removeEventListener("click", this._unlockAudio);
    }
  },
  methods: {
    // 盾牌切換
    shieldChange() {
      this.student_drawing_permissions = !this.student_drawing_permissions;
      this.$emit(
        "student_drawing_permissions",
        this.student_drawing_permissions
      );
      this.socket.emit("setStudentPermissions", {
        roomId: String(this.roomId),
        state: this.student_drawing_permissions,
      });
    },
    // 新增空白頁
    async addClick() {
      // 防止快速重複點擊（尤其是 iPad 雙擊）造成多個空白頁
      if (this.isAddingPage) return;
      this.isAddingPage = true;
      this.pageChange("newPage");
      this.loadNewPage = true;
      this.socket.emit("cleanPage", {
        roomId: String(this.roomId),
      });
    },
    // 工具欄選中切換
    toolStatusChange(type, e) {
      this.resetButton();
      this[type] = !this[type];

      if (type === "toolRandomStatus") {
        if (this.initialDraw || this.currentDraw == null) {
          this.initialDraw = false;
          const drawNum = this.toolRandomCheck || 1;
          const drawId = this.currentDraw || "draw-pen";
          this.triggerHit("toolRandomCheck", drawNum, drawId, e);
        } else {
          this.triggerHit(
            "toolRandomCheck",
            this.toolRandomCheck,
            this.currentDraw,
            e
          );
        }
      } else if (type === "toolshapeStatus") {
        if (this.initialShape || this.currentShape == null) {
          this.initialShape = false;
          const shapeNum = this.toolshapeCheck || 1;
          const shapeId = this.currentShape || "shape-rect";
          this.triggerHit("toolshapeStatus", shapeNum, shapeId, e);
        } else {
          this.triggerHit(
            "toolshapeStatus",
            this.toolshapeCheck,
            this.currentShape,
            e
          );
        }
      }

      if (type === "toolCursorStatus" || type === "toolzoomStatus") {
        $("#textContainer, #mouseOverlay").css("pointer-events", "none");
      } else {
        $("#textContainer, #mouseOverlay").css("pointer-events", "auto");
      }
    },
    triggerHit(tool, num, type, event) {
      this.toolCheckChange(tool, num, event);
      this.whiteboardSwitch({ currentTarget: document.getElementById(type) });
    },
    // 工具欄下的子類選中切換
    toolCheckChange(type, num, event) {
      this[type] = num;

      if (type === "toolRandomCheck") {
        var activeTool = $(event.currentTarget).attr("id");
        this.currentDraw = activeTool;
        this.toolRandomCheck = num;
      } else if (type === "toolshapeCheck") {
        var activeTool = $(event.currentTarget).attr("id");
        this.currentShape = activeTool;
        this.toolshapeCheck = num;
      }
    },
    // 媒體分頁切換
    async pageChange(type) {
      const imgEl = document.getElementById("ContextImgAsBackground");
      if (imgEl) {
        if (this.zoom > 1) {
          this.setZoom(-(this.zoom - 1));
        } else {
          this.setZoom(1 - this.zoom);
        }
      }

      if (this.MaterialCode && this.MaterialUnitPage && this.MaterialFileName) {
        await this.saveToDbAsJson(type);
        await this.saveAsImageBtn(type, {
          ClassroomId: String(this.roomId),
          MaterialCode: this.MaterialCode,
          MaterialUnit: this.MaterialUnit,
          MaterialPage: this.MaterialUnitPage,
          MaterialFileName: this.MaterialFileName,
          ImageInBase64: this.imageBase64,
        });
      }

      this.nextPageStatus = true;
      this.lastPageStatus = true;
      this.previousPageStatus = true;
      this.frontPageStatus = true;

      var height = $("#backgroundGrid").height();

      $("#frontPage, #previousPage, #nextPage, #lastPage").css({
        "pointer-events": "none",
        cursor: "not-allowed",
      });
      $("#loadingMedia").removeAttr("style");
      $("#loadingMedia").css({
        zIndex: "1",
        height:
          $("#backgroundGrid").height() > $("#whiteboardContainer").height()
            ? height
            : "100%",
      });

      if (type === "frontPage" && this.mediaProgressNum > 0) {
        // 最前頁
        this.prevIndexGlobal = 0;
        this.previousPicture(type);
      } else if (type === "previousPage" && this.mediaProgressNum > 0) {
        // 上一頁
        this.previousPicture(type);
      } else if (
        type === "nextPage" &&
        this.mediaProgressNum < this.mediaLengthNum
      ) {
        // 下一頁
        this.nextPicture(type);
      } else if (
        type === "lastPage" &&
        this.mediaProgressNum < this.mediaLengthNum
      ) {
        // 最後頁
        this.nextIndexGlobal = this.MaterialObjectData.length - 1;
        this.nextPicture(type);
      } else if (type === "newPage") {
        whiteboard.clearWhiteboard();
        this.mediaProgressNum = this.mediaProgressNum + 1;
        this.mediaLengthNum = this.mediaLengthNum + 1;

        // 同步更新空白頁狀態，防止 .then() 非同步回調讀到已切頁後的 live state
        const _prevFileName = this.MaterialFileName;
        const _prevFileType = this.MaterialFileType;
        const _prevUnitPageId = this.MaterialUnitPageId;
        const _classID = this.roomId;
        const _newJsonUrl =
          process.env.VUE_APP_BASE_URL +
          "/materialmodel/json/" +
          _classID +
          "/" +
          _prevFileName.split(".")[0] +
          "-" +
          String(this.mediaProgressNum) +
          ".json";

        this.MaterialCode = "NewPage";
        this.MaterialUnit = "";
        this.MaterialUnitPage = String(this.mediaProgressNum);
        this.MaterialFileType = "json";
        this.MaterialName = _prevFileName;
        this.MaterialFileUrl = _newJsonUrl;
        this.fileUrl = _newJsonUrl;
        this.EnglishFileName = "New" + _prevFileName;
        this.ChineseFileName = "New" + _prevFileName;
        this.prevMaterialCode = "NewPage";
        this.prevMaterialUnit = "";
        this.prevMaterialUnitPage = String(this.mediaProgressNum);
        this.prevMaterialFileName = _prevFileName;

        // 同步更新 index 並將空白頁插入序列
        this.prevIndexGlobal = this.prevIndexGlobal + 1;
        this.nextIndexGlobal = this.nextIndexGlobal + 1;
        this.currentIndexGlobal = this.currentIndexGlobal + 1;

        const _newMaterialData = {
          FileName: _prevFileName,
          FileType: _prevFileType,
          FileUrl: _newJsonUrl,
          MaterialCode: "NewPage",
          MaterialName: _prevFileName,
          MaterialPage: String(this.mediaProgressNum),
          MaterialUnit: "",
          MaterialUnitPageId: _prevUnitPageId,
        };
        this.MaterialObjectData.splice(this.mediaProgressNum - 1, 0, _newMaterialData);
        console.log("Save To Material", this.MaterialObjectData);

        // 快照供 .then() 的 socket emit 使用，避免讀到切頁後更新的 live state
        this._newPageSnapshot = {
          prevIndexGlobal: this.prevIndexGlobal,
          nextIndexGlobal: this.nextIndexGlobal,
          currentIndexGlobal: this.currentIndexGlobal,
          newMaterialData: _newMaterialData,
        };

        this.pageChangeSet();
      }

      await this.socket.emit("setCurrentIndexGlobal", {
        roomId: String(this.roomId),
        index: this.currentIndexGlobal,
      });
      // this.pageChangeSet();
    },
    pageButtonSet(type) {
      setTimeout(() => {
        let handled = false;
        if (type === "frontPage" && this.mediaProgressNum > 0) {
          // 最前頁
          handled = true;
          this.previousPageStatus = true;
          this.frontPageStatus = true;
          this.nextPageStatus = false;
          this.lastPageStatus = false;
        } else if (type === "previousPage" && this.mediaProgressNum > 0) {
          // 上一頁
          handled = true;
          if (this.prevIndexGlobal == -1) {
            this.previousPageStatus = true;
            this.frontPageStatus = true;
          } else {
            this.previousPageStatus = false;
            this.frontPageStatus = false;
          }

          if (this.mediaProgressNum < this.mediaLengthNum) {
            this.nextPageStatus = false;
            this.lastPageStatus = false;
          }
        } else if (
          type === "nextPage" &&
          this.mediaProgressNum <= this.mediaLengthNum
        ) {
          // 下一頁
          handled = true;
          if (this.nextIndexGlobal == this.MaterialObjectData.length) {
            this.nextPageStatus = true;
            this.lastPageStatus = true;
          } else {
            this.nextPageStatus = false;
            this.lastPageStatus = false;
          }
          if (this.mediaProgressNum > 1) {
            this.previousPageStatus = false;
            this.frontPageStatus = false;
          }
        } else if (type === "lastPage") {
          // 最後頁
          handled = true;
          if (this.mediaProgressNum < this.mediaLengthNum) {
            this.previousPageStatus = false;
            this.frontPageStatus = false;
            this.nextPageStatus = false;
            this.lastPageStatus = false;
          } else {
            this.previousPageStatus = false;
            this.frontPageStatus = false;
            this.nextPageStatus = true;
            this.lastPageStatus = true;
          }
        }

        // 只在有匹配到 case 時才同步 CSS，避免 type="new" 等未知類型
        // 用舊的 true 狀態錯誤地禁用所有按鈕
        if (handled) {
          $("#frontPage, #previousPage").css({
            "pointer-events": this.frontPageStatus ? "none" : "auto",
            cursor: this.frontPageStatus ? "not-allowed" : "default",
          });
          $("#nextPage, #lastPage").css({
            "pointer-events": this.nextPageStatus ? "none" : "auto",
            cursor: this.nextPageStatus ? "not-allowed" : "default",
          });
        }
      }, 0);
    },
    pageChangeSet() {
      setTimeout(() => {
        this.isAddingPage = false;
        if (this.mediaProgressNum == 1) {
          // 最前頁
          this.previousPageStatus = true;
          this.frontPageStatus = true;
          this.nextPageStatus = false;
          this.lastPageStatus = false;
          $("#frontPage, #previousPage").css({
            "pointer-events": "none",
            cursor: "not-allowed",
          });
          $("#nextPage, #lastPage").css({
            "pointer-events": "auto",
            cursor: "default",
          });
        } else if (
          this.mediaProgressNum > 1 &&
          this.mediaProgressNum < this.mediaLengthNum
        ) {
          // 上一頁
          this.previousPageStatus = false;
          this.frontPageStatus = false;
          this.nextPageStatus = false;
          this.lastPageStatus = false;
          $("#frontPage, #previousPage, #nextPage, #lastPage").css({
            "pointer-events": "auto",
            cursor: "default",
          });
        } else if (this.mediaProgressNum == this.mediaLengthNum) {
          // 最後頁
          this.previousPageStatus = false;
          this.frontPageStatus = false;
          this.nextPageStatus = true;
          this.lastPageStatus = true;
          $("#frontPage, #previousPage").css({
            "pointer-events": "auto",
            cursor: "default",
          });
          $("#nextPage, #lastPage").css({
            "pointer-events": "none",
            cursor: "not-allowed",
          });
        }
      }, 1000);
    },
    // 媒體播放狀態切換
    // playChange(type) {
    //   if (type === "play") {
    //     $("#media-stop-btn").removeClass("disabled");
    //     this.mediaStopStatus = true;
    //     this.mediaPlayStatus = !this.mediaPlayStatus;
    //   } else if (type === "pause") {
    //     this.mediaPlayStatus = !this.mediaPlayStatus;
    //   } else {
    //     this.mediaPlayStatus = false;
    //     this.mediaStopStatus = !this.mediaStopStatus;
    //     $("#media-stop-btn").addClass("disabled");
    //   }
    // },
    // 媒體文件切換選擇
    fileSelectChange() {
      // 如果音頻有選中的話 那就顯示進度條和音量
      if (this.fileSelectCheck) {
        this.mediaShow = true;
        this.volumeShow = true;

        console.log(this.fileSelectCheck);
        if (this.fileSelectCheck.FileType === "audio/mp3") {
          this.onChangeMedia();
        } else {
          this.mediaPlayStatus = false;
          this.mediaStopStatus = false;
          this.isPaused = false;
          this.mediaCurrentDuration = 0;
          this.mediaSlider = 0;
          this.onChangeVedioMedia();
        }
      }
    },
    // Get Duration
    fileAudioDuration() {
      const audioElement = document.getElementById("main_audio");
      console.log(audioElement);

      audioElement.oncanplaythrough = () => {
        const durationInSeconds = audioElement.duration;
        const formattedDuration = formatDuration(durationInSeconds);
        this.mediaTotalDuration = formattedDuration;
        console.log(durationInSeconds);
        console.log(formattedDuration);
      };

      audioElement.addEventListener("loadedmetadata", () => {
        const durationInSeconds = audioElement.duration;
        const formattedDuration = formatDuration(durationInSeconds);
        this.mediaTotalDuration = formattedDuration;
        console.log(durationInSeconds);
        console.log(formattedDuration);
      });

      function formatDuration(durationInSeconds) {
        const minutes = Math.floor(durationInSeconds / 60);
        const seconds = Math.floor(durationInSeconds % 60);
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      }
    },
    // 媒體播放進度切換
    mediaChange(val) {
      console.log("當前音量：" + val);
    },
    // 媒體聲音切換
    volumeClick() {
      if (this.volumeSlider > 0) {
        this.savedVolume = this.volumeSlider;
        this.volumeChange(0);
      } else {
        this.volumeChange(this.savedVolume || 40);
      }
    },
    // 媒體音量切換
    volumeChange(val) {
      this.handleVolumeChange(val);
      if (val == 0) {
        this.volumeStatus = true;
      } else {
        this.volumeStatus = false;
      }
    },
    // 全屏切換
    fullChange() {
      var width = $("#whiteboardContainer").width();
      var height = $("#whiteboardContainer").height();

      this.$store.commit("SET_FULL_STATUS_TEACHER", !this.teacher_full_status);
      if (!this.teacher_full_status) {
        $(".teacher-box").removeAttr("style");
        $("#router").removeAttr("style");
      } else {
        $(".teacher-box").css({ padding: "0px 100px" });
        $("#router").css({ height: "100%", width: "100%" });
      }
      // this.onAudioPause();
      this.resetScrollbar();
      whiteboard.fullscreen(this.isShowVideoModal, width, height);
      this.zoom = 1;
      this.resetScrollbar();
      this.updateThumb();

      // 同步全屏状态到学生/员工/观课端
      this.socket.emit("toggle-fullscreen", {
        roomId: String(this.roomId),
        isFull: this.teacher_full_status,
      });
    },
    // 全屏模式-左側工具欄劃上顯示
    fullLeftMouseover() {
      this.fullLeftShow = true;
    },
    // 全屏模式-左側工具欄劃開隱藏
    fullLeftMouseleave() {
      this.fullLeftShow = false;
    },
    // 全屏模式-底部播放欄劃上顯示
    fullBottomMouseover() {
      this.fullBottomShow = true;
    },
    // 全屏模式-底部播放欄劃開隱藏
    fullBottomMouseleave() {
      this.fullBottomShow = false;
    },
    // 全屏模式-右上權限劃上顯示
    fullRightTopMouseover() {
      this.fullRightTopShow = true;
    },
    // 全屏模式-右上權限劃開隱藏
    fullRightTopMouseleave() {
      this.fullRightTopShow = false;
    },
    // iPad 觸摸：左側工具欄顯示，4秒後自動隱藏
    fullLeftTouchShow() {
      this.fullLeftShow = true;
      clearTimeout(this._fullLeftHideTimer);
      this._fullLeftHideTimer = setTimeout(() => {
        this.fullLeftShow = false;
      }, 4000);
    },
    // iPad 觸摸：底部工具欄顯示，4秒後自動隱藏
    fullBottomTouchShow() {
      this.fullBottomShow = true;
      clearTimeout(this._fullBottomHideTimer);
      this._fullBottomHideTimer = setTimeout(() => {
        this.fullBottomShow = false;
      }, 4000);
    },
    // iPad 觸摸：右上角顯示，4秒後自動隱藏
    fullRightTopTouchShow() {
      this.fullRightTopShow = true;
      clearTimeout(this._fullRightTopHideTimer);
      this._fullRightTopHideTimer = setTimeout(() => {
        this.fullRightTopShow = false;
      }, 4000);
    },
    videoMouseOver() {
      this.videoBottomShow = true;
    },
    videoMouseleave() {
      this.videoBottomShow = false;
    },
    resetButton() {
      this.toolCursorStatus = false;
      this.toolTextStatus = false;
      this.toolRandomStatus = false;
      this.toolRandomCheck = this.toolRandomCheck;
      this.toolFontWeightStatus = false;
      this.toolshapeStatus = false;
      this.toolshapeCheck = this.toolshapeCheck;
      this.toolzoomStatus = false;
      this.toolshrinkStatus = false;
      this.toolPaletteStatus = false;
      this.paletteBackground = "#D60839";
      this.toolSelectStatus = false;
      this.toolEraserStatus = false;
      this.toolStampStatus = false;
      this.toolStampCheck = "";
    },
    async receiveMaterialsBySocket(data) {
      if (this.socketLoaded && !!data) {
        if (data.next) {
          let responseMaterial = await this.$store.dispatch(
            "fetchHitutorMedia",
            {
              ClassroomId: data.ClassroomId,
              LastPage: data.LastPage,
              RequestPages: data.RequestPages,
            }
          );
          console.log("receiveMaterialsBySocket", responseMaterial);
          if (responseMaterial.data.IsSuccess == true) {
            this.theLastLastPage =
              this.MaterialObjectData[0].MaterialUnitPageId;
            //let isAnyMessageProps = Object.hasOwn(responseMaterial.data, "Message");
            let isAnyMessageProps = this.hasProperty(
              responseMaterial.data,
              "Message"
            );

            if (isAnyMessageProps == false || isAnyMessageProps === false) {
              this.MaterialObjectData = responseMaterial.data.MaterialObject;
              this.MaterialVedioObjectData =
                responseMaterial.data.MaterialVedioObject;
              this.MaterialMediaObject =
                responseMaterial.data.MaterialMediaObject;

              if (
                this.MaterialObjectData[0].MaterialUnitPageId !=
                  this.theLastLastPage ||
                this.MaterialObjectData[0].MaterialUnitPageId !==
                  this.theLastLastPage
              ) {
                if (this.paginationLayers.length > 0) {
                  if (this.paginationLayers.includes(this.theLastLastPage)) {
                  } else {
                    this.paginationLayers.push(this.theLastLastPage);
                  }
                } else {
                  this.paginationLayers.push(this.theLastLastPage);
                }
                this.nextIndexGlobal = 1;
                currentIndex = 0;
                prevIndex = -1;
                nextIndex = currentIndex + 1;

                this.currentLayer = this.currentLayer + 1;
                if (this.currentLayer > this.paginationLayers.length - 1) {
                  this.currentLayer = this.paginationLayers.length - 1;
                }
              } else {
                currentIndex = this.MaterialObjectData.length - 1;
                nextIndex = this.MaterialObjectData.length - 1;
                prevIndex = currentIndex - 1;
              }
            } else {
              alert(responseMaterial.data.Message);
              currentIndex = this.MaterialObjectData.length - 1;
              nextIndex = this.MaterialObjectData.length - 1;
              prevIndex = currentIndex - 1;
            }
          } else {
            currentIndex = this.MaterialObjectData.length - 1;
            nextIndex = this.MaterialObjectData.length - 1;
            prevIndex = currentIndex - 1;
          }
        } else {
          let responseMaterial = await this.$store.dispatch(
            "fetchHitutorMedia",
            {
              ClassroomId: data.ClassroomId,
              LastPage: data.LastPage,
              RequestPages: data.RequestPages,
            }
          );

          if (responseMaterial.data.IsSuccess == true) {
            this.MaterialObjectData = responseMaterial.data.MaterialObject;
            this.MaterialVedioObjectData =
              responseMaterial.data.MaterialVedioObject;
            this.MaterialMediaObject =
              responseMaterial.data.MaterialMediaObject;

            this.nextIndexGlobal = this.MaterialObjectData.length;
            currentIndex = this.MaterialObjectData.length - 1;
            prevIndex = currentIndex - 1;
            nextIndex = this.nextIndexGlobal;
            this.currentLayer = this.currentLayer - 1;
          } else {
            currentIndex = 0;
            prevIndex = 0;
            nextIndex = currentIndex + 1;
          }
        }
      }
    },
    async initializeSocket() {
      // alert("socket");
      let urlForSocket = this.urlForSocket; // Get the socket URL from your computed property
      this.socket = io(urlForSocket, {
        secure: true,
        transports: ["websocket"], // Force WebSocket transport
      });

      this.socket.on("got-connected", async () => {
        this.socketLoaded = true;
        console.log("user-joined");
        this.socket.emit("join-room", {
          roomId: String(this.roomId),
          userId: String(this.userId),
          user: String(this.userName),
          userType: this.userType,
        });
      });

      this.socket.on("getUserList", async (data) => {
        this.$emit("retrieveUserList", data);
      });

      this.socket.on("setTimerRun", (data) => {
        this.$emit("setTimerRun");
      });

      this.socket.on("getStudentPermissions", (data) => {
        this.student_drawing_permissions = data;
        this.$emit("student_drawing_permissions", data);
      });

      this.socket.on("setClockIn", (data) => {
        this.$emit("clockIn", data);
      });

      this.socket.on("setClockOut", (data) => {
        this.$emit("clockOut");
      });

      this.socket.on("checkFeedback", () => {
        this.$emit("checkFeedback");
      });

      this.socket.on("disconnect", (reason) => {
        console.log("Disconnected from server. Reason:", reason);
      });

      this.socket.on("exit-room", async (data) => {
        sessionStorage.clear();
      });

      this.socket.on("user-joined", async (data) => {
        var user = data.user;
        this.$emit("retrieveUserList", data.userList);
        if (user) {
          if (user?.userType != "3") {
            this.$toast(
              {
                component: Notification,
                props: {
                  user: `${user.user}`,
                  type: "join",
                },
              },
              {
                position: "top-right",
                timeout: 5000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false,
              }
            );
          }
        }
      });

      this.socket.on("user-exit", async (data) => {
        var user = data.user;
        this.$emit("retrieveUserList", data.userList);
        if (user) {
          if (user.userType != "3") {
            if (user.userType == "1") {
              this.$emit("stopTimerRun");
            }
            this.$toast(
              {
                component: Notification,
                props: {
                  user: `${user.user}`,
                  type: "exit",
                },
              },
              {
                position: "top-right",
                timeout: 5000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false,
              }
            );
          }
        }
      });

      this.socket.on("cleanPage", async (data) => {
        $("#loadingMedia").css({
          display: "none",
        });
        $("#loadingMedia").css({ zIndex: "0" });
      });

      this.socket.on("getCurrentIndexGlobal", async (data) => {
        this.currentIndexMaterial = data[this.roomId];
        await signaling_socket.emit("getSavedData", whiteboardId);

        if (this.currentIndexMaterial >= 0) {
          if (!this.newMaterialState) {
            this.nextPageStatus = true;
            this.lastPageStatus = true;
            this.previousPageStatus = true;
            this.frontPageStatus = true;

            var height = $("#backgroundGrid").height();

            $("#frontPage, #previousPage, #nextPage, #lastPage").css({
              "pointer-events": "none",
              cursor: "not-allowed",
            });
            $("#loadingMedia").removeAttr("style");
            $("#loadingMedia").css({
              zIndex: "1",
              height:
                $("#backgroundGrid").height() >
                $("#whiteboardContainer").height()
                  ? height
                  : "100%",
            });
            // 直接加载页面，不依赖 signaling_socket 的 getSavedData
            this.loadImgMaterial();
            this.pageChangeSet();
            // 安全网：getSavedData 到达后补充绘图数据（只加载笔划，不处理背景图）
            var unwatchContent = this.$watch(
              () => this.content,
              (newContent) => {
                if (newContent && newContent.length > 0) {
                  var strokesOnly = newContent.filter(item => item && item["t"] !== "addImgContentAsBG" && item["t"] !== "clear");
                  if (strokesOnly.length > 0) {
                    // 先清除已加載的 DB JSON 筆跡，避免與 live buffer 重複疊加
                    whiteboard.loadCurrentData([{t: "clearDrawing"}, ...strokesOnly], false);
                  }
                }
                unwatchContent();
              }
            );
          } else {
            this.newMaterialState = false;
            this.mediaProgressNum = this.currentIndexGlobal + 1;
            this.mediaLengthNum = this.mediaLengthNum + this.newMaterial.length;
            const renderedWidth = "100%";
            const renderedHeight = "100%";
            this.setupCanvasAndResizeElements(renderedWidth, renderedHeight);

            // 一次性 watcher：content 到達後立即取消，避免 getCurrentIndexGlobal
            // 多次觸發時累積永久 watcher，導致畫板反覆重繪而閃動
            var unwatchNewMaterial = this.$watch(
              () => this.content,
              () => {
                console.log("contentDataLoadNoMaterial", this.content);
                whiteboard.loadCurrentData(this.content, false);
                this.pageButtonSet("newPage");
                this.pageChangeSet();
                unwatchNewMaterial();
              }
            );
          }
        } else {
          // 无历史记录，默认加载第一页
          const renderedWidth = "100%";
          const renderedHeight = "100%";
          this.setupCanvasAndResizeElements(renderedWidth, renderedHeight);
          // 一次性 watcher：避免每次 getCurrentIndexGlobal 新增永久監聽器
          var unwatchInitial = this.$watch(
            () => this.content,
            () => {
              whiteboard.loadCurrentData(this.content, false);
              unwatchInitial();
            }
          );
          if (this.MaterialObjectData && this.MaterialObjectData.length > 0) {
            this.currentIndexMaterial = 0;
            this.loadImgMaterial();
            this.pageChangeSet();
          }
        }
      });

      this.socket.on("clientMaterialConfirmed", () => {
        console.log("clientMaterialConfirmed");
      });

      this.socket.on("getNewMaterial", (data) => {
        // 若序列已從 DB 還原（含插入頁），跳過此處的 splice，避免重複插入
        if (this.sequenceRestoredFromDB) return;
        if (data.length > 0) {
          var newMaterialIndex = new Map();
          for (let i = 0; i < data.length; i++) {
            this.newMaterial.push(data[i].newMaterial);
            this.MaterialObjectData.splice(
              data[i].currentIndexGlobal,
              0,
              data[i].newMaterial
            );
            newMaterialIndex.set(data[i].currentIndexGlobal, i);
          }
          this.currentIndexGlobal = data[data.length - 1].currentIndexGlobal;
          this.$watch(
            () => this.currentIndexMaterial,
            () => {
              console.log(
                "NewMaterial",
                this.MaterialObjectData,
                this.currentIndexGlobal,
                this.currentIndexMaterial
              );
              if (newMaterialIndex.has(this.currentIndexMaterial)) {
                this.newMaterialState = true;
              } else {
                this.newMaterialState = false;
              }
              this.mediaProgressNum = this.currentIndexMaterial + 1;
              this.mediaLengthNum = this.mediaLengthNum + data.length - 1;
            }
          );
        }
      });

      this.socket.on("getLoadJsonFromDatabase", (data) => {
        console.log("loadJsonFromDatabase Socket Client", data);
        this.loadJsonFromDatabaseClient(
          data.roomId,
          data.englishName,
          data.materialUnit,
          data.materialPage,
          data.type,
          false,
          (val) => {
            if (
              this.zoom == 1 &&
              $("#ContextImgAsBackground").height() <
                $("#whiteboardContainer").height()
            ) {
              const transform = `translate(0px, -50%)`;
              const position = {
                transform: transform,
                top: "50%",
              };
              $(
                "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
              ).css(position);
            }
            if (!val) {
              $("#loadingMedia").css({
                display: "none",
              });
              $("#loadingMedia").css({ zIndex: "0" });
            }
            this.pageButtonSet(data.type);
          }
        );
      });

      this.socket.on("updateIndexGlobal", (data) => {
        this.prevIndexGlobal = data.prevIndexGlobal;
        this.nextIndexGlobal = data.nextIndexGlobal;
        this.currentIndexGlobal = data.currentIndexGlobal;
      });

      this.socket.on("getImgTempId", (data) => {
        var height = $("#backgroundGrid").height();
        // $("#frontPage, #previousPage, #nextPage, #lastPage").css({
        //   "pointer-events": "none",
        //   cursor: "not-allowed",
        // });
        // $("#loadingMedia").removeAttr("style");
        // $("#loadingMedia").css({
        //   zIndex: "1",
        //   height:
        //     $("#backgroundGrid").height() > $("#whiteboardContainer").height()
        //       ? height
        //       : "100%",
        // });

        this.prevIndexGlobal = data.num[0];
        this.nextIndexGlobal = data.num[1];
        this.currentIndexGlobal = data.num[2];
        this.mediaProgressNum = data.num[3];
        this.pageButtonSet(data.type);

        if (typeof data.file === "string") {
          var paramFileNameList = data.file.split("|");
          this.MaterialUnit = paramFileNameList[2];
          this.MaterialUnitPage = paramFileNameList[3];
          this.MaterialFileName = paramFileNameList[4];
          this.EnglishFileName = paramFileNameList[4];
          this.ChineseFileName = paramFileNameList[4];
          this.MaterialName = paramFileNameList[5];
        } else {
          this.MaterialUnit = data.file.materialUnit;
          this.MaterialUnitPage = data.file.materialPage;
          this.MaterialFileName = data.file.englishName;
          this.EnglishFileName = data.file.englishName;
          this.ChineseFileName = data.file.chineseName;
          this.MaterialName = data.file.materialName;
        }
      });

      this.socket.on("updateNewMaterial", (data) => {
        if (this.sequenceRestoredFromDB) return;
        // 使用伺服器回傳的 currentIndexGlobal 作為插入位置，而非本地的 mediaProgressNum-1
        // 兩者可能因網路時序不同而不一致，使用伺服器索引確保插入位置正確
        this.MaterialObjectData.splice(
          data.currentIndexGlobal,
          0,
          data.newMaterial
        );
        this.prevIndexGlobal = data.prevIndexGlobal;
        this.nextIndexGlobal = data.nextIndexGlobal;
        this.currentIndexGlobal = data.currentIndexGlobal;
        this.mediaProgressNum = this.nextIndexGlobal;
        this.mediaLengthNum = this.mediaLengthNum + 1;

        this.setupCanvasAndResizeElements("100%", "100%");
      });

      this.socket.on("retrieveRoomInfo", (data) => {
        const checkAndPlayAudio = () => {
          this.mediaSelected = data.selectedMedia.FileUrl;
          this.fileSelectCheck = data.selectedMedia;
          this.$refs.audio.currentTime = data.time;
          this.toggleAudioPlayback(data.action, data);
        };
        checkAndPlayAudio();
      });

      this.socket.on("audioCurrentTime", (data) => {
        this.$refs.audio.currentTime = data;
      });

      // this.socket.on("updateAudioTime", (data) => {
      //   let audioElement = document.getElementById("main_audio");
      //   const drift = Math.abs(audioElement.currentTime - data.time);
      //   if (drift > 0.5) {
      //     audioElement.currentTime = data.time;
      //   }
      // });

      this.socket.on("initialAudio", async (data) => {
        if (!data) {
          return;
        }

        if (data["isShowVideoModal"]) {
          let { selectedMedia } = data;
          this.isShowVideoModal = data.isShowVideoModal;
          if (this.isShowVideoModal) {
            this.mediaVedioSelected = selectedMedia.FileUrl;
            this.mediaVideoNameSelected = selectedMedia.FileName;
            this.fileSelectCheck = selectedMedia;
            whiteboard.isVideoShow = this.isShowVideoModal;
            this.adjustVideoElementSize();
          } else {
            this.$refs.video.pause();
          }

          const video = this.$refs.video;
          setTimeout(() => {
            video.currentTime = 0.01;
          }, 100);
        } else {
          // 若教師已選擇媒體或正在播放，以教師 UI 操作為準，不覆蓋任何狀態
          // 避免非同步 fetch 完成後覆蓋教師新選擇的媒體或中斷播放
          if (this.audioUrl || this.mediaPlayStatus) return;

          try {
            let { selectedMedia } = data;
            if (!selectedMedia || !selectedMedia.FileUrl) return;

            const restoredUrl = selectedMedia.FileUrl;
            this.mediaSelected = restoredUrl;
            this.fileSelectCheck = selectedMedia;
            this.audioUrl = restoredUrl;

            // 保留已解鎖的 AudioContext（iOS 重建會導致 suspended 無聲）
            if (!this.audioCtx || this.audioCtx.state === "closed") {
              this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
              this.gainNode = null;
              this.videoMediaSource = null;
              this.videoGainNode = null;
            }
            if (this.speakerDeviceId && typeof this.audioCtx.setSinkId === "function") {
              await this.audioCtx.setSinkId(this.speakerDeviceId).catch(() => {});
            }

            const response = await fetch(restoredUrl);
            const arrayBuffer = await response.arrayBuffer();
            const decoded = await this.audioCtx.decodeAudioData(arrayBuffer);

            // fetch 期間教師可能已選擇新媒體或開始播放，此時放棄覆蓋
            if (this.audioUrl !== restoredUrl || this.mediaPlayStatus) return;

            this.audioBuffer = decoded;
            this.mediaTotalDuration = decoded.duration;

            // 僅在時間點有效（在音頻範圍內）才恢復暫停位置
            if (data.time > 0 && data.time < decoded.duration) {
              this.mediaCurrentDuration = data.time;
              this.isPaused = true;
            }
            // 不呼叫 handleAudioControl，教師透過 UI 自行控制播放/暫停/停止
          } catch (err) {
            console.error("Error loading or decoding audio:", err);
          }
        }
      });

      this.socket.on("updateAudioTime", async (data) => {
        const localElapsed = this.audioCtx.currentTime - this.startTime;
        const drift = Math.abs(localElapsed - data.time);

        if (drift > 0.1) {
          if (this.audioCtx.state === "suspended") {
            await this.audioCtx.resume();
          }

          if (this.sourceNode) {
            this._safeStopNode(this.sourceNode);
            this.sourceNode = null;
          }

          this.createSource(data.time);
        }
      });

      this.socket.on("toggle-audio-playback", (data) => {
        if (data.roomId !== this.roomId) return;
        // 忽略自己发出的回显，教師端已在 playChange 中本地執行
        if (data.socketId === this.socket.id) return;
        // 忽略沒有 socketId 的伺服器生成事件（如斷線 handler 發出的 stop）
        // 教師端的音頻控制只由 UI 操作，不需要伺服器回播 stop
        if (!data.socketId) return;

        this.handleAudioControl(data.action);
      });

      // this.socket.on("toggle-audio-playback", (data) => {
      //   if (data.action == "play") {
      //     const datas = data.data;
      //     this.mediaSelected = datas.selectedMedia.FileUrl;
      //     this.fileSelectCheck = datas.selectedMedia;
      //     this.toggleAudioPlayback(datas.action, data.data);
      //   } else {
      //     this.toggleAudioPlayback(data.data.action, data.data);
      //   }
      // });

      this.socket.on("send-background-index", (data) => {
        this.receiveCurrentIndex(data);
      });

      this.socket.on("send-material-lists", (data) => {
        this.receiveMaterialsBySocket(data);
      });

      this.socket.on("send-material-video-media", (data) => {
        let { selectedVideoMedia } = data;
        console.log(selectedVideoMedia);
        let existingMediaIndex = this.MaterialVedioObjectData.findIndex(
          (media) => media.FileUrl === selectedVideoMedia.FileUrl
        );

        if (existingMediaIndex !== -1) {
          this.$set(
            this.MaterialVedioObjectData,
            existingMediaIndex,
            selectedVideoMedia
          );
        } else {
          this.MaterialVedioObjectData.push(selectedVideoMedia);
        }

        this.mediaVedioSelected = selectedVideoMedia.FileUrl;
        this.fileSelectCheck = selectedVideoMedia;
        this.mediaShow = !this.mediaShow;
      });

      this.socket.on("show-video-modal", (data) => {
        this.isShowVideoModal = data.isShowVideoModal;
        whiteboard.isVideoShow = this.isShowVideoModal;

        if (this.isShowVideoModal) {
          if (this.mediaVedioSelected != data.mediaVideoSelected.FileUrl) {
            this.mediaVedioSelected = data.mediaVideoSelected.FileUrl;
            this.mediaVideoNameSelected = data.mediaVideoSelected.FileName;
            this.fileSelectCheck = data.mediaVideoSelected;
            this.adjustVideoElementSize();

            const video = this.$refs.video;
            setTimeout(() => {
              video.currentTime = 0.01;
            }, 100);
          }
        } else {
          this._resetVideoAudioRouting();
        }
      });

      this.socket.on("playVideo", () => {
        this.$emit("audioPlayStart"); // 靜音麥克風，防止 MP4 音頻被麥克風採集產生回音
        this.setupVideoAudioRouting();
        // 只在視頻暫停時才調用 play()，避免對已在播放的視頻重複觸發非手勢 play() 影響音頻
        if (this.$refs.video && this.$refs.video.paused) {
          this.$refs.video.play().catch(() => {});
        }
      });

      this.socket.on("pauseVideo", () => {
        this.$refs.video.pause();
        this.$emit("audioPlayStop"); // 恢復麥克風
      });

      this.socket.on("changeVolume", (volume) => {
        this.volume = volume;
        if (this.$refs.video) this.$refs.video.volume = volume;
      });

      this.socket.on("changeCurrentTime", (currentTime) => {
        this.currentTimeVideo = currentTime;
        this.$refs.video.currentTime = this.currentTimeVideo;
      });

      this.socket.on("videoCurrentTime", (data) => {
        if (!data) {
          return;
        }

        if (data["isShowVideoModal"] && !this.isShowVideoModal) {
          let { selectedMedia } = data;
          this.isShowVideoModal = data.isShowVideoModal;
          if (this.isShowVideoModal) {
            this.mediaVedioSelected = selectedMedia.FileUrl;
            this.mediaVideoNameSelected = selectedMedia.FileName;
            this.fileSelectCheck = selectedMedia;
            whiteboard.isVideoShow = this.isShowVideoModal;
            this.adjustVideoElementSize();
          } else {
            this.$refs.video.pause();
          }

          const video = this.$refs.video;
          setTimeout(() => {
            video.currentTime = 0.01;
          }, 100);
        } else if (data["isShowVideoModal"] && this.isShowVideoModal) {
          if (data["action"] === "play" && this.$refs.video.paused) {
            this.$refs.video.play().catch(() => {});
          } else if (data["action"] === "pause" && !this.$refs.video.paused) {
            this.$refs.video.pause();
          }

          this.currentTimeVideo = data["time"];
        }
      });

      this.socket.on("videoDuration", (duration) => {
        this.duration = duration;
      });

      this.socket.on("send-material-media", (data) => {
        let { selectedMedia } = data;
        let existingMediaIndex = this.MaterialMediaObjectData.findIndex(
          (media) => media.FileUrl === selectedMedia.FileUrl
        );

        if (existingMediaIndex !== -1) {
          this.$set(
            this.MaterialMediaObjectData,
            existingMediaIndex,
            selectedMedia
          );
        } else {
          this.MaterialMediaObjectData.push(selectedMedia);
        }

        this.mediaSelected = selectedMedia.FileUrl;
        this.fileSelectCheck = selectedMedia;
        this.mediaShow = true;
        this.volumeShow = true;

        const audio = new Audio();
        audio.src = this.mediaSelected;
        audio.addEventListener("loadedmetadata", () => {
          this.mediaTotalDuration = audio.duration;
        });
      });
      this.socket.on("retrieveChats", (data) => {
        console.log("retrieveChats");
        this.$emit("retrieveChats");
      });
      this.socket.on("push-chat-message", (msg) => {
        this.$emit("newChatMessage", msg);
      });
    },

    setupCanvasAndResizeElements(width, height) {
      $("#whiteboardCanvas").ready(() => {
        const canvas = document.getElementById("whiteboardCanvas");
        const WHITEBOARD_MIN_WIDTH = 1200;
        var widthContainer = $("#whiteboardContainer").width();
        var heightContainer = $("#whiteboardContainer").height();
        const effectiveWidth = Math.max(widthContainer, WHITEBOARD_MIN_WIDTH);

        // 設定 whiteboardInner 固定像素尺寸，使 overflow:auto 容器能正確顯示捲動條
        $("#whiteboardInner").css({ width: effectiveWidth + "px", height: heightContainer + "px" });
        canvas.width = effectiveWidth;
        canvas.height = heightContainer;
        // 明確設定 canvas CSS 像素尺寸，避免 "100%" 導致內容被壓縮變形
        $(canvas).css({ width: effectiveWidth + "px", height: heightContainer + "px" });

        const elementsToResize = [
          "#textContainer",
          "#mouseOverlay",
          "#imgContainer",
          "#backgroundGrid",
          "#svgContainer",
          "#dropIndicator",
          "#cursorContainer",
          "#loadingMedia",
        ];
        elementsToResize.forEach((element) =>
          $(element).css({ width: effectiveWidth + "px", height: heightContainer + "px" })
        );
      });
    },

    adjustVideoElementSize() {
      var popupVideoElement = document.getElementById("hi_popup_video");
      var whiteboardContainer = document.getElementById("whiteboardContainer");

      popupVideoElement.style.cssText = `
        display: flex;
        flex-direction: column;
        position: absolute;
        z-index: 900;
        width: ${whiteboardContainer.clientWidth}px;
        height: ${whiteboardContainer.clientHeight}px;
        top: ${
          whiteboardContainer.getBoundingClientRect().top + window.scrollY
        }px;
        left: ${whiteboardContainer.getBoundingClientRect().left}px;
      `;
    },

    handleVolumeChange(val) {
      if (this.gainNode) {
        this.gainNode.gain.value = val / 100;
      }
    },

    setupSlider() {
      let timeSlider = $(".mejs__time-slider");
      console.log(timeSlider);
      if (timeSlider.length) {
        timeSlider.on("mouseup", (e) => {
          this.userInitiatedUpdate = true;
          setTimeout(() => {
            let x = e.pageX - timeSlider.offset().left;
            let width = timeSlider.width();
            let duration = this.$refs.audio.duration;
            var currentValue = (x / width) * duration;
            this.socket.emit("audioCurrentTime", {
              roomId: String(this.roomId),
              currentValue: currentValue,
            });
          }, 0);
        });
      }
    },

    handleSliderMouseUp() {
      this.userInitiatedUpdate = true;
      const currentValue = this.currentTime;
      this.isDraggingSlider = false;
      this.inputTimeUpdate(this.mediaSlider);
      this.socket.emit("audioCurrentTime", {
        roomId: String(this.roomId),
        currentValue: currentValue,
      });
    },

    // handleTimeUpdate() {
    //   let duration = this.$refs.audio.duration;
    //   let currentTime = this.$refs.audio.currentTime;
    //   this.mediaSlider = (currentTime / duration) * 100;
    //   this.mediaCurrentDuration = currentTime;

    //   this.socket.emit("audioTimeUpdate", {
    //     roomId: String(this.roomId),
    //     currentValue: currentTime,
    //   });
    // },

    // inputTimeUpdate() {
    //   const seekTime = (this.mediaSlider / 100) * this.$refs.audio.duration;
    //   this.$refs.audio.currentTime = seekTime;
    //   this.socket.emit("audioTimeUpdate", {
    //     roomId: String(this.roomId),
    //     currentValue: seekTime,
    //   });
    // },

    formatTime(timeInSeconds) {
      if (!timeInSeconds || isNaN(timeInSeconds) || !isFinite(timeInSeconds) || timeInSeconds < 0) {
        return "00:00:00";
      }
      let hours = Math.floor(timeInSeconds / 3600);
      let minutes = Math.floor((timeInSeconds % 3600) / 60);
      let seconds = Math.floor(timeInSeconds % 60);

      let hoursDisplay = `${hours < 10 ? "0" : ""}${hours}:`;
      let minutesDisplay = `${minutes < 10 ? "0" : ""}${minutes}:`;
      let secondsDisplay = `${seconds < 10 ? "0" : ""}${seconds}`;

      return hoursDisplay + minutesDisplay + secondsDisplay;
    },

    updateCurrentTimeVideoMethod() {
      this.waitForSocketAndRun(this, () => {
        this.currentTimeVideo = this.$refs.video.currentTime;
        this.socket.emit("videoCurrentTime", {
          roomId: String(this.roomId),
          currentTime: this.currentTimeVideo,
        });
      });
    },

    // 自动保存防抖 - 绘图停止 3 秒后触发
    debouncedAutoSave: debounce(function () {
      this.autoSaveToDb();
    }, 3000),

    throttledUpdateCurrentTime: throttle(function () {
      this.updateCurrentTimeVideoMethod();
    }, 500),

    setDuration(event) {
      this.waitForSocketAndRun(this, () => {
        this.duration = this.$refs.video.duration;
        this.duration = event.target.duration;
        const video = this.$refs.video;
        setTimeout(() => {
          video.currentTime = 0.01;
        }, 100);

        if (this.socket) {
          this.socket.emit("videoDuration", {
            roomId: String(this.roomId),
            duration: this.duration,
          });
        }
      });
    },

    async playVideo() {
      this.isPlay = true;
      this.$emit("audioPlayStart");

      // iOS 音頻路由修復：
      // 根本原因：iOS + Agora WebRTC 會把音頻 Session 設為 PlayAndRecord（預設輸出：聽筒）。
      // 若先呼叫 video.play() 再建立 MediaElementSource，iOS 已將音頻提交至聽筒路徑，
      // 事後重新路由無效，導致完全無聲。
      // 正確順序：先 resume AudioContext → 建立路由 → 再 play()。
      // iOS 上 resume() 在手勢上下文中完成極快（< 50ms），
      // await 後呼叫 play() 仍在 1 秒手勢視窗內，不會被拒絕。

      // 1. 確保 AudioContext 已建立
      if (!this.audioCtx || this.audioCtx.state === "closed") {
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        this.gainNode = null;
        this.videoMediaSource = null;
        this.videoGainNode = null;
      }

      // 2. 先 await resume()，確保 AudioContext 為 running 狀態後才建立路由
      if (this.audioCtx.state !== "running") {
        await this.audioCtx.resume().catch(() => {});
      }

      // 3. 在 play() 之前建立 AudioContext 路由
      //    確保視頻音頻從一開始就走 AudioContext → 揚聲器，而非先走聽筒
      this.setupVideoAudioRouting();

      // 4. 開始播放視頻（仍在手勢視窗內）
      if (this.$refs.video) {
        this.$refs.video.play().catch((e) => {
          console.error("[Video] play() failed:", e);
        });
      }

      this.socket.emit("playVideo", {
        roomId: String(this.roomId),
        isPlay: this.isPlay,
      });
    },
    pauseVideo() {
      if (this.$refs.video) this.$refs.video.pause();
      this.isPlay = false;
      this.$emit("audioPlayStop"); // 恢復麥克風
      this.socket.emit("pauseVideo", {
        roomId: String(this.roomId),
        isPlay: this.isPlay,
      });
    },

    // 設定視頻音量，並在 iOS 上強制走揚聲器輸出
    // iOS 問題：Agora WebRTC 啟動麥克風後，iOS 將音頻 Session 切為 PlayAndRecord，
    // 預設輸出走聽筒（earpiece），導致視頻聲音極小。
    // 解決：將 <video> 接入 AudioContext（已在使用者手勢中 resume），
    // iOS 會把 AudioContext 輸出導向揚聲器，從而讓視頻聲音正常。
    setupVideoAudioRouting() {
      if (!this.$refs.video) return;

      const clampedVolume = Math.max(0, Math.min(1, this.volume));
      this.$refs.video.volume = clampedVolume;

      // iOS Safari + WebRTC：透過 AudioContext 路由強制揚聲器輸出
      // 注意：必須在 audioCtx.state === "running" 時才能建立 MediaElementSource；
      // 若在 suspended 狀態接入，audio 會被捕獲進暫停的圖中 → 完全靜音。
      // playVideo() 已先 await audioCtx.resume()，此處只在確認 running 後才執行。
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (isIOS && this.audioCtx && this.audioCtx.state === "running") {
        try {
          if (!this.videoMediaSource) {
            this.videoMediaSource = this.audioCtx.createMediaElementSource(this.$refs.video);
            this.videoGainNode = this.audioCtx.createGain();
            this.videoGainNode.gain.value = 1;
            this.videoGainNode.connect(this.audioCtx.destination);
            this.videoMediaSource.connect(this.videoGainNode);
          }
        } catch (e) {
          // 路由建立失敗，回退到原生 volume 控制
          console.warn("[Video] Audio routing error:", e);
        }
      }
    },

    changeVolume() {
      const clampedVolume = Math.max(0, Math.min(1, this.volume));
      if (this.$refs.video) this.$refs.video.volume = clampedVolume;
      this.socket.emit("changeVolume", {
        roomId: String(this.roomId),
        volume: clampedVolume,
      });
    },
    toggleMute() {
      this.isMuted = !this.isMuted;
      this.$refs.video.muted = this.isMuted;
      // 靜音僅影響當前用戶，不廣播給其他端
    },
    changeCurrentTime() {
      this.$refs.video.currentTime = this.currentTimeVideo;
      this.socket.emit("changeCurrentTime", {
        roomId: String(this.roomId),
        currentTime: this.currentTimeVideo,
      });
    },
    showVideoDialogSocket() {
      let selectedVideoMedia = this.MaterialVedioObjectData.find(
        (media) => media.FileUrl === this.fileSelectCheck.FileUrl
      );
      if (selectedVideoMedia) {
        this.isShowVideoModal = true;
        whiteboard.isVideoShow = this.isShowVideoModal;
        this.adjustVideoElementSize();

        this.socket.emit("show-video-modal", {
          roomId: String(this.roomId),
          action: "",
          isShowVideoModal: this.isShowVideoModal,
          mediaVideoSelected: selectedVideoMedia,
        });
      }
    },
    _resetVideoAudioRouting() {
      // 斷開 iOS AudioContext 視頻路由，釋放 MediaElementSource
      if (this.videoMediaSource) {
        try { this.videoMediaSource.disconnect(); } catch (e) {}
        this.videoMediaSource = null;
      }
      if (this.videoGainNode) {
        try { this.videoGainNode.disconnect(); } catch (e) {}
        this.videoGainNode = null;
      }
    },
    closeVideoDialogSocket() {
      this.isShowVideoModal = false;
      whiteboard.isVideoShow = this.isShowVideoModal;
      this.pauseVideo();
      this._resetVideoAudioRouting();
      this.socket.emit("show-video-modal", {
        roomId: String(this.roomId),
        isShowVideoModal: false,
      });
    },
    closeModal() {
      this.isShowVideoModal = false;
      this.$refs.video.pause();
      this.$emit("audioPlayStop"); // 關閉 video modal，恢復麥克風
      this._resetVideoAudioRouting();
      this.socket.emit("show-video-modal", {
        roomId: String(this.roomId),
        isShowVideoModal: false,
      });
    },
    updateAudioTime(newTime) {
      let audioElement = document.getElementById("main_audio");
      audioElement.currentTime = newTime;
      audioElement.play().catch(() => {});
    },
    changePlayPauseButtonAppearance(type) {},
    async loadAudioBuffer() {
      console.log(`[Audio] loadAudioBuffer 開始 | audioUrl=${this.audioUrl}`);
      try {
        // 保留已解鎖的 AudioContext：iOS 每次重建都是 suspended，會導致無聲
        if (!this.audioCtx || this.audioCtx.state === "closed") {
          this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          // 將輸出設備對齊 Agora 揚聲器，讓系統 AEC 能消除回音
          if (this.speakerDeviceId && typeof this.audioCtx.setSinkId === "function") {
            await this.audioCtx.setSinkId(this.speakerDeviceId).catch(() => {});
          }
          this.gainNode = null; // 新 context，重建 gainNode
        }
        if (!this.gainNode) {
          this.gainNode = this.audioCtx.createGain();
          this.gainNode.gain.value = this.volumeSlider / 100;
          this.gainNode.connect(this.audioCtx.destination);
        }
        if (this.audioCtx.state === "suspended") {
          // 不 await：iOS 上 resume() 在非用戶手勢中可能永不 resolve，會卡住後續 decode
          this.audioCtx.resume().catch(() => {});
        }

        // 停止舊的 sourceNode，清除 buffer，準備載入新音頻
        if (this.sourceNode) {
          this._safeStopNode(this.sourceNode);
          this.sourceNode = null;
        }
        this.audioBuffer = null;

        const response = await fetch(this.audioUrl);
        const arrayBuffer = await response.arrayBuffer();
        this.audioBuffer = await this.audioCtx.decodeAudioData(arrayBuffer);
        this.mediaTotalDuration = this.audioBuffer.duration;
        console.log(`[Audio] loadAudioBuffer 完成 | duration=${this.mediaTotalDuration?.toFixed(2)}s | audioCtx.state=${this.audioCtx?.state}`);
        // 競態條件：buffer 載入完成後，執行先前被擱置的 play 指令
        if (this.pendingAudioPlay) {
          this.pendingAudioPlay = false;
          console.log(`[Audio] 執行 pendingAudioPlay | offset=${this.pendingAudioOffset}`);
          this.playAudio(this.pendingAudioOffset || 0);
        }
      } catch (err) {
        console.error("[Audio] loadAudioBuffer 失敗:", err);
        this.pendingAudioPlay = false;
      }
    },

    _safeStopNode(node) {
      if (!node) return;
      try {
        node.stop();
      } catch (e) {
        // 忽略 "stop without start" 或 "already stopped" 错误
      }
      try {
        node.disconnect();
      } catch (e) {}
      node.onended = null;
    },

    createSource(offset = 0) {
      if (!this.audioBuffer || !this.audioCtx) {
        console.warn("createSource: audioBuffer 未就绪");
        return;
      }

      // 先停止并释放旧节点（必须调 stop，否则旧节点会在后台继续运行）
      if (this.sourceNode) {
        this._safeStopNode(this.sourceNode);
        this.sourceNode = null;
      }

      if (!this.gainNode) {
        this.gainNode = this.audioCtx.createGain();
        this.gainNode.gain.value = this.volumeSlider / 100;
        this.gainNode.connect(this.audioCtx.destination);
      }

      try {
        const node = this.audioCtx.createBufferSource();
        node.buffer = this.audioBuffer;
        node.connect(this.gainNode);

        node.onended = () => {
          console.log(`[Audio] node.onended 觸發 | isPaused=${this.isPaused} | mediaCurrentDuration=${this.mediaCurrentDuration?.toFixed(2)} | totalDuration=${this.mediaTotalDuration?.toFixed(2)}`);
          if (!this.isPaused) {
            this.mediaPlayStatus = false;
            this.mediaStopStatus = false;
            this.mediaCurrentDuration = 0;
            this.mediaSlider = 0;
          }
          // 只有当 this.sourceNode 仍是本节点时才清空（防止被新节点覆盖后误清）
          if (this.sourceNode === node) {
            this.sourceNode = null;
          }
        };

        this.startTime = this.audioCtx.currentTime - offset;
        node.start(0, offset);
        // start() 成功后才赋值，避免留下未 start 的节点
        this.sourceNode = node;
        this.updatePlaybackTime();
      } catch (e) {
        console.error("createSource 失败:", e);
        this.sourceNode = null;
      }
    },
    playChange(action) {
      let selectedMedia = this.MaterialMediaObjectData.find(
        (media) => media.FileUrl === this.fileSelectCheck.FileUrl
      );

      this.socket.emit("toggle-audio-playback", {
        roomId: this.roomId,
        action,
        selectedMedia: selectedMedia,
      });

      // 教师端本地立即执行，不依赖 socket 回调
      this.handleAudioControl(action);
    },

    async playAudio(offset = 0) {
      console.log(`[Audio] playAudio(${offset?.toFixed(2)}) 開始 | audioCtx.state=${this.audioCtx?.state} | audioBuffer=${!!this.audioBuffer}`);
      // 此函數在用戶手勢上下文中調用（老師點擊播放按鈕），可安全 await resume()
      // await 確保 AudioContext 完全恢復後再播放，解決偶現無聲問題
      if (this.audioCtx && this.audioCtx.state === "suspended") {
        await this.audioCtx.resume().catch(() => {});
        console.log(`[Audio] AudioContext resume 後狀態: ${this.audioCtx?.state}`);
      }
      // 重置取消標記，並記錄本次播放的意圖 ID
      this._playAborted = false;
      const playId = ++this._playIntentionId;
      console.log(`[Audio] playAudio playId=${playId}, 等待 300ms 靜音麥克風...`);
      // 先靜音麥克風，等待 Agora setEnabled(false) 生效後再開始播放（300ms 確保回音消除生效）
      this.$emit("audioPlayStart");
      await new Promise(resolve => setTimeout(resolve, 300));
      // 若 300ms 等待期間已被停止或有新的播放請求，放棄本次啟動
      console.log(`[Audio] 300ms 後 | _playAborted=${this._playAborted} | playId=${playId} | _playIntentionId=${this._playIntentionId}`);
      if (this._playAborted || playId !== this._playIntentionId) {
        console.warn(`[Audio] playAudio 被中止! _playAborted=${this._playAborted}, playId=${playId}, _playIntentionId=${this._playIntentionId}`);
        this.$emit("audioPlayStop");
        return;
      }
      if (!this.audioBuffer) {
        console.error("[Audio] playAudio: 300ms 等待後 audioBuffer 仍為 null，放棄播放");
        this.$emit("audioPlayStop");
        return;
      }
      console.log(`[Audio] createSource(${offset?.toFixed(2)}) | audioBuffer.duration=${this.audioBuffer?.duration?.toFixed(2)}`);
      this.createSource(offset);
      console.log(`[Audio] createSource 完成 | sourceNode=${!!this.sourceNode}`);
      if (!this.sourceNode) {
        console.error("[Audio] createSource 失敗：sourceNode 未設定，放棄");
        this.$emit("audioPlayStop");
        return;
      }
      this.mediaPlayStatus = true;
      this.mediaStopStatus = true;
      this.isPaused = false;
    },

    pauseAudio() {
      console.log(`[Audio] pauseAudio() 被呼叫 | sourceNode=${!!this.sourceNode} | 呼叫堆疊:`, new Error().stack);
      // 標記取消，防止 playAudio 的 300ms 延遲結束後仍啟動播放
      this._playAborted = true;
      if (!this.sourceNode) return;

      this.pauseTime = this.audioCtx.currentTime;
      this.mediaCurrentDuration = this.pauseTime - this.startTime;
      this._safeStopNode(this.sourceNode);
      this.sourceNode = null;
      this.mediaPlayStatus = false;
      this.isPaused = true;
      this.$emit("audioPlayStop");
    },

    stopAudio() {
      console.log(`[Audio] stopAudio() 被呼叫 | mediaPlayStatus=${this.mediaPlayStatus} | 呼叫堆疊:`, new Error().stack);
      // 標記取消，防止 playAudio 的 300ms 延遲結束後仍啟動播放
      this._playAborted = true;
      if (this.sourceNode) {
        this._safeStopNode(this.sourceNode);
        this.sourceNode = null;
      }
      this.mediaPlayStatus = false;
      this.mediaStopStatus = false;
      this.isPaused = false;
      this.$emit("audioPlayStop");
      this.mediaCurrentDuration = 0;
      cancelAnimationFrame(this.timeUpdateRAF);
    },

    // onAudioPlay() {
    //   // play or resume audio from paused offset
    //   if (this.isPaused) {
    //     this.playAudio(this.elapsedTime); // resume from paused position
    //   } else {
    //     this.playAudio(0); // play from start
    //   }
    // },

    // onAudioPause() {
    //   this.pauseAudio();
    // },

    // onAudioStop() {
    //   this.stopAudio();
    // },

    handleAudioControl(action) {
      console.log(`[Audio] handleAudioControl("${action}") | audioBuffer=${!!this.audioBuffer} | isPaused=${this.isPaused} | mediaCurrentDuration=${this.mediaCurrentDuration?.toFixed(2)} | mediaPlayStatus=${this.mediaPlayStatus}`);
      if (action === "play") {
        const offset = this.isPaused ? (this.mediaCurrentDuration || 0) : 0;
        if (!this.audioBuffer) {
          // buffer 尚未就緒，設定 pending 等 loadAudioBuffer 完成後自動播放
          console.warn("[Audio] handleAudioControl: audioBuffer 未就緒，設定 pendingAudioPlay");
          this.pendingAudioPlay = true;
          this.pendingAudioOffset = offset;
          return;
        }
        if (this.isPaused) {
          console.log(`[Audio] 從暫停位置恢復: offset=${offset?.toFixed(2)}s, totalDuration=${this.mediaTotalDuration?.toFixed(2)}s`);
        }
        this.playAudio(offset);
      } else if (action === "pause") {
        this.pendingAudioPlay = false;
        this.pauseAudio();
      } else if (action === "stop") {
        this.pendingAudioPlay = false;
        this.stopAudio();
      }
    },

    updatePlaybackTime() {
      // 取消舊的 RAF 循環，防止多個循環並行導致 currentTime 計算混亂
      cancelAnimationFrame(this.timeUpdateRAF);
      const update = () => {
        if (this.sourceNode && this.mediaPlayStatus) {
          const currentTime = this.audioCtx.currentTime - this.startTime;
          this.handleTimeUpdate(currentTime);
          this.timeUpdateRAF = requestAnimationFrame(update);
        }
      };
      this.timeUpdateRAF = requestAnimationFrame(update);
    },

    handleTimeUpdate(currentTime) {
      if (typeof currentTime !== "number") currentTime = 0;

      // 本地 UI 保持高頻更新（進度條流暢）
      this.mediaCurrentDuration = currentTime;
      if (!this.isDraggingSlider) {
        this.mediaSlider = (currentTime / this.mediaTotalDuration) * 100;
      }

      // Socket 限流：每秒最多發送一次，避免其他端收到 60fps 事件導致 UI 卡頓
      const now = Date.now();
      if (!this._lastAudioTimeEmit || now - this._lastAudioTimeEmit >= 1000) {
        this._lastAudioTimeEmit = now;
        this.waitForSocketAndRun(this, () => {
          this.socket.emit("audioTimeUpdate", {
            roomId: String(this.roomId),
            time: currentTime,
            socketId: this.socket.id,
          });
        });
      }
    },

    inputTimeUpdate(sliderValue) {
      const seekTime = (sliderValue / 100) * this.mediaTotalDuration;
      if (this.mediaPlayStatus) {
        this.createSource(seekTime); // resumes playback
      } else {
        // Just update internal state without playback
        this.mediaCurrentDuration = seekTime;
        this.mediaSlider = (seekTime / this.mediaTotalDuration) * 100;
      }

      this.socket.emit("audioTimeUpdate", {
        roomId: String(this.roomId),
        currentValue: seekTime,
        socketId: this.socket.id,
      });
    },

    handleSliderTouchStart() {
      this.isDraggingSlider = true;
    },

    handleSliderTouchEnd() {
      this.userInitiatedUpdate = true;
      const currentValue = this.currentTime;
      this.isDraggingSlider = false;
      this.inputTimeUpdate(this.mediaSlider);
      this.socket.emit("audioCurrentTime", {
        roomId: String(this.roomId),
        currentValue: currentValue,
      });
    },

    // onAudioPlay() {
    //   let selectedMedia = this.MaterialMediaObjectData.find(
    //     (media) => media.FileUrl === this.fileSelectCheck.FileUrl
    //   );

    //   this.socket.emit("toggle-audio-playback", {
    //     roomId: String(this.roomId),
    //     data: {
    //       action: "play",
    //       selectedMedia: selectedMedia,
    //     },
    //   });
    // },
    // onAudioPause() {
    //   this.socket.emit("toggle-audio-playback", {
    //     roomId: String(this.roomId),
    //     data: {
    //       action: "pause",
    //     },
    //   });
    // },
    // onAudioStop() {
    //   this.socket.emit("toggle-audio-playback", {
    //     roomId: String(this.roomId),
    //     data: {
    //       action: "stop",
    //     },
    //   });
    // },
    // stopAudio() {
    //   this.$refs.audio.pause();
    //   this.$refs.audio.currentTime = 0;
    //   this.mediaSlider = 0;
    // },
    toggleAudioPlayback(action, data) {
      let audioElement = document.getElementById("main_audio");
      if (action === "play") {
        audioElement.play().catch(() => {});
        $("#media-stop-btn").removeClass("disabled");
        this.mediaStopStatus = true;
        this.mediaPlayStatus = true;
      } else if (action === "pause") {
        audioElement.pause();
        this.mediaPlayStatus = false;
      } else {
        this.stopAudio();
        this.mediaPlayStatus = false;
        this.mediaStopStatus = false;
        $("#media-stop-btn").addClass("disabled");
      }
    },
    getMaterialMediaObjectData() {
      if (this.$store.state.MaterialMediaObject.length > 0) {
        this.MaterialMediaObjectData = JSON.parse(
          JSON.stringify(this.$store.state.MaterialMediaObject)
        );
        this.fileSelectList[0].list = this.MaterialMediaObjectData;
      }
      console.log("MaterialMediaObjectData", this.MaterialMediaObjectData);
    },
    getMaterialVedioObjectData() {
      if (this.$store.state.MaterialVedioObject.length > 0) {
        this.MaterialVedioObjectData = JSON.parse(
          JSON.stringify(this.$store.state.MaterialVedioObject)
        );
        this.fileSelectList[1].list = this.MaterialVedioObjectData;
      }
      console.log("MaterialVedioData", this.MaterialVedioObjectData);
    },
    getMaterialObjectData() {
      if (this.$store.state.MaterialObject.length > 0) {
        // 初始化 MaterialObjectData：從 store 取得原始教材列表
        // 注意：新增的空白頁由 DB 序列或 getNewMaterial socket 後續補充，此處僅載入原始頁
        {
          if (this.$store.state.MaterialObject.length > 10) {
            let limit = 10;
            this.MaterialObjectData = this.$store.state.MaterialObject.slice(
              0,
              limit
            );
            this.mediaLengthNum = this.MaterialObjectData.length;
          } else {
            this.MaterialObjectData = this.$store.state.MaterialObject;
            this.mediaLengthNum = this.MaterialObjectData.length;
          }
        }
        // 查詢是否有插入頁的序列記錄，有則覆蓋本地列表
        // 先樂觀設為 true，防止 getNewMaterial 在 GET 回應前觸發的 race condition；
        // 若 GET 返回空或失敗則重設，讓 getNewMaterial 作為後備
        this.sequenceRestoredFromDB = true;
        this.$axios.get(`/materialmodel/sequence/${this.roomId}`)
          .then((res) => {
            if (!res.data.error && res.data.payload && res.data.payload.length > 0) {
              this.MaterialObjectData = res.data.payload;
              this.mediaLengthNum = res.data.payload.length;
              // sequenceRestoredFromDB 已在 GET 發出前設為 true，維持不變
            } else {
              // DB 沒有序列記錄，允許 getNewMaterial 作為後備
              this.sequenceRestoredFromDB = false;
            }
            this.preLoadMaterials(this.MaterialObjectData);
            if (process.env.VUE_APP_RUN_STATE == "local") {
              this.updateUrls();
              console.log("MaterialObjectData", this.MaterialObjectData);
            }
          })
          .catch(() => {
            // GET 失敗，允許 getNewMaterial 作為後備
            this.sequenceRestoredFromDB = false;
            this.preLoadMaterials(this.MaterialObjectData);
            if (process.env.VUE_APP_RUN_STATE == "local") {
              this.updateUrls();
              console.log("MaterialObjectData", this.MaterialObjectData);
            }
          });
      } else {
        this.nextPageStatus = true;
        this.lastPageStatus = true;
        this.previousPageStatus = true;
        this.frontPageStatus = true;

        $("#frontPage, #previousPage, #nextPage, #lastPage").css({
          "pointer-events": "none",
          cursor: "not-allowed",
        });
        this.notificationMaterial();
      }
      console.log("MaterialObjectData", this.MaterialObjectData);
    },
    preLoadMaterials(materials) {
      materials.forEach((material) => {
        const url = material.FileUrl;
        if (url && url.length > 0) {
          if (!document.querySelector(`link[data-preload-url="${url}"]`)) {
            const link = document.createElement("link");
            link.rel = "preload";
            link.as = "image";
            link.href = url;

            link.setAttribute("data-preload-url", url);
            document.head.appendChild(link);
          }
        }
      });
      console.log(`Preloaded ${materials.length} material image URLs.`);
    },
    loadData() {
      this.initialMilliSec = this.milliseconds;
      this.initialHour = new Date().getHours();
      this.getMaterialMediaObjectData();
      this.getMaterialVedioObjectData();
      this.getMaterialObjectData();
    },
    onChangeVedioMedia() {
      this.mediaVedioSelected = this.fileSelectCheck.FileUrl;
      this.mediaVideoNameSelected = this.fileSelectCheck.FileName;
      console.log("MEDIA VIDEO SELECTED:" + this.mediaVedioSelected);

      let selectedVideoMedia = this.MaterialVedioObjectData.find(
        (media) => media.FileUrl === this.fileSelectCheck.FileUrl
      );

      if (selectedVideoMedia) {
        this.$refs.video.currentTime = 0.01;
        this.socket.emit("send-material-video-media", {
          roomId: String(this.roomId),
          selectedVideoMedia: selectedVideoMedia,
        });
      }
    },
    onChangeMedia() {
      this.mediaSelected = this.fileSelectCheck.FileUrl;
      let selectedMedia = this.MaterialMediaObjectData.find(
        (media) => media.FileUrl === this.fileSelectCheck.FileUrl
      );

      if (selectedMedia) {
        this.socket.emit("send-material-media", {
          roomId: String(this.roomId),
          selectedMedia: selectedMedia,
        });
      }

      this.audioUrl = this.mediaSelected;
      this.mediaTotalDuration = 0;
      this.mediaCurrentDuration = 0;
      this.mediaSlider = 0;
      this.isPaused = false;
      // 切換媒體時重置播放狀態，確保按鈕顯示「播放」而非「暫停」
      this.mediaPlayStatus = false;
      this.mediaStopStatus = false;
      this.pendingAudioPlay = false;
      this.loadAudioBuffer();
    },

    //----------Whiteboard------------//
    handleTools(toolsname, idx) {
      switch (toolsname) {
        case "stamp":
          this.showStamp = !this.showStamp;
          break;
        default:
          break;
      }
    },
    showBasicAlert(html, newOptions) {
      var options = {
        header: "INFO MESSAGE",
        okBtnText: "Ok",
        headercolor: "#d25d5d",
        hideAfter: false,
        onOkClick: false,
      };
      if (newOptions) {
        for (var i in newOptions) {
          options[i] = newOptions[i];
        }
      }
      var alertHtml = $(
        '<div class="basicalert" style="position:absolute; left:0px; width:100%; top:70px; font-family: monospace;">' +
          '<div style="width: 30%; margin: auto; background: #aaaaaa; border-radius: 5px; font-size: 1.2em; border: 1px solid gray;">' +
          '<div style="border-bottom: 1px solid #676767; background: ' +
          options["headercolor"] +
          '; padding-left: 5px; font-size: 0.8em;">' +
          options["header"] +
          '<div style="float: right; margin-right: 4px; color: #373737; cursor: pointer;" class="closeAlert">x</div></div>' +
          '<div style="padding: 10px;" class="htmlcontent"></div>' +
          '<div style="height: 20px; padding: 10px;"><button class="modalBtn okbtn" style="float: right;">' +
          options["okBtnText"] +
          "</button></div>" +
          "</div>" +
          "</div>"
      );
      alertHtml.find(".htmlcontent").append(html);
      $("body").append(alertHtml);
      alertHtml
        .find(".okbtn")
        .off("click")
        .click(function () {
          if (options.onOkClick) {
            options.onOkClick();
          }
          alertHtml.remove();
        });
      alertHtml
        .find(".closeAlert")
        .off("click")
        .click(function () {
          alertHtml.remove();
        });

      if (options.hideAfter) {
        setTimeout(function () {
          alertHtml.find(".okbtn").click();
        }, 1000 * options.hideAfter);
      }
    },
    initWhiteBoard() {
      ReadOnlyService.activateReadOnlyMode();

      if (urlParams.get("webdav") === "true") {
        $("#uploadWebDavBtn").show();
      }

      whiteboard.loadWhiteboard("#whiteboardContainer", {
        //Load the whiteboard
        whiteboardId: whiteboardId,
        username: btoa(encodeURIComponent(this.myUsername)),
        backgroundGridUrl: "./images/" + ConfigService.backgroundGridImage,
        sendFunction: (content) => {
          if (ReadOnlyService.readOnlyActive) return;
          content["at"] = this.accessToken;
          signaling_socket.emit("drawToWhiteboard", content);
          InfoService.incrementNbMessagesSent();
          // 实际绘图操作触发防抖自动保存（排除 cursor 移动）
          if (content.t && content.t !== "cursor") {
            this.autoSaveDirty = true;
            this.debouncedAutoSave();
          }
        },
      });

      $.get(this.subdir + "/api/loadwhiteboard", {
        wid: whiteboardId,
        at: this.accessToken,
      }).done(function (data) {
        whiteboard.loadData(data);
        if (this.copyfromwid && data.length == 0) {
          $.get(this.subdir + "/api/loadwhiteboard", {
            wid: this.copyfromwid,
            at: this.accessToken,
          }).done(function (data) {
            whiteboard.loadData(data);
          });
        }
      });

      $(window).resize(function () {
        signaling_socket.emit("updateScreenResolution", {
          at: this.accessToken,
          windowWidthHeight: { w: $(window).width(), h: $(window).height() },
        });
      });

      $("#whiteboardUnlockBtn").hide();
      $("#whiteboardLockBtn").show();

      if (!localStorage.getItem("savedColors")) {
        localStorage.setItem(
          "savedColors",
          JSON.stringify([
            "rgba(0, 0, 0, 1)",
            "rgba(255, 255, 255, 1)",
            "rgba(255, 0, 0, 1)",
            "rgba(0, 255, 0, 1)",
            "rgba(0, 0, 255, 1)",
            "rgba(255, 255, 0, 1)",
            "rgba(255, 0, 255, 1)",
          ])
        );
      }

      this.intColorPicker();
      this.intBgColorPicker();

      // on startup select mouse
      shortcutFunctions.setTool_mouse();
      // fix bug cursor not showing up
      whiteboard.refreshCursorAppearance();

      if (process.env.NODE_ENV === "production") {
        if (ConfigService.readOnlyOnWhiteboardLoad)
          ReadOnlyService.activateReadOnlyMode();
        else ReadOnlyService.deactivateReadOnlyMode();
      } else {
        // in dev
        ReadOnlyService.deactivateReadOnlyMode();
        // InfoService.displayInfo();
      }

      // In any case, if we are on read-only whiteboard we activate read-only mode
      if (ConfigService.isReadOnly) ReadOnlyService.activateReadOnlyMode();
    },
    whiteboardTrashBtn(e) {
      $("#whiteboardTrashBtnConfirm").show().focus();
      $(e.currentTarget).hide();
    },
    whiteboardTrashBtnConfirm(e) {
      $(e.currentTarget).hide();
      $("#whiteboardTrashBtn").show();
      whiteboard.clearWhiteboard();
      // 清空白板时重置自动保存状态
      this.autoSaveDirty = false;
      this.lastSavedDrawBufferLength = 0;
      if (this.debouncedAutoSave && this.debouncedAutoSave.cancel) {
        this.debouncedAutoSave.cancel();
      }
    },
    whiteboardTrashBtnConfirmHide(e) {
      $(e.currentTarget).hide();
      $("#whiteboardTrashBtn").show();
    },
    whiteboardLockBtn() {
      ReadOnlyService.deactivateReadOnlyMode();
    },
    whiteboardUnlockBtn() {
      ReadOnlyService.activateReadOnlyMode();
    },
    async whiteboardSwitch(e) {
      await this.saveToDbAsJson("saving");
      var activeTool = $(e.currentTarget).attr("tool");

      if (activeTool === "move") {
        if (this.currentTool != activeTool) whiteboard.setMove("move");
      } else {
        whiteboard.setTool(activeTool);
      }

      if (this.currentTool != activeTool) {
        if (this.currentTool === "move") {
        }
        this.currentTool = activeTool;
      }

      if (activeTool == "mouse" || activeTool == "recSelect") {
        $(".activeToolIcon").empty();
      } else {
        $(".activeToolIcon").html($(e.currentTarget).html()); //Set Active icon the same as the button icon
      }

      if (activeTool == "stamp") {
        this.showStamp = !this.showStamp;
      }

      if (activeTool == "text" || activeTool == "stickynote") {
        $("#textboxBackgroundColorPickerBtn").show();
      } else {
        $("#textboxBackgroundColorPickerBtn").hide();
      }
      let savedThickness = localStorage.getItem("item_thickness_" + activeTool);
      if (savedThickness) {
        whiteboard.setStrokeThickness(savedThickness);
        $("#whiteboardThicknessSlider").val(savedThickness);
      }
    },
    showOnOffMenuStamps(e) {
      this.showStamp = !this.showStamp;
    },
    addImgToCanvasBtn() {
      if (ReadOnlyService.readOnlyActive) return;
      this.showBasicAlert(`Please drag the image into the browser.<br>
                Or upload here: <input type="file" id="manualFileUpload" name="myfile" />`);
      document.getElementById("manualFileUpload").addEventListener(
        "change",
        (e) => {
          $(".basicalert").remove();
          if (ReadOnlyService.readOnlyActive) return;
          e.originalEvent = { dataTransfer: { files: e.target.files } };
          this.handleFileUploadEvent(e);
        },
        false
      );
    },
    handleStamps(toolsname, idx) {
      this.svgUrl =
        `${process.env.VUE_APP_STAMP_URL}` + "/stamp/" + toolsname + ".png";
      whiteboard.addImgToCanvasByUrl(String(this.svgUrl));
      console.log("Image uploaded!");
    },
    handleTest() {
      whiteboard.addImgToCanvasByUrl(
        `${process.env.VUE_APP_SOCKET_URL}:8096` +
          "/images/stamp/Keep_It_Up.png"
      );
    },
    saveAsImageBtn(type, obj) {
      console.log("saveAsImageBtn");
      whiteboard.getImageDataBase64(
        {
          imageFormat: ConfigService.imageDownloadFormat,
          drawBackgroundGrid: ConfigService.drawBackgroundGrid,
        },
        (imgData) => {
          this.imageBase64 = imgData;
          this.uploadMaterialRecord(type, obj);
        }
      );
    },
    saveAsJSONBtn() {
      var imgData = whiteboard.getImageDataJson();
      var w = window.open("about:blank"); //Firefox will not allow downloads without extra window
      setTimeout(function () {
        //FireFox seems to require a setTimeout for this to work.
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(
          new Blob([imgData], { type: "text/json" })
        );
        this.jsonFileUrl = a.href;
        a.download = "whiteboard.json";
        w.document.body.appendChild(a);
        a.click();
        w.document.body.removeChild(a);
        setTimeout(function () {
          w.close();
        }, 100);
      }, 200);
    },
    async saveToDbAsJson(type) {
      var imgData = whiteboard.getImageDataJson();

      if (imgData && this.prevMaterialFileUrl != undefined && imgData != "") {
        this.isLoading = true;
        this.uploadJsonData = {
          classRoomID: this.$store.state.classRoomId,
          materialCode: this.MaterialCode,
          materialUnit: this.MaterialUnit,
          materialPage: this.MaterialUnitPage,
          materialFileName: this.MaterialFileName,
          materialName: this.MaterialName,
          jsonString: imgData,
          fileUrl: this.fileUrl,
          englishName: this.EnglishFileName,
          chineseName: this.ChineseFileName,
          version: 3,
        };
        this.uploadJsonTeacherMedia(type);
        // 重置自动保存状态，避免重复保存
        this.autoSaveDirty = false;
        this.lastSavedDrawBufferLength = whiteboard.drawBuffer.length;
        if (this.debouncedAutoSave && this.debouncedAutoSave.cancel) {
          this.debouncedAutoSave.cancel();
        }
      }
    },
    async autoSaveToDb() {
      if (!this.autoSaveDirty) return;
      if (!this.MaterialCode || !this.MaterialUnitPage || !this.MaterialFileName) return;

      var imgData = whiteboard.getImageDataJson();
      if (!imgData || imgData === "" || this.prevMaterialFileUrl === undefined) return;
      if (whiteboard.drawBuffer.length === this.lastSavedDrawBufferLength) {
        this.autoSaveDirty = false;
        return;
      }

      this.autoSaveDirty = false;
      this.lastSavedDrawBufferLength = whiteboard.drawBuffer.length;

      this.uploadJsonData = {
        classRoomID: this.$store.state.classRoomId,
        materialCode: this.MaterialCode,
        materialUnit: this.MaterialUnit,
        materialPage: this.MaterialUnitPage,
        materialFileName: this.MaterialFileName,
        materialName: this.MaterialName,
        jsonString: imgData,
        fileUrl: this.fileUrl,
        englishName: this.EnglishFileName,
        chineseName: this.ChineseFileName,
        version: 3,
      };
      this.uploadJsonTeacherMedia("saving");
    },
    async uploadJsonTeacherMedia(type, retryCount = 0) {
      this.$store
        .dispatch("uploadJsonTeacherMedia", this.uploadJsonData)
        .then(() => {
          // 第一步：空白頁狀態已在 pageChange("newPage") 同步更新，此處無需重複

          // 第二步：持久化序列（splice 已在 pageChange 同步完成）
          if (this.loadNewPage) {
            this.loadNewPage = false;
            // 將插入後的完整序列持久化到後端
            this.saveInsertedPageSequence();
          }

          // 第三步：通知其他端（使用快照避免讀到切頁後更新的 live state）
          if (type === "newPage" && this._newPageSnapshot) {
            const snap = this._newPageSnapshot;
            this.socket.emit("updateNewMaterial", {
              roomId: String(this.roomId),
              prevIndexGlobal: snap.prevIndexGlobal,
              nextIndexGlobal: snap.nextIndexGlobal,
              currentIndexGlobal: snap.currentIndexGlobal,
              newMaterial: snap.newMaterialData,
            });
            // 只有仍在空白頁時才隱藏 loading 遮罩並更新畫布
            // 若已切換到其他頁，不可搶先隱藏遮罩（其他頁的 JSON 可能尚未載入完成）
            if (this.currentIndexGlobal === snap.currentIndexGlobal) {
              $("#loadingMedia").css({ display: "none", zIndex: "0" });
              this.socket.emit("setCurrentIndexGlobal", {
                roomId: String(this.roomId),
                index: this.currentIndexGlobal,
              });
              this.setupCanvasAndResizeElements("100%", "100%");
            }
            delete this._newPageSnapshot;
          }
        })
        .catch((error) => {
          if (retryCount < 5) {
            const delay = 1000 * (retryCount + 1); // 1s, 2s, 3s
            setTimeout(() => {
              this.uploadJsonTeacherMedia(type, retryCount + 1);
            }, delay);
          } else {
            this.retryJsonList.push(this.uploadJsonData);
            this.uploadNotificationError();
          }
        });
    },
    // 將當前 MaterialObjectData 序列（含插入頁）持久化到後端
    async saveInsertedPageSequence() {
      try {
        await this.$axios.post("/materialmodel/sequence", {
          classRoomID: String(this.$store.state.classRoomId),
          sequence: this.MaterialObjectData,
        });
      } catch (e) {
        // 非關鍵操作，靜默失敗
      }
    },
    async uploadJsonToDatabase(item, index, retryCount = 0) {
      this.$store
        .dispatch("uploadJsonTeacherMedia", item)
        .then(() => {
          console.log("uploadJsonToDatabase");
          this.retryJsonList.splice(index, 1);
        })
        .catch((error) => {
          if (retryCount < 5) {
            const delay = 1000 * (retryCount + 1); // 1s, 2s, 3s
            setTimeout(() => {
              this.uploadJsonToDatabase(item, index, retryCount + 1);
            }, delay);
          } else {
            this.retryJsonList.push(this.uploadJsonData);
            this.uploadNotificationError();
          }
        });
    },
    async uploadNotificationError() {
      this.$toast.error(
        {
          component: NotificationUpload,
          props: {
            status: "Error Upload Data",
            desc: "Click to retry",
          },
          listeners: {
            retryUpload: () => {
              if (this.retryJsonList.length > 0) {
                this.retryJsonList.forEach((item, index) => {
                  this.uploadJsonToDatabase(item, index);
                });
              }
            },
          },
        },
        {
          position: "top-right",
          timeout: false,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        }
      );
    },
    async uploadMaterialRecord(type, obj) {
      var checkIsImage = await this.isBase64UrlImage(this.imageBase64);
      if (checkIsImage) {
        this.$store
          .dispatch("uploadMaterialRecord", {
            ClassroomId: obj.ClassroomId,
            MaterialCode: obj.MaterialCode,
            MaterialUnit: obj.MaterialUnit,
            MaterialPage: obj.MaterialPage,
            MaterialFileName: obj.MaterialFileName,
            ImageInBase64: obj.ImageInBase64,
          })
          .then((response) => {
            console.log("Upload Material Record", response);
          });
      }
    },
    notificationMaterial() {
      this.$toast.error(
        {
          component: NotificationMaterialUpload,
        },
        {
          position: "top-right",
          timeout: false,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        }
      );
    },
    createImageFromJSON(jsonData) {
      const data = JSON.parse(jsonData);
      const canvas = document.createElement("canvas");
      canvas.width = data.width;
      canvas.height = data.height;
      const ctx = canvas.getContext("2d");

      const imageData = ctx.createImageData(data.width, data.height);

      for (let i = 0; i < data.pixels.length; i += 3) {
        imageData.data[i] = data.pixels[i];
        imageData.data[i + 1] = data.pixels[i + 1];
        imageData.data[i + 2] = data.pixels[i + 2];
        imageData.data[i + 3] = 255; // Alpha value (255 means fully opaque)
      }

      ctx.putImageData(imageData, 0, 0);
    },
    uploadWebDavBtn() {
      if ($(".webdavUploadBtn").length > 0) {
        return;
      }

      var webdavserver = localStorage.getItem("webdavserver") || "";
      var webdavpath = localStorage.getItem("webdavpath") || "/";
      var webdavusername = localStorage.getItem("webdavusername") || "";
      var webdavpassword = localStorage.getItem("webdavpassword") || "";
      var webDavHtml = $(
        `<div>
                        <table>
                            <tr>
                                <td>Server URL:</td>
                                <td><input class="webdavserver" type="text" value="${webdavserver}" placeholder="https://yourserver.com/remote.php/webdav/"></td>
                                <td></td>
                            </tr>
                        <tr>
                            <td>Path:</td>
                            <td><input class="webdavpath" type="text" placeholder="folder" value="${webdavpath}"></td>
                            <td style="font-size: 0.7em;"><i>path always have to start & end with "/"</i></td>
                        </tr>
                        <tr>
                            <td>Username:</td>
                            <td><input class="webdavusername" type="text" value="${webdavusername}" placeholder="username"></td>
                            <td style="font-size: 0.7em;"></td>
                        </tr>
                        <tr>
                            <td>Password:</td>
                            <td><input class="webdavpassword" type="password" value="${webdavpassword}" placeholder="password"></td>
                            <td style="font-size: 0.7em;"></td>
                        </tr>
                        <tr>
                            <td style="font-size: 0.7em;" colspan="3">
                                Note: You have to generate and use app credentials if you have 2 Factor Auth activated on your dav/nextcloud server!
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td colspan="2">
                                <span class="loadingWebdavText" style="display:none;">Saving to webdav, please wait...</span><button class="modalBtn webdavUploadBtn"><i class="fas fa-upload"></i> Start Upload</button>
                            </td>
                        </tr>
                        </table>
                    </div>`
      );
      webDavHtml
        .find(".webdavUploadBtn")
        .off("click")
        .click(function () {
          var webdavserver = webDavHtml.find(".webdavserver").val();
          localStorage.setItem("webdavserver", webdavserver);
          var webdavpath = webDavHtml.find(".webdavpath").val();
          localStorage.setItem("webdavpath", webdavpath);
          var webdavusername = webDavHtml.find(".webdavusername").val();
          localStorage.setItem("webdavusername", webdavusername);
          var webdavpassword = webDavHtml.find(".webdavpassword").val();
          localStorage.setItem("webdavpassword", webdavpassword);
          whiteboard.getImageDataBase64(
            {
              imageFormat: ConfigService.imageDownloadFormat,
              drawBackgroundGrid: ConfigService.drawBackgroundGrid,
            },
            function (base64data) {
              var webdavaccess = {
                webdavserver: webdavserver,
                webdavpath: webdavpath,
                webdavusername: webdavusername,
                webdavpassword: webdavpassword,
              };
              webDavHtml.find(".loadingWebdavText").show();
              webDavHtml.find(".webdavUploadBtn").hide();
              saveWhiteboardToWebdav(base64data, webdavaccess, function (err) {
                if (err) {
                  webDavHtml.find(".loadingWebdavText").hide();
                  webDavHtml.find(".webdavUploadBtn").show();
                } else {
                  webDavHtml.parents(".basicalert").remove();
                }
              });
            }
          );
        });
      this.showBasicAlert(webDavHtml, {
        header: "Save to Webdav",
        okBtnText: "cancel",
        headercolor: "#0082c9",
      });
      dom.i2svg();
    },
    uploadJsonBtn() {
      $("#myFile").click();
    },
    loadJson() {
      var file = document.getElementById("myFile").files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          var j = JSON.parse(e.target.result);
          whiteboard.loadJsonData(j);
        } catch (e) {
          showBasicAlert("File was not a valid JSON!");
        }
      };
      reader.readAsText(file);
      $(this).val("");
    },
    async loadJsonFromDatabase(classroomId, englishName, materialUnit, materialPage, type, fallbackImg, imgTempId) {
      // 空值保护：防止 URL 出现空路径段
      var safeUnit = materialUnit || "none";
      var safePage = materialPage || "none";
      var safeName = englishName || "none";
      try {
        const response = await this.$axios.get(
          `/materialmodel/json/load/${encodeURIComponent(classroomId)}/${encodeURIComponent(safeName)}/${encodeURIComponent(safeUnit)}/${encodeURIComponent(safePage)}`
        );

        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          // 先确认有数据再 clearWhiteboard
          whiteboard.clearWhiteboard(() => {
            whiteboard.loadJsonData(response.data, true, () => {
              if (type != "firstLoad") {
                this.socket.emit("setLoadJsonFromDatabase", {
                  roomId: classroomId,
                  englishName: englishName,
                  materialUnit: materialUnit,
                  materialPage: materialPage,
                  type: type,
                  sendState: false,
                });
              }
              // 所有类型都要隐藏遮罩 + 恢复按钮（原来只对 "new" 类型生效，导致切回第一页时卡住）
              $("#loadingMedia").css({ display: "none", zIndex: "0" });
              $(".pageChange").removeAttr("style");
              this.setImageToCenter();
            });
          });
        } else {
          // 此頁無 JSON 繪圖資料（空陣列或格式不符）→ 回退到教材背景圖，防止 loading 遮罩卡住按鈕
          if (fallbackImg) {
            this.setBackgroundDynamic4(fallbackImg, imgTempId, type);
            this.currentBackgroundImage = fallbackImg;
          } else {
            whiteboard.clearWhiteboard();
            $("#loadingMedia").css({ display: "none", zIndex: "0" });
            this.pageButtonSet(type);
            this.pageChangeSet();
          }
        }
      } catch (error) {
        // 404 = 此页无数据，不重试
        console.log("loadJsonFromDatabase: 此页无绘图数据", error?.response?.status);
        // 无 JSON 数据 → 回退到教材背景图
        if (fallbackImg) {
          this.setBackgroundDynamic4(fallbackImg, imgTempId, type);
          this.currentBackgroundImage = fallbackImg;
        } else {
          // 無背景圖（如 NewPage）：清空畫布並恢復完整狀態
          whiteboard.clearWhiteboard();
          $("#loadingMedia").css({ display: "none", zIndex: "0" });
          this.pageButtonSet(type);
          // pageButtonSet 沒有處理 "new" type，補上 pageChangeSet 確保按鈕恢復
          this.pageChangeSet();
        }
      }
    },
    async loadJsonFromDatabaseClient(
      classroomId,
      englishName,
      materialUnit,
      materialPage,
      type,
      sendState = true,
      callback
    ) {
      // 空值保护
      var safeUnit = materialUnit || "none";
      var safePage = materialPage || "none";
      var safeName = englishName || "none";
      console.log(
        "loadJsonFromDatabaseClient",
        classroomId,
        safeName,
        safeUnit,
        safePage
      );

      try {
        const response = await this.$axios.get(
          `/materialmodel/json/load/${encodeURIComponent(classroomId)}/${encodeURIComponent(safeName)}/${encodeURIComponent(safeUnit)}/${encodeURIComponent(safePage)}`
        );

        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          whiteboard.clearSelfWhiteboard();
          whiteboard.loadJsonData(response.data, true, () => {
            if (callback) callback(this.imageExists(response.data));
          });
        } else {
          if (callback) callback(false);
        }
      } catch (error) {
        // 404 = 此页无数据
        console.log("loadJsonFromDatabaseClient: 此页无绘图数据", error?.response?.status);
        if (callback) callback(false);
      }
    },
    imageExists(content) {
      if (content && Array.isArray(content)) {
        return content.some(
          (item) => item && item["t"] === "addImgContentAsBG"
        );
      }
      return false;
    },
    shareWhiteboardBtn() {
      function urlToClipboard(whiteboardId = null) {
        const { protocol, host, pathname, search } = window.location;
        const basePath = `${protocol}//${host}${pathname}`;
        const getParams = new URLSearchParams(search);
        getParams.delete("username");

        if (whiteboardId) {
          // override whiteboardId value in URL
          getParams.set("whiteboardid", whiteboardId);
        }

        const url = `${basePath}?${getParams.toString()}`;
        $("<textarea/>")
          .appendTo("body")
          .val(url)
          .select()
          .each(() => {
            document.execCommand("copy");
          })
          .remove();
      }
      $("#shareWhiteboardDialogMessage").toggleClass("displayNone", true);

      $("#shareWhiteboardDialog").toggleClass("displayNone", false);
      $("#shareWhiteboardDialogGoBack")
        .off("click")
        .click(() => {
          $("#shareWhiteboardDialog").toggleClass("displayNone", true);
        });

      $("#shareWhiteboardDialogCopyReadOnlyLink")
        .off("click")
        .click(() => {
          urlToClipboard(ConfigService.correspondingReadOnlyWid);

          $("#shareWhiteboardDialogMessage")
            .toggleClass("displayNone", false)
            .text("Read-only link copied to clipboard ✓");
        });

      $("#shareWhiteboardDialogCopyReadWriteLink")
        .toggleClass("displayNone", ConfigService.isReadOnly)
        .click(() => {
          $("#shareWhiteboardDialogMessage")
            .toggleClass("displayNone", false)
            .text("Read/write link copied to clipboard ✓");
          urlToClipboard();
        });
    },
    displayWhiteboardInfoBtn() {
      InfoService.toggleDisplayInfo();
    },
    minMaxBtn() {
      if (!this.btnsMini) {
        $("#toolbar").find(".btn-group:not(.minGroup)").hide();
        $("#minBtn").hide();
        $("#maxBtn").show();
      } else {
        $("#toolbar").find(".btn-group").show();
        $("#minBtn").show();
        $("#maxBtn").hide();
      }
      this.btnsMini = !this.btnsMini;
    },
    whiteboardThicknessSlider(e) {
      if (ReadOnlyService.readOnlyActive) return;
      whiteboard.setStrokeThickness($(e.currentTarget).val());
      let activeTool = $(".whiteboard-tool.active").attr("tool");
      localStorage.setItem(
        "item_thickness_" + activeTool,
        $(e.currentTarget).val()
      );
    },
    whiteboardZoomSlider(e) {
      if (ReadOnlyService.readOnlyActive) return;
      // whiteboard.setStrokeThickness($(e.currentTarget).val());
      // let activeTool = $(".whiteboard-tool.active").attr("tool");
      // localStorage.setItem(
      //   "item_thickness_" + activeTool,
      //   $(e.currentTarget).val()
      // );
    },
    whiteboardUndoBtn() {
      whiteboard.undoWhiteboardClick();
    },
    whiteboardRedoBtn() {
      whiteboard.redoWhiteboardClick();
    },
    handleDragEnter(e) {
      if (ReadOnlyService.readOnlyActive) return;
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter++;
      // whiteboard.dropIndicator.show();
    },
    handleDragLeave(e) {
      if (ReadOnlyService.readOnlyActive) return;
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        whiteboard.dropIndicator.hide();
      }
    },
    handleDrop(e) {
      //Handle drop
      if (ReadOnlyService.readOnlyActive) return;

      this.handleFileUploadEvent(e);
      this.dragCounter = 0;
      whiteboard.dropIndicator.hide();
    },
    handleFileUploadEvent(e) {
      console.log(e);
      if (e.dataTransfer === undefined) {
        if (e.originalEvent.dataTransfer) {
          if (e.originalEvent.dataTransfer.files.length) {
            e.preventDefault();
            e.stopPropagation();
            var filename = e.originalEvent.dataTransfer.files[0]["name"];
            if (this.isImageFileName(filename)) {
              var blob = e.originalEvent.dataTransfer.files[0];
              var reader = new window.FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                const base64data = reader.result;
                this.uploadImgAndAddToWhiteboard(base64data);
              };
            } else if (isPDFFileName(filename)) {
              var blob = e.dataTransfer.files[0];

              var reader = new window.FileReader();
              reader.onloadend = function () {
                var pdfData = new Uint8Array(this.result);

                var loadingTask = pdfjsLib.getDocument({ data: pdfData });
                loadingTask.promise.then(
                  function (pdf) {
                    console.log("PDF loaded");

                    var currentDataUrl = null;
                    var modalDiv = $(
                      "<div>" +
                        "Page: <select></select> " +
                        '<button style="margin-bottom: 3px;" class="modalBtn"><i class="fas fa-upload"></i> Upload to Whiteboard</button>' +
                        '<img style="width:100%;" src=""/>' +
                        "</div>"
                    );

                    modalDiv.find("select").change(function () {
                      showPDFPageAsImage(parseInt($(this).val()));
                    });

                    modalDiv
                      .find("button")
                      .off("click")
                      .click(() => {
                        if (currentDataUrl) {
                          $(".basicalert").remove();
                          this.uploadImgAndAddToWhiteboard(currentDataUrl);
                        }
                      });

                    for (var i = 1; i < pdf.numPages + 1; i++) {
                      modalDiv
                        .find("select")
                        .append('<option value="' + i + '">' + i + "</option>");
                    }

                    this.showBasicAlert(modalDiv, {
                      header: "Pdf to Image",
                      okBtnText: "cancel",
                      headercolor: "#0082c9",
                    });

                    // render newly added icons
                    dom.i2svg();

                    showPDFPageAsImage(1);
                    function showPDFPageAsImage(pageNumber) {
                      // Fetch the page
                      pdf.getPage(pageNumber).then(function (page) {
                        console.log("Page loaded");

                        var scale = 1.5;
                        var viewport = page.getViewport({ scale: scale });

                        // Prepare canvas using PDF page dimensions
                        var canvas = $("<canvas></canvas>")[0];
                        var context = canvas.getContext("2d");
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        // Render PDF page into canvas context
                        var renderContext = {
                          canvasContext: context,
                          viewport: viewport,
                        };
                        var renderTask = page.render(renderContext);
                        renderTask.promise.then(function () {
                          var dataUrl = canvas.toDataURL("image/jpeg", 1.0);
                          currentDataUrl = dataUrl;
                          modalDiv.find("img").attr("src", dataUrl);
                          console.log("Page rendered");
                        });
                      });
                    }
                  },
                  function (reason) {
                    // PDF loading error

                    showBasicAlert(
                      "Error loading pdf as image! Check that this is a vaild pdf file!"
                    );
                    console.error(reason);
                  }
                );
              };
              reader.readAsArrayBuffer(blob);
            } else {
              showBasicAlert("File must be an image!");
            }
          } else {
            //File from other browser

            var fileUrl = e.originalEvent.dataTransfer.getData("URL");
            var imageUrl = e.originalEvent.dataTransfer.getData("text/html");
            var rex = /src="?([^"\s]+)"?\s*/;
            var url = rex.exec(imageUrl);
            if (url && url.length > 1) {
              url = url[1];
            } else {
              url = "";
            }

            isValidImageUrl(fileUrl, (isImage) => {
              if (isImage && this.isImageFileName(url)) {
                whiteboard.addImgToCanvasByUrl(fileUrl);
              } else {
                isValidImageUrl(url, (isImage) => {
                  if (isImage) {
                    if (this.isImageFileName(url) || url.startsWith("http")) {
                      whiteboard.addImgToCanvasByUrl(url);
                    } else {
                      this.uploadImgAndAddToWhiteboard(url); //Last option maybe its base64
                    }
                  } else {
                    showBasicAlert("Can only upload Imagedata!");
                  }
                });
              }
            });
          }
        }
      } else {
        if (e.dataTransfer) {
          if (e.dataTransfer.files.length) {
            //File from harddisc
            e.preventDefault();
            e.stopPropagation();
            var filename = e.dataTransfer.files[0]["name"];
            if (this.isImageFileName(filename)) {
              var blob = e.dataTransfer.files[0];
              var reader = new window.FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                const base64data = reader.result;
                this.uploadImgAndAddToWhiteboard(base64data);
              };
            } else if (isPDFFileName(filename)) {
              //Handle PDF Files
              var blob = e.dataTransfer.files[0];

              var reader = new window.FileReader();
              reader.onloadend = function () {
                var pdfData = new Uint8Array(this.result);

                var loadingTask = pdfjsLib.getDocument({ data: pdfData });
                loadingTask.promise.then(
                  function (pdf) {
                    console.log("PDF loaded");

                    var currentDataUrl = null;
                    var modalDiv = $(
                      "<div>" +
                        "Page: <select></select> " +
                        '<button style="margin-bottom: 3px;" class="modalBtn"><i class="fas fa-upload"></i> Upload to Whiteboard</button>' +
                        '<img style="width:100%;" src=""/>' +
                        "</div>"
                    );

                    modalDiv.find("select").change(function () {
                      showPDFPageAsImage(parseInt($(this).val()));
                    });

                    modalDiv
                      .find("button")
                      .off("click")
                      .click(() => {
                        if (currentDataUrl) {
                          $(".basicalert").remove();
                          this.uploadImgAndAddToWhiteboard(currentDataUrl);
                        }
                      });

                    for (var i = 1; i < pdf.numPages + 1; i++) {
                      modalDiv
                        .find("select")
                        .append('<option value="' + i + '">' + i + "</option>");
                    }

                    this.showBasicAlert(modalDiv, {
                      header: "Pdf to Image",
                      okBtnText: "cancel",
                      headercolor: "#0082c9",
                    });

                    // render newly added icons
                    dom.i2svg();

                    showPDFPageAsImage(1);
                    function showPDFPageAsImage(pageNumber) {
                      // Fetch the page
                      pdf.getPage(pageNumber).then(function (page) {
                        console.log("Page loaded");

                        var scale = 1.5;
                        var viewport = page.getViewport({ scale: scale });

                        // Prepare canvas using PDF page dimensions
                        var canvas = $("<canvas></canvas>")[0];
                        var context = canvas.getContext("2d");
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        // Render PDF page into canvas context
                        var renderContext = {
                          canvasContext: context,
                          viewport: viewport,
                        };
                        var renderTask = page.render(renderContext);
                        renderTask.promise.then(function () {
                          var dataUrl = canvas.toDataURL("image/jpeg", 1.0);
                          currentDataUrl = dataUrl;
                          modalDiv.find("img").attr("src", dataUrl);
                          console.log("Page rendered");
                        });
                      });
                    }
                  },
                  function (reason) {
                    // PDF loading error

                    showBasicAlert(
                      "Error loading pdf as image! Check that this is a vaild pdf file!"
                    );
                    console.error(reason);
                  }
                );
              };
              reader.readAsArrayBuffer(blob);
            } else {
              showBasicAlert("File must be an image!");
            }
          } else {
            //File from other browser

            var fileUrl = e.dataTransfer.getData("URL");
            var imageUrl = e.dataTransfer.getData("text/html");
            var rex = /src="?([^"\s]+)"?\s*/;
            var url = rex.exec(imageUrl);
            if (url && url.length > 1) {
              url = url[1];
            } else {
              url = "";
            }

            isValidImageUrl(fileUrl, (isImage) => {
              if (isImage && this.isImageFileName(url)) {
                whiteboard.addImgToCanvasByUrl(fileUrl);
              } else {
                isValidImageUrl(url, (isImage) => {
                  if (isImage) {
                    if (this.isImageFileName(url) || url.startsWith("http")) {
                      whiteboard.addImgToCanvasByUrl(url);
                    } else {
                      this.uploadImgAndAddToWhiteboard(url); //Last option maybe its base64
                    }
                  } else {
                    showBasicAlert("Can only upload Imagedata!");
                  }
                });
              }
            });
          }
        }
      }
    },
    changeColor(color) {
      this.paletteBackground = color;
      $("#whiteboardColorpicker").css({ background: this.paletteBackground });
    },
    intColorPicker(initColor) {
      const _this = this;
      if (this.colorPicker) {
        this.colorPicker.destroy();
      }
      this.colorPicker = new Picker({
        parent: $("#whiteboardColorpicker")[0],
        color: initColor || "#d60839",
        onChange: function (color) {
          whiteboard.setDrawColor(color.rgbaString);
          _this.changeColor(color.rgbaString);
        },
        onDone: function (color) {
          let palette = JSON.parse(localStorage.getItem("savedColors"));
          if (!palette.includes(color.rgbaString)) {
            palette.push(color.rgbaString);
            localStorage.setItem("savedColors", JSON.stringify(palette));
          }
          _this.changeColor(color.rgbaString);
          _this.intColorPicker(color.rgbaString);
        },
        onOpen: colorPickerOnOpen,
        template: colorPickerTemplate,
      });
    },
    intBgColorPicker(initColor) {
      if (this.bgColorPicker) {
        this.bgColorPicker.destroy();
      }
      this.bgColorPicker = new Picker({
        parent: $("#textboxBackgroundColorPicker")[0],
        // color: initColor || "#f5f587",
        // bgcolor: initColor || "#f5f587",
        color: initColor || "rgba(0, 0, 0, 0)",
        bgcolor: initColor || "rgba(0, 0, 0, 0)",
        onChange: function (bgcolor) {
          whiteboard.setTextBackgroundColor(bgcolor.rgbaString);
        },
        onDone: (bgcolor) => {
          let palette = JSON.parse(localStorage.getItem("savedColors"));
          if (!palette.includes(color.rgbaString)) {
            palette.push(color.rgbaString);
            localStorage.setItem("savedColors", JSON.stringify(palette));
          }
          this.intBgColorPicker(color.rgbaString);
        },
        onOpen: colorPickerOnOpen,
        template: colorPickerTemplate,
      });
    },
    uploadImgAndAddToWhiteboard(base64data) {
      const date = +new Date();
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_WHITEBOARD_SERVICE_URL || process.env.VUE_APP_WHITEBOARD_URL + ':5174'}` + "/api/upload",
        data: {
          imagedata: base64data,
          wid: whiteboardId,
          date: date,
          at: this.accessToken,
        },
        success: (msg) => {
          const { correspondingReadOnlyWid } = ConfigService;
          const filename = `${correspondingReadOnlyWid}_${date}.jpg`;
          const rootUrl = document.URL.substr(0, document.URL.lastIndexOf("/"));
          whiteboard.addImgToCanvasByUrl(
            `${rootUrl}/uploads/${correspondingReadOnlyWid}/${filename}`
          ); //Add image to canvas
          console.log("Image uploaded!");
        },
        error: (err) => {
          this.showBasicAlert("Failed to upload frame: " + JSON.stringify(err));
        },
      });
    },
    uploadImgSetToWhiteboard(base64data) {
      const date = +new Date();
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_WHITEBOARD_SERVICE_URL || process.env.VUE_APP_WHITEBOARD_URL + ':5174'}` + "/api/upload",
        data: {
          imagedata: base64data,
          wid: whiteboardId,
          date: date,
          at: this.accessToken,
        },
        success: (msg) => {
          const { correspondingReadOnlyWid } = ConfigService;
          const filename = `${correspondingReadOnlyWid}_${date}.png`;
          const rootUrl = document.URL.substr(0, document.URL.lastIndexOf("/"));
          whiteboard.setImgAsBackgroundByUrl(
            `${process.env.VUE_APP_WHITEBOARD_SERVICE_URL || process.env.VUE_APP_WHITEBOARD_URL + ':5174'}/uploads/${correspondingReadOnlyWid}/${filename}`
          );
        },
        error: (err) => {
          this.showBasicAlert("Failed to upload frame: " + JSON.stringify(err));
        },
      });
    },
    saveWhiteboardToWebdav(base64data, webdavaccess, callback) {
      var date = +new Date();
      $.ajax({
        type: "POST",
        url:
          document.URL.substr(0, document.URL.lastIndexOf("/")) + "/api/upload",
        data: {
          imagedata: base64data,
          wid: whiteboardId,
          date: date,
          at: this.accessToken,
          webdavaccess: JSON.stringify(webdavaccess),
        },
        success: (msg) => {
          this.showBasicAlert("Whiteboard was saved to Webdav!", {
            headercolor: "#5c9e5c",
          });
          console.log("Image uploaded to webdav!");
          callback();
        },
        error: (err) => {
          console.error(err);
          if (err.status == 403) {
            this.showBasicAlert(
              "Could not connect to Webdav folder! Please check the credentials and paths and try again!"
            );
          } else {
            this.showBasicAlert("Unknown Webdav error! ", err);
          }
          callback(err);
        },
      });
    },
    isImageFileName(filename) {
      var extension = filename.split(".")[filename.split(".").length - 1];
      var known_extensions = [
        "png",
        "jpg",
        "jpeg",
        "gif",
        "tiff",
        "bmp",
        "webp",
      ];
      return known_extensions.includes(extension.toLowerCase());
    },
    isPDFFileName(filename) {
      var extension = filename.split(".")[filename.split(".").length - 1];
      var known_extensions = ["pdf"];
      return known_extensions.includes(extension.toLowerCase());
    },
    isValidImageUrl(url, callback) {
      var img = new Image();
      var timer = null;
      img.onerror = img.onabort = function () {
        clearTimeout(timer);
        callback(false);
      };
      img.onload = function () {
        clearTimeout(timer);
        callback(true);
      };
      timer = setTimeout(function () {
        callback(false);
      }, 2000);
      img.src = url;
    },
    thicknessSlide() {
      if (this.thicknessSlideState) {
        $("#thicknessSlide").show();
        $("#thicknessSlide").hide();
      } else {
        $("#thicknessSlide").hide();
        $("#thicknessSlide").show();
      }
      this.thicknessSlideState = !this.thicknessSlideState;
    },
    setZoom(zoom) {
      if (this.zoom == 1) {
        const rect = document
          .getElementById("ContextImgAsBackground")
          .getBoundingClientRect();
        this.originalWidth = rect.width;
        this.originalHeight = rect.height;
      }

      if (this.zoom + zoom > 0.5) {
        $("#ContextImgAsBackground").css({ width: "100%", height: "100%" });
        this.zoom += zoom;
        var top = 0;
        var left = 0;

        if (this.zoom > 1) {
          top = Math.abs(this.originalHeight * (this.zoom - 1)) / 2;
          left = Math.abs(this.originalWidth * (this.zoom - 1)) / 2;
        }

        if (this.zoom < 1) {
          top = -(Math.abs(this.originalHeight * (this.zoom - 1)) / 2);
        }

        if (
          this.zoom == 1 &&
          $("#ContextImgAsBackground").height() <
            $("#whiteboardContainer").height()
        ) {
          transform = `translate(0px, -50%)`;
          const position = {
            transform: transform,
            top: "50%",
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        } else {
          var transform = `translate(${left}px, ${top}px) scale(${this.zoom})`;
          const position = {
            transform: transform,
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        }

        if (
          $("#ContextImgAsBackground").height() * this.zoom <
          $("#whiteboardContainer").height()
        ) {
          transform = `translate(${left}px, -50%) scale(${this.zoom})`;
          const position = {
            transform: transform,
            top: "50%",
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        } else {
          var transform = `translate(${left}px, ${top}px) scale(${this.zoom})`;
          const position = {
            transform: transform,
            top: `0px`,
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        }
        // 向學生端/觀課端/員工端廣播目前縮放比例
        if (this.socket && this.socketLoaded) {
          this.socket.emit("sync-zoom", {
            roomId: String(this.roomId),
            zoom: this.zoom,
          });
        }
      }
      this.$nextTick(() => {
        this.updateThumb();
      });
    },
    setImageToCenter() {
      if (
        this.zoom == 1 &&
        $("#ContextImgAsBackground").height() <
          $("#whiteboardContainer").height()
      ) {
        const transform = `translate(0px, -50%)`;
        const position = {
          transform: transform,
          top: "50%",
        };
        $(
          "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
        ).css(position);
      }
      this.pageChangeSet();
    },
    //--------------------------------------//

    //------------Content-------------------//

    async previousPicture(type) {
      if (this.MaterialObjectData.length > 0) {
        $(".book_scroll").animate({ scrollTop: "0px" }, 1000);
        var currentIndex = this.prevIndexGlobal;
        var prevIndex = currentIndex - 1;
        var nextIndex = currentIndex + 1;
        this.imgTempId = "obj-" + currentIndex;
        for (let i = 0; i < this.MaterialObjectData.length; i++) {
          var elem = "obj-" + i;
          if (i !== this.currentIndex) {
            if (document.getElementById(elem)) {
              var element = document.getElementById(elem).firstChild;
              element.style.removeProperty("border");
            }
          }
        }

        if (currentIndex < 0) {
          prevIndex = 0;
          let lengthPaginationLayer = this.paginationLayers.length - 1;
          var responseMaterial;
          if (this.currentLayer > -1) {
            if (lengthPaginationLayer > -1) {
              if (lengthPaginationLayer > 0) {
                responseMaterial = await this.$store.dispatch(
                  "fetchHitutorMedia",
                  {
                    ClassroomId: this.$store.state.classRoomId,
                    LastPage: this.paginationLayers[this.currentLayer],
                    RequestPages: 10,
                  }
                );
              } else {
                responseMaterial = await this.$store.dispatch(
                  "fetchHitutorMedia",
                  {
                    ClassroomId: this.$store.state.classRoomId,
                    LastPage: this.paginationLayers[0],
                    RequestPages: 10,
                  }
                );
              }

              if (responseMaterial.data.IsSuccess == true) {
                this.MaterialObjectData = responseMaterial.data.MaterialObject;
                this.MaterialVedioObjectData =
                  responseMaterial.data.MaterialVedioObject;
                this.MaterialMediaObject =
                  responseMaterial.data.MaterialMediaObject;

                this.nextIndexGlobal = this.MaterialObjectData.length;
                currentIndex = this.MaterialObjectData.length - 1;
                prevIndex = currentIndex - 1;
                nextIndex = this.nextIndexGlobal;
                this.currentLayer = this.currentLayer - 1;
              } else {
                currentIndex = 0;
                prevIndex = 0;
                nextIndex = currentIndex + 1;
              }
            } else {
              this.currentLayer = 0;
              currentIndex = 0;
              prevIndex = 0;
              nextIndex = currentIndex + 1;
            }
          } else {
            currentIndex = 0;
            prevIndex = 0;
            nextIndex = currentIndex + 1;
          }
        }

        try {
          this.visibleImage = currentIndex;
          this.prevMaterialFileType = this.MaterialFileType;
          this.prevMaterialFileName = this.MaterialFileName;
          this.prevMaterialName = this.MaterialName;
          this.prevMaterialFileUrl = this.MaterialFileUrl;
          this.prevMaterialUnitPageId = this.MaterialUnitPageId;
          this.prevMaterialUnit = this.MaterialUnit;
          this.prevMaterialUnitPage = this.MaterialUnitPage;
          this.prevMaterialCode = this.MaterialCode;

          this.MaterialFileType =
            this.MaterialObjectData[currentIndex].FileType;
          this.MaterialFileName =
            this.MaterialObjectData[currentIndex].FileName;
          this.MaterialName =
            this.MaterialObjectData[currentIndex].MaterialName;
          this.MaterialFileUrl = this.MaterialObjectData[currentIndex].FileUrl;
          this.MaterialUnitPageId =
            this.MaterialObjectData[currentIndex].MaterialUnitPageId;
          this.MaterialUnit =
            this.MaterialObjectData[currentIndex].MaterialUnit;
          this.MaterialUnitPage =
            this.MaterialObjectData[currentIndex].MaterialPage;
          this.MaterialCode =
            this.MaterialObjectData[currentIndex].MaterialCode;

          var imgTemp = document.querySelector("#obj-" + currentIndex);

          this.SELECTIMGWIDTH = imgTemp.children[0].naturalWidth;
          this.SELECTIMGHEIGHT = imgTemp.children[0].naturalHeight;
        } catch (error) {}

        // NewPage 沒有真實背景圖，傳 null 避免載入錯誤 URL 作為背景
        var img = this.MaterialCode === "NewPage"
          ? null
          : this.MaterialObjectData[currentIndex].FileUrl;

        // 同步 EnglishFileName
        this.EnglishFileName = this.MaterialCode === "NewPage"
          ? "New" + this.MaterialFileName : this.MaterialFileName;
        this.ChineseFileName = this.MaterialFileName;

        // 构造 fileData 供 socket emit 使用（保持兼容）
        var fileData = `${this.roomId}|${this.MaterialUnitPageId}|${this.MaterialUnit}|${this.MaterialUnitPage}|${this.EnglishFileName}|${this.MaterialName}`;

        // 检查是否 NewPage 并设置画布
        if (this.MaterialCode === "NewPage") {
          type = "new";
          this.setupCanvasAndResizeElements("100%", "100%");
        }

        // 直接用确定性参数加载，无需先查 MongoDB 获取文件名
        // 传入 fallbackImg：无 JSON 时回退到教材背景图（NewPage 传 null）
        this.loadJsonFromDatabase(
          this.roomId, this.EnglishFileName,
          this.MaterialUnit, this.MaterialUnitPage, type,
          img, this.imgTempId
        );

        this.versions = 0;
        this.fileUrl = this.currentBackgroundImage;
        this.prevIndexGlobal = prevIndex;
        this.nextIndexGlobal = nextIndex;
        this.currentIndexGlobal = currentIndex;
        this.mediaProgressNum = this.currentIndexGlobal + 1;
        this.socket.emit("setImgTempId", {
          roomId: String(this.roomId),
          status: "previous",
          type: type,
          num: [
            this.prevIndexGlobal,
            this.nextIndexGlobal,
            this.currentIndexGlobal,
            this.mediaProgressNum,
          ],
          file: fileData,
        });

        if (this.MaterialObjectData.length > 0) {
          if (
            this.prevMaterialFileType !== "" &&
            this.prevMaterialFileName !== "" &&
            this.prevMaterialFileUrl !== "" &&
            this.prevMaterialUnitPageId !== "" &&
            this.prevMaterialUnit !== "" &&
            this.prevMaterialUnitPage !== "" &&
            this.prevMaterialCode !== "" &&
            this.prevMaterialFileType !== undefined &&
            this.prevMaterialFileName !== undefined &&
            this.prevMaterialFileUrl !== undefined &&
            this.prevMaterialUnitPageId !== undefined &&
            this.prevMaterialUnit !== undefined &&
            this.prevMaterialUnitPage !== undefined &&
            this.prevMaterialCode !== undefined &&
            this.prevMaterialFileType !== null &&
            this.prevMaterialFileName !== null &&
            this.prevMaterialFileUrl !== null &&
            this.prevMaterialUnitPageId !== null &&
            this.prevMaterialUnit !== null &&
            this.prevMaterialUnitPage !== null &&
            this.prevMaterialCode !== null
          ) {
            // this.uploadTeacherMedia();
          }
        }
      }
    },
    hasProperty(obj, propertyName) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
          if (prop == propertyName) {
            return true;
          }
      }
      return false;
    },
    async nextPicture(type) {
      if (this.MaterialObjectData.length > 0) {
        $(".book_scroll").animate({ scrollTop: "0px" }, 1000);
        var currentIndex = this.nextIndexGlobal;
        var prevIndex = currentIndex - 1;
        var nextIndex = currentIndex + 1;
        this.imgTempId = "obj-" + currentIndex;

        for (let i = 0; i < this.MaterialObjectData.length; i++) {
          var elem = "obj-" + i;
          if (i !== this.currentIndex) {
            if (document.getElementById(elem)) {
              var element = document.getElementById(elem).firstChild;
              element.style.removeProperty("border");
            }
          }
        }

        try {
          this.visibleImage = currentIndex;
          this.prevMaterialFileType = this.MaterialFileType;
          this.prevMaterialFileName = this.MaterialFileName;
          this.prevMaterialName = this.MaterialName;
          this.prevMaterialFileUrl = this.MaterialFileUrl;
          this.prevMaterialUnitPageId = this.MaterialUnitPageId;
          this.prevMaterialUnit = this.MaterialUnit;
          this.prevMaterialUnitPage = this.MaterialUnitPage;
          this.prevMaterialCode = this.MaterialCode;

          this.MaterialFileType =
            this.MaterialObjectData[currentIndex].FileType;
          this.MaterialFileName =
            this.MaterialObjectData[currentIndex].FileName;
          this.MaterialName =
            this.MaterialObjectData[currentIndex].MaterialName;
          this.MaterialFileUrl = this.MaterialObjectData[currentIndex].FileUrl;
          this.MaterialUnitPageId =
            this.MaterialObjectData[currentIndex].MaterialUnitPageId;
          this.MaterialUnit =
            this.MaterialObjectData[currentIndex].MaterialUnit;
          this.MaterialUnitPage =
            this.MaterialObjectData[currentIndex].MaterialPage;
          this.MaterialCode =
            this.MaterialObjectData[currentIndex].MaterialCode;

          var imgTemp = document.querySelector("#obj-" + currentIndex);
          this.SELECTIMGWIDTH = imgTemp.children[0].naturalWidth;
          this.SELECTIMGHEIGHT = imgTemp.children[0].naturalHeight;
        } catch (error) {}

        // NewPage 沒有真實背景圖，傳 null 避免載入錯誤 URL 作為背景
        var img = this.MaterialCode === "NewPage"
          ? null
          : this.MaterialObjectData[currentIndex].FileUrl;

        // 同步 EnglishFileName
        this.EnglishFileName = this.MaterialCode === "NewPage"
          ? "New" + this.MaterialFileName : this.MaterialFileName;
        this.ChineseFileName = this.MaterialFileName;

        // 构造 fileData 供 socket emit 使用（保持兼容）
        var fileData = `${this.roomId}|${this.MaterialUnitPageId}|${this.MaterialUnit}|${this.MaterialUnitPage}|${this.EnglishFileName}|${this.MaterialName}`;

        // 检查是否 NewPage 并设置画布
        if (this.MaterialCode === "NewPage") {
          type = "new";
          this.setupCanvasAndResizeElements("100%", "100%");
        }

        // 直接用确定性参数加载，无需先查 MongoDB 获取文件名
        // 传入 fallbackImg：无 JSON 时回退到教材背景图（NewPage 传 null）
        this.loadJsonFromDatabase(
          this.roomId, this.EnglishFileName,
          this.MaterialUnit, this.MaterialUnitPage, type,
          img, this.imgTempId
        );

        this.versions = 0;
        this.fileUrl = this.currentBackgroundImage;
        this.prevIndexGlobal = prevIndex;
        this.nextIndexGlobal = nextIndex;
        this.currentIndexGlobal = currentIndex;
        this.mediaProgressNum = this.currentIndexGlobal + 1;
        this.socket.emit("setImgTempId", {
          roomId: String(this.roomId),
          status: "next",
          type: type,
          num: [
            this.prevIndexGlobal,
            this.nextIndexGlobal,
            this.currentIndexGlobal,
            this.mediaProgressNum,
          ],
          file: fileData,
        });

        if (this.MaterialObjectData.length > 0) {
          if (
            this.prevMaterialFileType !== "" &&
            this.prevMaterialFileName !== "" &&
            this.prevMaterialFileUrl !== "" &&
            this.prevMaterialUnitPageId !== "" &&
            this.prevMaterialUnit !== "" &&
            this.prevMaterialUnitPage !== "" &&
            this.prevMaterialCode !== "" &&
            this.prevMaterialFileType !== undefined &&
            this.prevMaterialFileName !== undefined &&
            this.prevMaterialFileUrl !== undefined &&
            this.prevMaterialUnitPageId !== undefined &&
            this.prevMaterialUnit !== undefined &&
            this.prevMaterialUnitPage !== undefined &&
            this.prevMaterialCode !== undefined &&
            this.prevMaterialFileType !== null &&
            this.prevMaterialFileName !== null &&
            this.prevMaterialFileUrl !== null &&
            this.prevMaterialUnitPageId !== null &&
            this.prevMaterialUnit !== null &&
            this.prevMaterialUnitPage !== null &&
            this.prevMaterialCode !== null
          ) {
          }
        }

        if (nextIndex >= this.MaterialObjectData.length) {
          var lastMaterialObject = this.MaterialObjectData[currentIndex];

          // 新增空白頁沒有真實的 MaterialUnitPageId，不應用於向伺服器分頁拉取
          // 否則會以上一頁的 ID 拉取已存在的頁面，導致 MaterialObjectData 出現重複項目
          if (!lastMaterialObject || lastMaterialObject.MaterialCode === "NewPage") {
            return;
          }

          const responseMaterial = await this.$store.dispatch(
            "getClassroomMaterials",
            {
              ClassroomId: String(this.roomId),
              LastPage: lastMaterialObject.MaterialUnitPageId + 1,
              RequestPage: 10,
            }
          );

          if (
            this.$store.state.ClassroomMaterial.IsSuccess == true &&
            this.$store.state.ClassroomMaterial?.MaterialObject?.length > 0
          ) {
            this.$store.state.ClassroomMaterial.MaterialObject.forEach((i) => {
              this.MaterialObjectData.push(i);
            });
            this.mediaLengthNum = this.MaterialObjectData.length;
          }
          console.log("update Material Object", this.MaterialObjectData);
        }
      }
    },
    async imageUrlToBase64(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // To handle CORS issues for cross-origin images
        img.src = url;

        img.onload = () => {
          // Create a canvas element to draw the image
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          // Draw the image onto the canvas
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          // Convert the canvas to a base64 string
          const base64data = canvas.toDataURL("image/png"); // or 'image/jpeg'
          resolve(base64data);
        };

        img.onerror = (err) => {
          reject(new Error(`Failed to load image: ${err}`));
        };
      });
    },
    async setBackgroundDynamic4(imgUrl, imgTempId, type) {
      if (!imgUrl && imgUrl.length <= 0) {
        this.notificationMaterial();
      }

      var valueIndex = {
        prevIndexGlobal: this.prevIndexGlobal,
        nextIndexGlobal: this.nextIndexGlobal,
        currentIndexGlobal: this.currentIndexGlobal,
      };
      if (type != "firstLoad") {
        whiteboard.clearWhiteboard();
        // var base64 = await this.imageUrlToBase64(String(imgUrl));
        // this.uploadImgSetToWhiteboard(base64);

        whiteboard.setImgAsBackgroundByUrl(
          String(imgUrl),
          imgTempId,
          valueIndex,
          false
        );
      } else {
        whiteboard.setImgAsBackgroundByUrl(
          String(imgUrl),
          imgTempId,
          valueIndex,
          false
        );
      }

      // const imgLoad = document.getElementById("ContextImgAsBackground");
      // if (imgLoad.complete) {
      //   $("#loadingMedia").css({
      //       display: "none",
      //     });
      //     $("#loadingMedia").css({ zIndex: "0" });
      // }

      signaling_socket.emit("updateIndex", valueIndex);
    },
    setBackgroundDynamic(imgUrl) {
      this.fabricObj.setBackgroundImage(
        imgUrl,
        this.fabricObj.renderAll.bind(this.fabricObj),
        {
          backgroundImageOpacity: 1,
          // should the image be resized to fit the container?
          backgroundImageStretch: true,
          crossOrigin: "anonymous",
        }
      );
      this.fabricObj.setWidth(this.SELECTIMGWIDTH);
      this.fabricObj.setHeight(this.SELECTIMGHEIGHT);
    },
    setBackgroundDynamic3(imgUrl) {
      var widthz = $(".book_scroll").width();
      this.fabricObj.setBackgroundImage(
        imgUrl,
        this.fabricObj.renderAll.bind(this.fabricObj),
        {
          scaleX: widthz / this.SELECTIMGWIDTH,
          scaleY: widthz / this.SELECTIMGWIDTH,
          backgroundImageOpacity: 1,
          backgroundImageStretch: true,
          crossOrigin: "anonymous",
        }
      );
      this.backgroundState = 3;
      this.widthFabric = this.SELECTIMGWIDTH * (widthz / this.SELECTIMGWIDTH);
      this.heightFabric = this.SELECTIMGHEIGHT * (widthz / this.SELECTIMGWIDTH);

      this.fabricObj.setWidth(this.widthFabric);
      this.fabricObj.setHeight(this.heightFabric);
    },
    setBackgroundDynamic2(imgUrl) {
      var widthz = $(".book_scroll").width();
      this.fabricObj.setBackgroundImage(
        imgUrl,
        this.fabricObj.renderAll.bind(this.fabricObj),
        {
          backgroundImageOpacity: 1,
          backgroundImageStretch: true,
          crossOrigin: "anonymous",
        }
      );
      this.backgroundState = 2;
      this.widthFabric = this.SELECTIMGWIDTH * (widthz / this.SELECTIMGWIDTH);
      this.heightFabric = this.SELECTIMGHEIGHT * (widthz / this.SELECTIMGWIDTH);

      this.fabricObj.setWidth(this.widthFabric);
      this.fabricObj.setHeight(this.heightFabric);
    },
    //--------------------------------------//

    //-------------UploadImage--------------//
    selectImage(event, materialData, currentIndex, prevIndex, nextIndex) {
      this.saveAsImageBtn();

      for (let i = 0; i < this.MaterialObjectData.length; i++) {
        var elem = "obj-" + i;
        if (i !== this.currentIndex) {
          if (document.getElementById(elem)) {
            var element = document.getElementById(elem).firstChild;
            element.style.removeProperty("border");
          }
        }
      }

      if (this.MaterialObjectData.length > 0) {
        $(".book_scroll").animate({ scrollTop: "0px" }, 1000);
        var img = document.querySelector("#img-" + currentIndex).src;
        this.imgTempId = "obj-" + currentIndex;
        if (prevIndex < 0) {
          prevIndex = 0;
        }

        if (nextIndex > this.MaterialObjectData.length - 1) {
          nextIndex = this.MaterialObjectData.length - 1;
        }

        this.prevIndexGlobal = prevIndex;
        this.nextIndexGlobal = nextIndex;
        this.currentIndexGlobal = currentIndex;
        this.visibleImage = currentIndex;

        try {
          this.SELECTIMGWIDTH = document.querySelector(
            "#img-" + currentIndex
          ).naturalWidth;
          this.SELECTIMGHEIGHT = document.querySelector(
            "#img-" + currentIndex
          ).naturalHeight;
        } catch (error) {}

        this.MaterialFileType = materialData.FileType;
        this.MaterialFileName = materialData.FileName;
        this.MaterialFileUrl = materialData.FileUrl;
        this.MaterialUnitPageId = materialData.MaterialUnitPageId;
        this.MaterialUnit = materialData.MaterialUnit;
        this.MaterialUnitPage = materialData.MaterialPage;
        this.MaterialCode = materialData.MaterialCode;

        let paramFileName =
          this.roomId +
          this.MaterialUnitPageId +
          this.MaterialUnit +
          this.MaterialUnitPage +
          this.MaterialFileName;

        this.currentSelectedImage = paramFileName;

        this.$axios
          .get(`/materialmodel/detailsbyEnglishName/` + paramFileName)
          .then((response) => {
            if (
              response.data.payload.materialObject != null ||
              response.data.payload.materialObject != undefined
            ) {
              var classID = response.data.payload.materialObject.classRoomID;
              var fileURL =
                response.data.payload.materialObject.fileName.split(".")[0] +
                ".jpg";
              var imgUrl =
                process.env.BASE_URL +
                "/materialmodel/img/" +
                classID +
                "/" +
                fileURL;
              this.setBackgroundDynamic4(imgUrl, this.imgTempId);
              this.currentBackgroundImage = imgUrl;
            } else {
              this.setBackgroundDynamic4(img, this.imgTempId);
              this.currentBackgroundImage = img;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    uploadAsImageBtn() {
      whiteboard.getImageDataBase64(
        {
          imageFormat: ConfigService.imageDownloadFormat,
          drawBackgroundGrid: true,
        },
        function (imgData) {
          var w = window.open("about:blank"); //Firefox will not allow downloads without extra window
          setTimeout(function () {
            //FireFox seems to require a setTimeout for this to work.
            var a = document.createElement("a");
            a.href = imgData;
            a.download = "whiteboard." + ConfigService.imageDownloadFormat;
            w.document.body.appendChild(a);
            a.click();
            w.document.body.removeChild(a);
            setTimeout(function () {
              w.close();
            }, 100);
          }, 0);
        }
      );
    },
    uploadAsJSONBtn() {
      var imgData = whiteboard.getImageDataJson();

      var w = window.open("about:blank"); //Firefox will not allow downloads without extra window
      setTimeout(function () {
        //FireFox seems to require a setTimeout for this to work.
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(
          new Blob([imgData], { type: "text/json" })
        );
        a.download = "whiteboard.json";
        w.document.body.appendChild(a);
        a.click();
        w.document.body.removeChild(a);
        setTimeout(function () {
          w.close();
        }, 100);
      }, 0);
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    downloadImage() {
      this.done = true;
      let base64URl = this.fabricObj.toDataURL({
        format: "png",
        multiplier: 4,
      });
      this.imageBase64 = base64URl;
      this.done = false;
      const a = document.createElement("a");
      a.href = base64URl;
      a.download = "joke";
      a.click();
    },
    async isBase64UrlImage(base64String) {
      let image = new Image();
      image.src = base64String;
      return await new Promise((resolve) => {
        image.onload = function () {
          if (image.height === 0 || image.width === 0) {
            resolve(false);
            return;
          }
          resolve(true);
        };
        image.onerror = () => {
          resolve(false);
        };
      });
    },
    async uploadTeacherMedia(type) {
      if (type === "newPage") {
        var classID = this.roomId;
        var fileURL =
          this.MaterialObjectData[this.currentIndexGlobal].FileName.split(
            "."
          )[0] + ".jpg";
        this.fileUrl =
          process.env.VUE_APP_BASE_URL +
          "/materialmodel/img/" +
          classID +
          "/" +
          fileURL;
        this.prevMaterialCode = this.MaterialCode;
        this.prevMaterialUnit = this.MaterialUnit;
        this.prevMaterialUnitPage = this.MaterialUnitPage;
        this.prevMaterialFileName = this.MaterialFileName;
      }

      console.log("Upload Teacher Media", {
        ClassroomId: this.$store.state.classRoomId,
        MaterialCode: this.prevMaterialCode,
        MaterialUnit: this.prevMaterialUnit,
        MaterialPage: this.prevMaterialUnitPage,
        MaterialFileName: this.prevMaterialFileName,
        ImageInBase64: this.imageBase64,
        fileUrl: this.fileUrl,
      });

      var checkIsImage = await this.isBase64UrlImage(this.imageBase64);
      if (
        checkIsImage &&
        this.fileUrl != undefined &&
        this.fileUrl != "" &&
        type != "newPage"
      ) {
        console.log("Upload Teacher Media");
        this.isLoading = true;
        this.$store
          .dispatch("uploadTeacherMedia", {
            classRoomID: this.$store.state.classRoomId,
            materialCode: this.prevMaterialCode,
            materialUnit: this.prevMaterialUnit,
            materialPage: this.prevMaterialUnitPage,
            MaterialFileName: this.prevMaterialFileName,
            base64Img: this.imageBase64,
            fileUrl: this.fileUrl,
            englishName: this.prevMaterialFileName,
            chineseName: this.prevMaterialFileName,
            version: 3,
          })
          .then((response) => {
            if (response.data != null || response.data != undefined) {
              var newMaterialData = {};
              if (this.loadNewPage) {
                this.prevIndexGlobal = this.prevIndexGlobal + 1;
                this.nextIndexGlobal = this.nextIndexGlobal + 1;
                this.currentIndexGlobal = this.currentIndexGlobal + 1;
                this.mediaProgressNum = this.currentIndexGlobal + 1;

                console.log(
                  "updatedIndexGlobal",
                  this.prevIndexGlobal,
                  this.nextIndexGlobal,
                  this.currentIndexGlobal
                );
                var classID = this.roomId;
                var fileURL = "NEW-" + String(this.mediaProgressNum) + ".jpg";
                this.MaterialFileType = "image/jpeg";
                this.MaterialFileName =
                  "NEW-" + String(this.mediaProgressNum) + ".jpg";
                this.MaterialFileUrl =
                  process.env.VUE_APP_BASE_URL +
                  "/materialmodel/img/" +
                  classID +
                  "/" +
                  fileURL;
                this.MaterialUnitPageId = this.mediaProgressNum - 1;
                this.MaterialUnit = "NEW-" + String(this.mediaProgressNum);
                this.MaterialUnitPage = "NEW-" + String(this.mediaProgressNum);
                this.MaterialCode = "NEW-" + String(this.mediaProgressNum);

                newMaterialData = {
                  FileName: this.MaterialFileName,
                  FileType: this.MaterialFileType,
                  FileUrl: this.MaterialFileUrl,
                  MaterialCode: this.MaterialCode,
                  MaterialName: this.MaterialFileName,
                  MaterialPage: this.MaterialUnitPage,
                  MaterialUnit: this.MaterialUnit,
                  MaterialUnitPageId: this.MaterialUnitPageId,
                };
                this.MaterialObjectData.splice(
                  this.mediaProgressNum - 1,
                  0,
                  newMaterialData
                );
                console.log(
                  "updatedMaterialObjectData",
                  this.MaterialObjectData
                );
                this.loadNewPage = false;
              }
              if (type == "newPage") {
                whiteboard.clearWhiteboard();
                this.socket.emit("updateNewMaterial", {
                  prevIndexGlobal: this.prevIndexGlobal,
                  nextIndexGlobal: this.nextIndexGlobal,
                  currentIndexGlobal: this.currentIndexGlobal,
                  newMaterial: newMaterialData,
                });
                this.socket.emit(
                  "setCurrentIndexGlobal",
                  this.currentIndexGlobal
                );
                const renderedWidth = "100%";
                const renderedHeight = "100%";

                const canvas = document.getElementById("whiteboardCanvas");
                var widthContainer = $("#whiteboardContainer").width();
                var heightContainer = $("#whiteboardContainer").height();
                canvas.width = widthContainer;
                canvas.height = heightContainer;

                // $("#whiteboardCanvas").css({ width: renderedWidth, height: renderedHeight });
                $("#textContainer").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
                $("#mouseOverlay").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
                $("#imgContainer").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
                $("#backgroundGrid").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
                $("#svgContainer").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
                $("#dropIndicator").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
                $("#cursorContainer").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
                $("#loadingMedia").css({
                  width: renderedWidth,
                  height: renderedHeight,
                });
              }
            }
          });
      }
    },
    waitForElementsToLoad(selectors, callback) {
      const elementsNeeded = selectors.length;
      let elementsFound = 0;
      const elements = new Map();

      // Create a new MutationObserver instance
      const observer = new MutationObserver((mutations, obs) => {
        selectors.forEach((selector) => {
          if (!elements.has(selector)) {
            const element = document.querySelector(selector);
            if (element) {
              elements.set(selector, element);
              elementsFound++;
            }
          }
        });

        // Check if all elements are found
        if (elementsFound === elementsNeeded) {
          // If all elements are found, disconnect the observer and run the callback
          obs.disconnect();
          callback();
        }
      });

      // Start observing the document for changes to the DOM
      observer.observe(document.body, {
        childList: true, // Watch for additions/removals of child nodes
        subtree: true, // Watch the entire subtree of the document
      });

      // Initial check in case elements are already in the DOM
      selectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          elements.set(selector, element);
          elementsFound++;
        }
      });

      // If all elements are already found, run the callback immediately
      if (elementsFound === elementsNeeded) {
        observer.disconnect();
        callback();
      }
    },
    async loadImgMaterial() {
      if (this.currentIndexMaterial >= 0) {
        console.log("currentIndexMaterial", this.currentIndexMaterial);
        if (!this.MaterialObjectData || !this.MaterialObjectData[this.currentIndexMaterial]) {
          // 教材資料尚未就緒，等待 MaterialObjectData 填充後再重試
          var unwatch = this.$watch(
            () => this.MaterialObjectData,
            (val) => {
              if (val && val[this.currentIndexMaterial]) {
                unwatch();
                this.loadImgMaterial();
              }
            },
            { deep: false }
          );
          return;
        }
        this.MaterialFileType =
          this.MaterialObjectData[this.currentIndexMaterial].FileType;
        this.MaterialFileName =
          this.MaterialObjectData[this.currentIndexMaterial].FileName;
        this.MaterialName =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialName;
        this.MaterialFileUrl =
          this.MaterialObjectData[this.currentIndexMaterial].FileUrl;
        this.MaterialUnitPageId =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialUnitPageId;
        this.MaterialUnit =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialUnit;
        this.MaterialUnitPage =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialPage;
        this.MaterialCode =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialCode;

        var imgTemp = document.querySelector(
          "#obj-" + this.currentIndexMaterial
        );

        this.imgTempId = "obj-" + this.currentIndexMaterial;
        var type = "firstLoad";

        var img = this.MaterialObjectData[this.currentIndexMaterial].FileUrl;
        console.log("firstLoad", this.roomId, this.MaterialFileName, this.MaterialUnit, this.MaterialUnitPage);

        // 1. 先设背景图（确保背景总是渲染，无论 JSON 结果如何）
        this.setBackgroundDynamic4(img, this.imgTempId, type);
        this.currentBackgroundImage = img;

        // 2. 然后尝试加载 JSON 绘图数据叠加到背景上
        // NewPage 插入頁的 JSON 以 "New" + FileName 為 key 儲存（與 nextPicture 邏輯一致）
        var safeName = (this.MaterialCode === "NewPage"
          ? "New" + (this.MaterialFileName || "") : (this.MaterialFileName || "")) || "none";
        var safeUnit = this.MaterialUnit || "none";
        var safePage = this.MaterialUnitPage || "none";
        try {
          const response = await this.$axios.get(
            `/materialmodel/json/load/${encodeURIComponent(this.roomId)}/${encodeURIComponent(safeName)}/${encodeURIComponent(safeUnit)}/${encodeURIComponent(safePage)}`
          );
          if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            whiteboard.loadJsonData(response.data, true, () => {
              // 先清除已加載的 DB JSON 筆跡，避免與 live buffer 重複疊加
              var strokesOnly = (this.content || []).filter(item => item && item["t"] !== "addImgContentAsBG" && item["t"] !== "clear");
              if (strokesOnly.length > 0) {
                whiteboard.loadCurrentData([{t: "clearDrawing"}, ...strokesOnly], false);
              }
              if (
                this.zoom == 1 &&
                $("#ContextImgAsBackground").height() <
                  $("#whiteboardContainer").height()
              ) {
                const transform = `translate(0px, -50%)`;
                const position = { transform: transform, top: "50%" };
                $(
                  "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
                ).css(position);
              }
              if (!this.imageExists(response.data)) {
                $("#loadingMedia").css({ display: "none" });
                $("#loadingMedia").css({ zIndex: "0" });
              }
              this.pageChangeSet();
            });
          }
        } catch (error) {
          // 已设了背景图，无需额外操作
          console.log("firstLoad: 此页无绘图数据", error?.response?.status);
        }

        this.currentBackgroundImage = img;
        this.prevIndexGlobal = this.currentIndexMaterial - 1;
        this.nextIndexGlobal = this.currentIndexMaterial + 1;
        this.currentIndexGlobal = this.currentIndexMaterial;
        this.mediaProgressNum = this.currentIndexGlobal + 1;

        // 初始載入後主動同步當前頁碼到後端及房間內所有客戶端
        // 確保其他端在老師未切換頁面時也能顯示正確頁面
        this.socket.emit("setCurrentIndexGlobal", {
          roomId: String(this.roomId),
          index: this.currentIndexGlobal,
        });
        var _initEnglishName = this.MaterialCode === "NewPage"
          ? "New" + this.MaterialFileName : this.MaterialFileName;
        var _initFileData = `${this.roomId}|${this.MaterialUnitPageId}|${this.MaterialUnit}|${this.MaterialUnitPage}|${_initEnglishName}|${this.MaterialName}`;
        this.socket.emit("setImgTempId", {
          roomId: String(this.roomId),
          status: "firstLoad",
          type: "firstLoad",
          num: [
            this.prevIndexGlobal,
            this.nextIndexGlobal,
            this.currentIndexGlobal,
            this.mediaProgressNum,
          ],
          file: _initFileData,
        });
      }
    },
    retrieveChats() {
      console.log("retrieveChats");
      this.socket.emit("retrieveChats", {
        roomId: String(this.roomId),
      });
    },
    pushChatMessage(msg) {
      this.socket.emit("push-chat-message", {
        roomId: String(this.roomId),
        msg,
      });
    },
    setPermissionsStudent(state) {
      this.student_drawing_permissions = state;
      this.SET_DRAWING_PERMISSIONS_STUDENT(state);
    },
    updateGroupLabels() {
      const selectComponent = this.$refs.selectComponent;
      console.log("updateGroupLabels", selectComponent);
      if (selectComponent) {
        const groups = selectComponent.$el.querySelectorAll(
          ".el-select-group__title"
        );
        this.fileSelectList.forEach((group, index) => {
          const groupTitle = groups[index];
          console.log("updateGroupLabels", group);
          if (groupTitle) {
            groupTitle.innerHTML = `<img src="${group.imgUrl}" alt="Group Image" style="width: 20px; height: auto;"/>`;
          }
        });
      }
    },
    setTimerRun() {
      console.log("setTimeRun");
      this.socket.emit("setTimerRun", {
        roomId: String(this.roomId),
      });
    },
    async setScroll() {
      const scrollContainer = this.$refs.whiteboardContainer;

      const updateScrollbar = () => {
        this.waitForSocketAndRun(this, () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
          const scrollPercentage = scrollTop / (scrollHeight - clientHeight);
          // Emit scroll
          this.socket.emit("setScroll", {
            roomId: String(this.roomId),
            size: [scrollContainer.offsetWidth, scrollContainer.offsetHeight],
            scrollPercentage,
          });
        });
      };
      scrollContainer.addEventListener("scroll", updateScrollbar);
      this.$nextTick(updateScrollbar);
    },
    setClockIn(val) {
      val["roomId"] = String(this.roomId);
      this.socket.emit("setClockIn", val);
    },
    updateClassTime(val) {
      val["roomId"] = String(this.roomId);
      this.socket.emit("updateClassTime", val);
    },
    updateUrls() {
      this.MaterialObjectData = this.MaterialObjectData.map((image) => {
        if (image.FileUrl.startsWith("https://storage.googleapis.com")) {
          return {
            ...image,
            FileUrl: `${process.env.VUE_APP_PROXY}?gcsUrl=${image.FileUrl}`,
          };
        }
        return image;
      });
    },
    reset() {
      this.$store.commit("SET_DRAWING_PERMISSIONS_STUDENT", false);
      this.socket.emit("setStudentPermissions", {
        roomId: String(this.roomId),
        state: false,
      });
    },
    checkFeedback() {
      this.socket.emit("checkFeedback", {
        roomId: String(this.roomId),
      });
    },
    resetScrollbar() {
      const container = this.$refs.whiteboardContainer;
      if (container) {
        container.scrollTop = 0;
        container.scrollLeft = 0;
        this.thumbTop = 0;
        this.thumbLeft = 0;
      }
    },
    updateScrollbarThumb() {
      const scrollContainer = this.$refs.whiteboardContainer;
      const thumb = this.$refs.customScrollbar;

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
      const thumbHeight = (clientHeight / scrollHeight) * clientHeight;
      const thumbTop =
        (scrollTop / (scrollHeight - clientHeight)) *
        (clientHeight - thumbHeight);

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.top = `${thumbTop}px`;
    },
    updateThumb() {
      console.error("updateThumb called");
      const container = this.$refs.whiteboardContainer;
      const canvas = container?.querySelector("#whiteboardCanvas");

      if (!container || !canvas) {
        console.warn("Missing container or canvas in updateThumb()");
        return;
      }

      const visibleHeight = container.clientHeight;
      const visibleWidth = container.clientWidth;

      const canvasHeight = canvas.clientHeight;
      const canvasWidth = canvas.clientWidth;

      const contentHeight = canvasHeight * this.zoom;
      const contentWidth = canvasWidth * this.zoom;

      this.scrollbarHeight = visibleHeight;
      this.scrollbarWidth = visibleWidth;

      const thumbHeightRaw = visibleHeight * (visibleHeight / contentHeight);
      const thumbWidthRaw = visibleWidth * (visibleWidth / contentWidth);

      this.thumbHeight = isFinite(thumbHeightRaw)
        ? Math.max(thumbHeightRaw, 30)
        : 30;
      this.thumbWidth = isFinite(thumbWidthRaw)
        ? Math.max(thumbWidthRaw, 30)
        : 30;

      this.$refs.customScrollbar.style.display =
        contentHeight <= visibleHeight ? "none" : "block";
      this.$refs.customScrollbarHorizontal.style.display =
        contentWidth <= visibleWidth ? "none" : "block";

      if (contentWidth <= visibleWidth) {
        this.thumbLeft = 0;
      } else if (!isFinite(this.thumbLeft)) {
        this.thumbLeft = 0; // fallback
      }

      if (contentHeight <= visibleHeight) {
        this.thumbTop = 0;
      }

      $("#loadingMedia").css({
        display: "none",
      });
      $("#loadingMedia").css({ zIndex: "0" });
    },
    handleScroll() {
      const container = this.$refs.whiteboardContainer;
      const scrollbar = this.$refs.customScrollbar;
      const scrollbarx = this.$refs.customScrollbarHorizontal;

      const scrollRatio =
        container.scrollTop / (container.scrollHeight - container.clientHeight);
      const scrollxRatio =
        container.scrollLeft / (container.scrollWidth - container.clientWidth);
      this.thumbTop = scrollRatio * (scrollbar.clientHeight - this.thumbHeight);
      this.thumbLeft =
        scrollxRatio * (scrollbarx.clientWidth - this.thumbWidth);
    },
    startDrag(e) {
      this.isDragging = true;
      this.startY = e.touches ? e.touches[0].clientY : e.clientY;
      this.startScrollTop = this.$refs.whiteboardContainer.scrollTop;
      this.startThumbTop = this.thumbTop;

      if (e.cancelable) e.preventDefault();

      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
      document.addEventListener("touchmove", this.onDrag, { passive: false });
      document.addEventListener("touchend", this.stopDrag);
    },
    onDrag(e) {
      if (!this.isDragging) return;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const deltaY = clientY - this.startY;

      const container = this.$refs.whiteboardContainer;
      const scrollbar = this.$refs.customScrollbar;

      const maxScrollTop = container.scrollHeight - container.clientHeight;
      const maxThumbTop = scrollbar.clientHeight - this.thumbHeight;
      const scrollRatio = maxScrollTop / maxThumbTop;
      let newThumbTop = this.startThumbTop + deltaY;

      newThumbTop = Math.max(0, Math.min(newThumbTop, maxThumbTop));
      this.thumbTop = newThumbTop;
      container.scrollTop = newThumbTop * scrollRatio;
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.removeEventListener("touchmove", this.onDrag, {
        passive: false,
      });
      document.removeEventListener("touchend", this.stopDrag, {
        passive: false,
      });
    },
    startHorizontalDrag(e) {
      this.isDraggingHorizontal = true;
      this.startX = e.touches ? e.touches[0].clientX : e.clientX;
      this.startScrollLeft = this.$refs.whiteboardContainer.scrollLeft;
      this.startThumbLeft = this.thumbLeft;

      if (e.cancelable) e.preventDefault();

      document.addEventListener("mousemove", this.onHorizontalDrag);
      document.addEventListener("mouseup", this.stopHorizontalDrag);
      document.addEventListener("touchmove", this.onHorizontalDrag, {
        passive: false,
      });
      document.addEventListener("touchend", this.stopHorizontalDrag, {
        passive: false,
      });
    },
    onHorizontalDrag(e) {
      if (!this.isDraggingHorizontal) return;

      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const deltaX = clientX - this.startX;

      const container = this.$refs.whiteboardContainer;
      const scrollbar = this.$refs.customScrollbarHorizontal;

      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      const maxThumbLeft = scrollbar.clientWidth - this.thumbWidth;

      const scrollRatio = maxScrollLeft / maxThumbLeft;
      let newThumbLeft = this.startThumbLeft + deltaX;

      newThumbLeft = Math.max(0, Math.min(newThumbLeft, maxThumbLeft));
      this.thumbLeft = newThumbLeft;
      container.scrollLeft = newThumbLeft * scrollRatio;
    },
    stopHorizontalDrag() {
      this.isDraggingHorizontal = false;
      document.removeEventListener("mousemove", this.onHorizontalDrag);
      document.removeEventListener("mouseup", this.stopHorizontalDrag);
      document.removeEventListener("touchmove", this.onHorizontalDrag, {
        passive: false,
      });
      document.removeEventListener("touchend", this.stopHorizontalDrag, {
        passive: false,
      });
    },
    waitForSocketAndRun(context, fn, retryDelay = 100) {
      if (!context.socket || !context.socket.connected) {
        setTimeout(
          () => this.waitForSocketAndRun(context, fn, retryDelay),
          retryDelay
        );
        return;
      }
      fn();
    },
    ...mapMutations(["SET_DRAWING_PERMISSIONS_STUDENT"]),
    //--------------------------------------//
  },
  async mounted() {
    // Vue 2 不代理 _ 前綴屬性，需直接在實例上初始化
    this._playAborted = false;
    this._playIntentionId = 0;
    this.setScroll();
    let mainUIUXScript = document.createElement("script");
    mainUIUXScript.setAttribute("src", "/static/main.js");
    document.head.appendChild(mainUIUXScript);

    this.userIdz = this.$store.state.UserId;
    this.teachername = this.$store.state.TeacherName;
    this.roomId = sessionStorage.getItem("classroomId");
    this.userId = sessionStorage.getItem("userId");
    this.userName = sessionStorage.getItem("userName");
    this.userType = sessionStorage.getItem("userType");
    this.is_teacher = this.$store.state.teacher;
    this.onlineUsers = this.$store.state.onlineUsers;
    this.beginTimeStamp = moment
      .unix(this.$store.state.BeginTimeStamp)
      .format("LLLL");

    if (
      this.$store.state.MaterialVedioObject.length > 0 &&
      this.$store.state.MaterialVedioObject[0] != undefined
    ) {
      this.mediaVedioSelected =
        this.$store.state.MaterialVedioObject[0].FileUrl;
    }

    $("#whiteboardColorpicker").css({ background: this.paletteBackground });
    if (randomid) {
      whiteboardId = uuidv4();
      urlParams.delete("randomid");
      window.location.search = urlParams;
    }

    if (!whiteboardId) {
      whiteboardId = this.roomId;
    }

    this.myUsername =
      this.userName || "unknown" + (Math.random() + "").substring(2, 6);
    this.accessToken = urlParams.get("accesstoken") || "";
    this.copyfromwid = urlParams.get("copyfromwid") || "";

    this.title = urlParams.get("title");
    if (this.title) {
      document.title = decodeURIComponent(title);
    }
    this.subdir = "";
    try {
      signaling_socket = io(`${process.env.VUE_APP_WHITEBOARD_SERVICE_URL || process.env.VUE_APP_WHITEBOARD_URL}`, {
        path: this.subdir + "/ws-api",
      }); // Connect even if we are in a subdir behind a reverse proxy
      // signaling_socket = io("", { path: this.subdir + "/ws-api" });
    } catch (error) {
      alert(error);
    }

    signaling_socket.on("connect", async () => {
      console.log("Websocket connected!");

      signaling_socket.on("whiteboardConfig", (serverResponse) => {
        ConfigService.initFromServer(serverResponse);
        // Init whiteboard only when we have the config from the server
        $(document).ready(() => {
          this.initWhiteBoard();
        });
      });

      signaling_socket.on("whiteboardInfoUpdate", (info) => {
        InfoService.updateInfoFromServer(info);
      });

      signaling_socket.on(
        "drawToWhiteboard",
        function (content, isNewData = true) {
          whiteboard.drawToWhiteboardRemote(content, isNewData);
          InfoService.incrementNbMessagesReceived();
        }
      );

      signaling_socket.on("getSavedData", (data) => {
        console.log("contentData", data);
        this.content = data;
      });

      signaling_socket.on("refreshUserBadges", function () {
        whiteboard.refreshUserBadges();
      });

      let accessDenied = false;
      signaling_socket.on("wrongAccessToken", () => {
        if (!accessDenied) {
          accessDenied = true;
          this.showBasicAlert("Access denied! Wrong accessToken!");
        }
      });

      signaling_socket.emit("joinWhiteboard", {
        wid: whiteboardId,
        at: this.accessToken,
        windowWidthHeight: { w: $(window).width(), h: $(window).height() },
      });
    });
    await this.loadData();
    var elementList = [
      "#mouseOverlay",
      "#backgroundGrid",
      "#whiteboardCanvas",
      "#imgContainer",
    ];
    this.waitForElementsToLoad(elementList, async () => {
      await this.initializeSocket();
      const whiteboardCanvas =
        this.$refs.whiteboardContainer.querySelector("#whiteboardCanvas");
      if (whiteboardCanvas) {
        this.resizeObserver = new ResizeObserver(this.updateThumb);
        this.resizeObserver.observe(whiteboardCanvas);
      }
      $("#textContainer, #mouseOverlay").css("pointer-events", "none");

      // ✅ Detect if #imgContainer has children (e.g. <img>)
      const imgContainer =
        this.$refs.whiteboardContainer.querySelector("#imgContainer");
      if (imgContainer) {
        if (imgContainer.querySelector("img")) {
          this.pageChangeSet();
        } else {
          console.log("No image inside #imgContainer yet");
        }

        // ✅ Optional: Watch dynamically for changes
        const observer = new MutationObserver(() => {
          if (imgContainer.querySelector("img")) {
            console.log("Image found inside #imgContainer");
            this.pageChangeSet();
          } else {
            console.log("Image removed from #imgContainer");
          }
        });

        observer.observe(imgContainer, { childList: true, subtree: true });
      }
    });

    this.$nextTick(() => {
      this.$refs.video.addEventListener("loadedmetadata", this.setDuration);
      this.$refs.video.addEventListener(
        "timeupdate",
        this.throttledUpdateCurrentTime
      );
      this.$refs.audio.addEventListener("timeupdate", this.handleTimeUpdate);
      this.$refs.audio.addEventListener("loadedmetadata", this.setupSlider);
      this.updateGroupLabels();

      const container = document.getElementById("whiteboardContainer");
      const canvas = document.getElementById("whiteboardCanvas");

      let lastTouch = null;

      container.addEventListener(
        "touchstart",
        (e) => {
          if (e.touches.length >= 2) {
            lastTouch = {
              x: e.touches[0].clientX,
              y: e.touches[0].clientY,
            };
          }
        },
        { passive: false }
      );

      container.addEventListener(
        "touchmove",
        (e) => {
          if (e.touches.length >= 2 && lastTouch) {
            e.preventDefault();
            const currentTouch = e.touches[0];

            const deltaX = lastTouch.x - currentTouch.clientX;
            const deltaY = lastTouch.y - currentTouch.clientY;

            container.scrollLeft += deltaX;
            container.scrollTop += deltaY;

            lastTouch = {
              x: currentTouch.clientX,
              y: currentTouch.clientY,
            };
          }
        },
        { passive: false }
      );

      container.addEventListener("touchend", () => {
        lastTouch = null;
      });

      this.$refs.whiteboardContainer.addEventListener(
        "scroll",
        this.handleScroll
      );

      this.$refs.scrollbarThumb.addEventListener("touchstart", this.startDrag, {
        passive: false,
      });

      this.$refs.scrollbarThumbHorizontal.addEventListener(
        "touchstart",
        this.startHorizontalDrag,
        {
          passive: false,
        }
      );
    });

    this.$watch(
      () => this.$store.state.MaterialVedioObject,
      () => {
        this.getMaterialVedioObjectData();
      }
    );

    this.$watch(
      () => this.$store.state.MaterialMediaObject,
      () => {
        this.getMaterialMediaObjectData();
      }
    );

    this.$watch(
      () => this.$store.state.MaterialObject,
      () => {
        this.nextPageStatus = false;
        this.lastPageStatus = false;
        this.previousPageStatus = false;
        this.frontPageStatus = false;

        if (this.newMaterial.length > 0) {
          this.MaterialObjectData.splice(
            data[0].currentIndexGlobal,
            0,
            data[0].newMaterial
          );
        }

        $("#frontPage, #previousPage, #nextPage, #lastPage").removeAttr(
          "style"
        );
      }
    );

    this.$watch(
      () => this.fileSelectCheck,
      (value) => {
        if (this.syncInterval) clearInterval(this.syncInterval);

        let lastSentState = null;

        this.syncInterval = setInterval(() => {
          const isAudio = this.fileSelectCheck.FileType === "audio/mp3";
          const action = isAudio
            ? this.mediaPlayStatus
              ? "play"
              : "pause"
            : this.isPlay
            ? "play"
            : "pause";

          const currentTime = isAudio
            ? this.mediaCurrentDuration || 0
            : this.$refs.video.currentTime || 0;

          const state = {
            roomId: this.roomId,
            action,
            startAt: Date.now() - currentTime * 1000,
            time: currentTime,
            isShowVideoModal: this.isShowVideoModal,
            selectedMedia: this.fileSelectCheck,
          };

          // Only emit if something changed
          if (
            !lastSentState ||
            JSON.stringify(lastSentState) !== JSON.stringify(state)
          ) {
            this.socket.emit("set-sync-media-state", state);
            lastSentState = state;
          }
        }, 2000);
      }
    );

    window.addEventListener("resize", () => {
      this.resetScrollbar();
      this.zoom = 1;
      // this.updateThumb();
    });

    // iOS Autoplay Policy: 監聽用戶手勢以解鎖 AudioContext
    // 同時在第一次手勢時預建立 AudioContext，確保後續播放不會因 suspended 而無聲
    this._unlockAudio = () => {
      if (!this.audioCtx || this.audioCtx.state === "closed") {
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        if (this.speakerDeviceId && typeof this.audioCtx.setSinkId === "function") {
          this.audioCtx.setSinkId(this.speakerDeviceId).catch(() => {});
        }
        this.gainNode = null; // 待 createSource 時重建
      }
      // 不論是新建還是既有的 context，只要非 running 就在手勢上下文中 resume
      if (this.audioCtx.state !== "running") {
        this.audioCtx.resume().catch(() => {});
      }
    };
    document.addEventListener("touchstart", this._unlockAudio, { passive: true });
    document.addEventListener("click", this._unlockAudio, { passive: true });

    if (!this.teacher_full_status) {
      $(".teacher-box").removeAttr("style");
      $("#router").removeAttr("style");
    } else {
      $(".teacher-box").css({ padding: "0px 100px" });
      $("#router").css({ height: "100%", width: "100%" });
    }
  },
};
</script>

<style lang="scss" scoped>
.sketchpad {
  width: 100%;
  height: 100%;

  .sketchpad-head {
    z-index: 2;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .sketchpad-head-left {
      display: flex;
      align-items: center;

      p {
        color: #1f2937;
        font-size: 12px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }

      img {
        margin: 0 12px 0 6px;
        width: 12px;
        height: 12px;
      }

      span {
        color: #6b7280;
        font-size: 12px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .sketchpad-head-right {
      display: flex;
      align-items: center;

      div {
        margin-left: 16px;
        user-select: none;
        cursor: pointer;
        width: 24px;
        height: 24px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .sketchpad-box {
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    justify-content: space-between;

    .sketchpad-box-left {
      padding: 15px 10px;
      width: 60px;
      max-height: 100%;
      overflow: auto;
      border-radius: 8px;
      border: 1px solid #e9e9ea;
      background: #fff;
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;

      /* IE10+ */
      &::-webkit-scrollbar {
        display: none;
        /* ChromeSafari */
      }

      .left-box {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .sketchpad-box-right {
      width: calc(100% - 76px);
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      position: relative;

      .sketchpad-box-right-head {
        width: 100%;
        height: calc(100% - 58px);
        border-radius: 8px;
        border: 1px solid #e9e9ea;
        background: #fff;
      }

      .sketchpad-box-right-foo {
        padding: 0 12px;
        width: 100%;
        height: 50px;
        border-radius: 8px;
        border: 1px solid #e9e9ea;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .foo-left {
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;
          overflow: hidden;

          .foo-left-box {
            cursor: pointer;
            user-select: none;
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: #f3f4f6;
            }

            img {
              width: 16px;
              height: 16px;
            }
          }

          .foo-left-music {
            cursor: pointer;
            user-select: none;
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 16px;
              height: 16px;
            }
          }

          .foo-left-div {
            margin: 0 5px;
            min-width: 40px;
            color: #000;
            font-size: 13px;
            font-family: Microsoft JhengHei;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }

          .foo-left-select {
            flex: 0 1 180px;
            min-width: 80px;
            height: 30px;
            border-radius: 4px;
            position: relative;

            ::v-deep .el-select {
              width: 100%;
              height: 100%;

              .el-input {
                width: 100%;
                height: 100%;

                .el-input__inner {
                  padding: 5px 34px 5px 14px;
                  width: 100%;
                  height: 100%;
                  border: 1px solid rgba(0, 0, 0, 0.2);
                  color: #323130;
                  font-size: 12px;
                  font-family: Microsoft JhengHei;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                }

                .el-input__suffix {
                  display: none;
                }
              }
            }

            .foo-left-select-div {
              position: absolute;
              top: 5px;
              right: 10px;
              width: 20px;
              height: 20px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .foo-right {
          display: flex;
          align-items: center;
          flex-shrink: 0;

          .foo-media {
            display: flex;
            align-items: center;

            .foo-media-btn {
              user-select: none;
              cursor: pointer;
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;

              &:hover {
                background: #f2f2f2;
              }

              img {
                width: 24px;
                height: 24px;
              }
            }

            .foo-media-time {
              margin: 0 5px;
              color: #000;
              font-size: 14px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }

            .foo-media-slider {
              margin: 0 20px;
              width: 246px;
            }
          }

          .foo-volume {
            margin: 0 50px;
            display: flex;
            align-items: center;

            .volume-btn {
              cursor: pointer;
              user-select: none;
              width: 40px;
              height: 40px;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:hover {
                background: #f3f4f6;
              }

              img {
                width: 24px;
                height: 24px;
              }

              span {
                width: 24px;
                height: 24px;
              }
            }

            .volume-btn-show {
              display: none;
            }

            .volume-slider {
              margin-left: 10px;
              width: 130px;
            }
          }

          .foo-full {
            cursor: pointer;
            user-select: none;
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: #f3f4f6;
            }

            img {
              width: 24px;
              height: 24px;
            }
          }
        }

        @media screen and (max-width: 1880px) {
          .foo-right {
            .foo-media {
              .foo-media-slider {
                margin: 0 15px;
                width: 180px;
              }
            }

            .foo-volume {
              margin: 0 30px;

              .volume-slider {
                margin-left: 10px;
                width: 100px;
              }
            }
          }
        }

        @media screen and (max-width: 1680px) {
          .foo-right {
            .foo-media {
              .foo-media-slider {
                margin: 0 15px;
                width: 150px;
              }
            }

            .foo-volume {
              margin: 0 10px;

              .volume-btn {
                display: none;
              }

              .volume-slider {
                display: none;
              }

              .volume-btn-show {
                display: flex;
              }
            }
          }
        }

        @media screen and (max-width: 1580px) {
          .foo-right {
            .foo-media {
              .foo-media-slider {
                margin: 0 15px;
                width: 100px;
              }
            }

            .foo-volume {
              margin: 0 5px;

              .volume-btn {
                display: none;
              }

              .volume-slider {
                display: none;
              }

              .volume-btn-show {
                display: flex;
              }
            }
          }
        }
      }
    }
  }

  #hi_popup_video {
    /*.modal-16by9 {
      aspect-ratio: 16/9;
    }

    .modal-content {
      height: 100%;

      .modal-body {
        display: flex;
        align-items: center;
      }

      .footer {
        padding: var(--bs-modal-padding);
      }
    }*/

    border-radius: 8px;

    .video-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      height: 50px;
      align-items: center;
      position: absolute;
      top: 0px;
      left: 0px;
      background-color: rgba(255, 255, 255, 0.3);
      z-index: 1;
      padding: 15px 15px;

      button {
        width: 4%;
        margin: 0;
      }
    }

    .video-body {
      flex: 1;
      border-radius: 8px;
    }

    .content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .video-content {
      position: relative;
      width: 100%;
      border-radius: 8px;
      aspect-ratio: 16/9;
    }
    video {
    }
  }
}

// 全屏的樣式
.sketchpad-full {
  background: #fff;

  .sketchpad-head {
    width: auto;
    position: fixed;
    top: 10px;
    right: 20px;
  }

  .sketchpad-box {
    height: 100%;

    .sketchpad-box-left {
      position: absolute;
      top: calc(50% - 315px);
      left: 25px;
      overflow: visible;
    }

    .sketchpad-box-right {
      width: 100%;
      height: 100%;

      .sketchpad-box-right-head {
        width: 100%;
        height: 100%;
        border-radius: 0;
      }
    }
  }

  .sketchpad-full-left {
    position: fixed;
    top: 0;
    left: 0;
    width: 30px;
    height: 100vh;
  }

  .sketchpad-full-bottom {
    z-index: 10000;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 30px;
  }

  .sketchpad-full-rightTop {
    z-index: 1;
    position: fixed;
    top: 0;
    right: 0;
    width: 150px;
    height: 80px;
  }
}

.sketchpad-box-right-bottom {
  z-index: 10000;
  padding: 40px 25px 25px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 130px;

  .bottom-slider {
    width: 100%;
    height: 40px;
  }

  .bottom-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bottom-box-left {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      overflow: hidden;

      .bottom-media-time {
        margin: 0 16px;
        color: #000;
        font-size: 14px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 290;
        line-height: normal;
      }

      .bottom-media-div {
        color: #000;
        font-size: 13px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      .bottom-media-music {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .bottom-media-select {
        flex: 0 1 180px;
        min-width: 80px;
        height: 30px;
        border-radius: 4px;
        position: relative;

        ::v-deep .el-select {
          width: 100%;
          height: 100%;

          .el-input {
            width: 100%;
            height: 100%;

            .el-input__inner {
              padding: 5px 34px 5px 14px;
              width: 100%;
              height: 100%;
              border: 1px solid rgba(0, 0, 0, 0.2);
              color: #323130;
              font-size: 12px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }

        .bottom-media-select-div {
          position: absolute;
          top: 5px;
          right: 10px;
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .bottom-box-right {
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .bottom-media-volume {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .bottom-media-slider {
        margin: 0 10px;
        width: 80px;
        flex-shrink: 1;
        min-width: 50px;
      }
    }

    .bottom-media-btn {
      cursor: pointer;
      user-select: none;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: #f3f4f6;
      }

      img {
        width: 24px;
        height: 24px;
      }

      .img1 {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.video-footer {
  z-index: 2;
  padding: 15px 25px 25px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100px;
  // background-color: rgba(255, 255, 255, 0.3);

  .bottom-slider {
    padding: 0px 12px;
    width: 100%;
    height: 35px;
  }

  .bottom-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bottom-box-left {
      display: flex;
      align-items: center;

      .bottom-media-time {
        margin: 0 16px;
        color: #ffffff;
        font-size: 14px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 290;
        line-height: normal;
      }

      .bottom-media-div {
        color: #ffffff;
        font-size: 13px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      .bottom-media-music {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .bottom-media-select {
        width: 180px;
        height: 30px;
        border-radius: 4px;
        position: relative;

        ::v-deep .el-select {
          width: 100%;
          height: 100%;

          .el-input {
            width: 100%;
            height: 100%;

            .el-input__inner {
              padding: 5px 34px 5px 14px;
              width: 100%;
              height: 100%;
              border: 1px solid rgba(0, 0, 0, 0.2);
              color: #323130;
              font-size: 12px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }

        .bottom-media-select-div {
          position: absolute;
          top: 5px;
          right: 10px;
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .bottom-box-right {
      display: flex;
      align-items: center;

      .bottom-media-volume {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .bottom-media-slider {
        margin: 0 15px 0 10px;
        width: 130px;
      }
    }

    .bottom-media-btn {
      cursor: pointer;
      user-select: none;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      // &:hover {
      //   background: #f3f4f6;
      // }

      img {
        width: 24px;
        height: 24px;
      }

      .img1 {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.box-div {
  padding: 10px;
  display: flex;
  align-items: center;

  .tool-btn,
  .tool-btns {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.tool-btn {
  user-select: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  &:hover {
    background: #f2f2f2;
  }

  img {
    width: 24px;
    height: 24px;
  }

  div {
    width: 20px;
    height: 20px;
  }
}

.tool-btns {
  user-select: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: #418ef2;

  img {
    width: 24px;
    height: 24px;
  }

  div {
    width: 20px;
    height: 20px;
  }
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.blur {
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.router-full {
  height: 100%;
  width: 100%;
}

.box-imgList {
  padding: 10px;
  max-width: 370px;
  max-height: 370px;
  overflow-y: auto;

  .box-imgList-div {
    user-select: none;
    cursor: pointer;
    width: 70px;
    height: 70px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;

    &:hover {
      background: #f2f2f2;
    }

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .box-imgList-divs {
    user-select: none;
    cursor: pointer;
    width: 70px;
    height: 70px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #418ef2;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
<style>
/* 修改彈窗原生樣式 */
.sketchpad-popover {
  padding: 0 !important;
}

.sketchpad-popovers {
  min-width: 40px;
  padding: 15px 0 !important;
  display: flex;
  justify-content: center;
}

.picker_wrapper {
  height: fit-content;
  border-radius: 10px;
}

.arrow {
  stroke: #000000;
  stroke-width: 2;
  marker-end: url(#arrow);
}

.active {
  background: rgba(204, 211, 213, 0.87);
}

.textBox.active {
  border: 1px dashed gray;
}

.textBox > .removeIcon,
.textBox > .moveIcon {
  display: none;
}

.textBox.active > .removeIcon,
.textBox.active > .moveIcon {
  display: block;
}

.mobile {
  touch-action: none;
}

.clickable {
  touch-action: auto;
  pointer-events: auto;
}

.scroll-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}

/* Custom scrollbar container */
.custom-scrollbar {
  position: absolute;
  right: -14px;
  top: 0;
  height: 100%;
  width: 14px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.scrollbar-thumb {
  position: absolute;
  width: 100%;
  background-color: #888;
  border-radius: 4px;
  cursor: pointer;
}

.custom-scrollbar-horizontal {
  height: 14px;
  background: #eee;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
}

.scrollbar-thumb-horizontal {
  position: absolute;
  top: 0;
  height: 100%;
  background: #888;
  border-radius: 4px;
  cursor: pointer;
}

#whiteboardContainer {
  overflow: auto;
  -webkit-overflow-scrolling: touch; /* ensures momentum scrolling on iOS */
  touch-action: auto;
}

#whiteboardContainer::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

#whiteboardContainer::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.scrollbar-thumb:active {
  cursor: grabbing;
}

.scrollbar-thumb-horizontal:active {
  cursor: grabbing;
}

#mouseOverlay {
  touch-action: none;
}

.el-zoom-in-bottom-enter-active,
.el-zoom-in-bottom-leave-active,
.el-zoom-in-bottom-appear-active {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.el-zoom-in-bottom-enter-from,
.el-zoom-in-bottom-leave-to,
.el-zoom-in-bottom-appear-from {
  opacity: 0;
  transform: translateY(20px);
}

.el-zoom-in-bottom-enter-to,
.el-zoom-in-bottom-leave-from,
.el-zoom-in-bottom-appear-to {
  opacity: 1;
  transform: translateY(0);
}
</style>
